$wj([9],{

/***/ 1559:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(1586), exports);
//# sourceMappingURL=Label.js.map

/***/ }),

/***/ 1573:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(1576), exports);
tslib_1.__exportStar(__webpack_require__(629), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 1576:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var Utilities_1 = __webpack_require__(7);
var Spinner_types_1 = __webpack_require__(629);
var stylesImport = __webpack_require__(1577);
var styles = stylesImport;
var Spinner = /** @class */ (function (_super) {
    tslib_1.__extends(Spinner, _super);
    function Spinner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Spinner.prototype.render = function () {
        var _a = this.props, type = _a.type, size = _a.size, label = _a.label, className = _a.className, ariaLive = _a.ariaLive, ariaLabel = _a.ariaLabel; // TODO remove deprecated type property at >= 2.0.0
        var statusMessage = ariaLabel || label;
        return (React.createElement("div", { className: Utilities_1.css('ms-Spinner', styles.root, className) },
            React.createElement("div", { className: Utilities_1.css('ms-Spinner-circle', styles.circle, (_b = {},
                    _b['ms-Spinner--xSmall ' + styles.circleIsXSmall] = size === Spinner_types_1.SpinnerSize.xSmall,
                    _b['ms-Spinner--small ' + styles.circleIsSmall] = size === Spinner_types_1.SpinnerSize.small,
                    _b['ms-Spinner--medium ' + styles.circleIsMedium] = size === Spinner_types_1.SpinnerSize.medium,
                    _b['ms-Spinner--large ' + styles.circleIsLarge] = size === Spinner_types_1.SpinnerSize.large,
                    _b['ms-Spinner--normal ' + styles.circleIsTypeMedium] = type === Spinner_types_1.SpinnerType.normal,
                    _b['ms-Spinner--large ' + styles.circleIsTypeLarge] = type === Spinner_types_1.SpinnerType.large // TODO remove deprecated value at >= 2.0.0
                ,
                    _b)) }),
            label && React.createElement("div", { className: Utilities_1.css('ms-Spinner-label', styles.label) }, label),
            statusMessage &&
                React.createElement("div", { role: 'status', "aria-live": ariaLive },
                    React.createElement(Utilities_1.DelayedRender, null,
                        React.createElement("div", { className: styles.screenReaderOnly }, statusMessage)))));
        var _b;
    };
    Spinner.defaultProps = {
        size: Spinner_types_1.SpinnerSize.medium,
        ariaLive: 'polite'
    };
    return Spinner;
}(Utilities_1.BaseComponent));
exports.Spinner = Spinner;
//# sourceMappingURL=Spinner.js.map

/***/ }),

/***/ 1577:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = __webpack_require__(8);
load_themed_styles_1.loadStyles([{ "rawString": "@-webkit-keyframes spinAnimation_4865f20c{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes spinAnimation_4865f20c{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}.root_4865f20c>.circle_4865f20c{margin:auto;-webkit-box-sizing:border-box;box-sizing:border-box;border-radius:50%;width:100%;height:100%;border:1.5px solid " }, { "theme": "themeLight", "defaultValue": "#c7e0f4" }, { "rawString": ";border-top-color:" }, { "theme": "themePrimary", "defaultValue": "#0078d7" }, { "rawString": ";-webkit-animation:spinAnimation_4865f20c 1.3s infinite cubic-bezier(0.53, 0.21, 0.29, 0.67);animation:spinAnimation_4865f20c 1.3s infinite cubic-bezier(0.53, 0.21, 0.29, 0.67)}.root_4865f20c>.circle_4865f20c.circleIsXSmall_4865f20c{width:12px;height:12px}.root_4865f20c>.circle_4865f20c.circleIsSmall_4865f20c{width:16px;height:16px}.root_4865f20c>.circle_4865f20c.circleIsTypeMedium_4865f20c,.root_4865f20c>.circle_4865f20c.circleIsMedium_4865f20c{width:20px;height:20px}.root_4865f20c>.circle_4865f20c.circleIsTypeLarge_4865f20c,.root_4865f20c>.circle_4865f20c.circleIsLarge_4865f20c{width:28px;height:28px}.root_4865f20c .label_4865f20c{color:" }, { "theme": "themePrimary", "defaultValue": "#0078d7" }, { "rawString": ";margin-top:10px;text-align:center}.root_4865f20c .screenReaderOnly_4865f20c{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0, 0, 0, 0);border:0}@media screen and (-ms-high-contrast: active){.root_4865f20c>.circle_4865f20c{border-top-color:Highlight}}\n" }]);
exports.root = "root_4865f20c";
exports.circle = "circle_4865f20c";
exports.spinAnimation = "spinAnimation_4865f20c";
exports.circleIsXSmall = "circleIsXSmall_4865f20c";
exports.circleIsSmall = "circleIsSmall_4865f20c";
exports.circleIsTypeMedium = "circleIsTypeMedium_4865f20c";
exports.circleIsMedium = "circleIsMedium_4865f20c";
exports.circleIsTypeLarge = "circleIsTypeLarge_4865f20c";
exports.circleIsLarge = "circleIsLarge_4865f20c";
exports.label = "label_4865f20c";
exports.screenReaderOnly = "screenReaderOnly_4865f20c";
//# sourceMappingURL=Spinner.scss.js.map

/***/ }),

/***/ 1586:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(1587), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 1587:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var Utilities_1 = __webpack_require__(7);
var Label_classNames_1 = __webpack_require__(1588);
var Label = /** @class */ (function (_super) {
    tslib_1.__extends(Label, _super);
    function Label() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Label.prototype.render = function () {
        var _a = this.props, disabled = _a.disabled, required = _a.required, children = _a.children, className = _a.className, theme = _a.theme;
        return (React.createElement("label", tslib_1.__assign({}, Utilities_1.getNativeProps(this.props, Utilities_1.divProperties), { className: Label_classNames_1.getLabelClassNames(theme, className, !!disabled, !!required).root }), children));
    };
    Label = tslib_1.__decorate([
        Utilities_1.customizable('Label', ['theme'])
    ], Label);
    return Label;
}(Utilities_1.BaseComponent));
exports.Label = Label;
//# sourceMappingURL=Label.js.map

/***/ }),

/***/ 1588:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = __webpack_require__(7);
var Styling_1 = __webpack_require__(21);
exports.getLabelClassNames = Utilities_1.memoizeFunction(function (theme, className, disabled, required) {
    return Styling_1.mergeStyleSets({
        root: ['ms-Label',
            {
                color: theme.semanticColors.bodyText,
                boxSizing: 'border-box',
                boxShadow: 'none',
                margin: 0,
                display: 'block',
                padding: '5px 0',
                wordWrap: 'break-word',
                overflowWrap: 'break-word',
            },
            disabled && {
                color: theme.semanticColors.disabledBodyText,
                selectors: (_a = {},
                    _a[Styling_1.HighContrastSelector] = {
                        color: 'GrayText'
                    },
                    _a)
            },
            required && {
                selectors: {
                    '::after': {
                        content: "' *'",
                        color: theme.semanticColors.errorText,
                        paddingRight: 12
                    }
                }
            },
            className]
    });
    var _a;
});
//# sourceMappingURL=Label.classNames.js.map

/***/ }),

/***/ 1594:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.AriaRoles = {
    /** http://www.w3.org/TR/wai-aria/roles#alert */
    alert: 'alert',
    /** http://www.w3.org/TR/wai-aria/roles#alertdialog */
    alertdialog: 'alertdialog',
    /** http://www.w3.org/TR/wai-aria/roles#application */
    application: 'application',
    /** http://www.w3.org/TR/wai-aria/roles#article */
    article: 'article',
    /** http://www.w3.org/TR/wai-aria/roles#banner */
    banner: 'banner',
    /** http://www.w3.org/TR/wai-aria/roles#button */
    button: 'button',
    /** http://www.w3.org/TR/wai-aria/roles#checkbox */
    checkbox: 'checkbox',
    /** http://www.w3.org/TR/wai-aria/roles#columnheader */
    columnheader: 'columnheader',
    /** http://www.w3.org/TR/wai-aria/roles#combobox */
    combobox: 'combobox',
    /** http://www.w3.org/TR/wai-aria/roles#complementary */
    complementary: 'complementary',
    /** http://www.w3.org/TR/wai-aria/roles#contentinfo */
    contentinfo: 'contentinfo',
    /** http://www.w3.org/TR/wai-aria/roles#definition */
    definition: 'definition',
    /** http://www.w3.org/TR/wai-aria/roles#dialog */
    dialog: 'dialog',
    /** http://www.w3.org/TR/wai-aria/roles#directory */
    directory: 'directory',
    /** http://www.w3.org/TR/wai-aria/roles#document */
    document: 'document',
    /** http://www.w3.org/TR/wai-aria/roles#form */
    form: 'form',
    /** http://www.w3.org/TR/wai-aria/roles#grid */
    grid: 'grid',
    /** http://www.w3.org/TR/wai-aria/roles#gridcell */
    gridcell: 'gridcell',
    /** http://www.w3.org/TR/wai-aria/roles#group */
    group: 'group',
    /** http://www.w3.org/TR/wai-aria/roles#heading */
    heading: 'heading',
    /** http://www.w3.org/TR/wai-aria/roles#img */
    img: 'img',
    /** http://www.w3.org/TR/wai-aria/roles#link */
    link: 'link',
    /** http://www.w3.org/TR/wai-aria/roles#list */
    list: 'list',
    /** http://www.w3.org/TR/wai-aria/roles#listbox */
    listbox: 'listbox',
    /** http://www.w3.org/TR/wai-aria/roles#listitem */
    listitem: 'listitem',
    /** http://www.w3.org/TR/wai-aria/roles#log */
    log: 'log',
    /** http://www.w3.org/TR/wai-aria/roles#main */
    main: 'main',
    /** http://www.w3.org/TR/wai-aria/roles#marquee */
    marquee: 'marquee',
    /** http://www.w3.org/TR/wai-aria/roles#math */
    math: 'math',
    /** http://www.w3.org/TR/wai-aria/roles#menu */
    menu: 'menu',
    /** http://www.w3.org/TR/wai-aria/roles#menubar */
    menubar: 'menubar',
    /** http://www.w3.org/TR/wai-aria/roles#menuitem */
    menuitem: 'menuitem',
    /** http://www.w3.org/TR/wai-aria/roles#menuitemcheckbox */
    menuitemcheckbox: 'menuitemcheckbox',
    /** http://www.w3.org/TR/wai-aria/roles#menuitemradio */
    menuitemradio: 'menuitemradio',
    /** http://www.w3.org/TR/wai-aria/roles#navigation */
    navigation: 'navigation',
    /** http://www.w3.org/TR/wai-aria/roles#note */
    note: 'note',
    /** http://www.w3.org/TR/wai-aria/roles#option */
    option: 'option',
    /** http://www.w3.org/TR/wai-aria/roles#presentation */
    presentation: 'presentation',
    /** http://www.w3.org/TR/wai-aria/roles#progressbar */
    progressbar: 'progressbar',
    /** http://www.w3.org/TR/wai-aria/roles#radio */
    radio: 'radio',
    /** http://www.w3.org/TR/wai-aria/roles#radiogroup */
    radiogroup: 'radiogroup',
    /** http://www.w3.org/TR/wai-aria/roles#region */
    region: 'region',
    /** http://www.w3.org/TR/wai-aria/roles#row */
    row: 'row',
    /** http://www.w3.org/TR/wai-aria/roles#rowgroup */
    rowgroup: 'rowgroup',
    /** http://www.w3.org/TR/wai-aria/roles#rowheader */
    rowheader: 'rowheader',
    /** http://www.w3.org/TR/wai-aria/roles#scrollbar */
    scrollbar: 'scrollbar',
    /** http://www.w3.org/TR/wai-aria/roles#search */
    search: 'search',
    /** http://www.w3.org/TR/wai-aria/roles#separator */
    separator: 'separator',
    /** http://www.w3.org/TR/wai-aria/roles#slider */
    slider: 'slider',
    /** http://www.w3.org/TR/wai-aria/roles#spinbutton */
    spinbutton: 'spinbutton',
    /** http://www.w3.org/TR/wai-aria/roles#status */
    status: 'status',
    /** http://www.w3.org/TR/wai-aria/roles#tab */
    tab: 'tab',
    /** http://www.w3.org/TR/wai-aria/roles#tablist */
    tablist: 'tablist',
    /** http://www.w3.org/TR/wai-aria/roles#tabpanel */
    tabpanel: 'tabpanel',
    /** http://www.w3.org/TR/wai-aria/roles#textbox */
    textbox: 'textbox',
    /** http://www.w3.org/TR/wai-aria/roles#timer */
    timer: 'timer',
    /** http://www.w3.org/TR/wai-aria/roles#toolbar */
    toolbar: 'toolbar',
    /** http://www.w3.org/TR/wai-aria/roles#tooltip */
    tooltip: 'tooltip',
    /** http://www.w3.org/TR/wai-aria/roles#tree */
    tree: 'tree',
    /** http://www.w3.org/TR/wai-aria/roles#treegrid */
    treegrid: 'treegrid',
    /** http://www.w3.org/TR/wai-aria/roles#treeitem */
    treeitem: 'treeitem',
};
//# sourceMappingURL=ariaRoles.js.map

/***/ }),

/***/ 1595:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var id = 0;
function generateNewId(prefix) {
    if (prefix === void 0) { prefix = 'id'; }
    return "" + prefix + id++;
}
exports.generateNewId = generateNewId;
//# sourceMappingURL=generateNewId.js.map

/***/ }),

/***/ 1596:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function joinListOfTokens(tokens) {
    if (Array.isArray(tokens)) {
        return tokens.join(' ');
    }
    else {
        return tokens;
    }
}
function generateDomPropertiesForAria(ariaProps) {
    if (!ariaProps) {
        return null;
    }
    var domProperties = {};
    var ariaKeys = Object.keys(ariaProps);
    /* tslint:disable:no-string-literal */
    /* Can't access or assign 'aria-*' properties without string literals */
    for (var i = 0; i < ariaKeys.length; i++) {
        var key = ariaKeys[i];
        switch (key) {
            case 'role':
                domProperties['role'] = ariaProps.role;
                break;
            case 'id':
                domProperties['id'] = ariaProps.id;
                break;
            case 'activeDescendant':
                domProperties['aria-activedescendant'] = ariaProps.activeDescendant;
                break;
            case 'atomic':
                domProperties['aria-atomic'] = ariaProps.atomic;
                break;
            case 'autocomplete':
                domProperties['aria-autocomplete'] = ariaProps.autocomplete;
                break;
            case 'busy':
                domProperties['aria-busy'] = ariaProps.busy;
                break;
            case 'checked':
                domProperties['aria-checked'] = ariaProps.checked;
                break;
            case 'controls':
                domProperties['aria-controls'] = joinListOfTokens(ariaProps.controls);
                break;
            case 'describedBy':
                domProperties['aria-describedby'] = joinListOfTokens(ariaProps.describedBy);
                break;
            case 'disabled':
                domProperties['aria-disabled'] = ariaProps.disabled;
                break;
            case 'dropEffect':
                domProperties['aria-dropeffect'] = joinListOfTokens(ariaProps.dropEffect);
                break;
            case 'expanded':
                domProperties['aria-expanded'] = ariaProps.expanded;
                break;
            case 'flowTo':
                domProperties['aria-flowto'] = joinListOfTokens(ariaProps.flowTo);
                break;
            case 'grabbed':
                domProperties['aria-grabbed'] = ariaProps.grabbed;
                break;
            case 'hasPopup':
                domProperties['aria-haspopup'] = ariaProps.hasPopup;
                break;
            case 'hidden':
                domProperties['aria-hidden'] = ariaProps.hidden;
                break;
            case 'invalid':
                domProperties['aria-invalid'] = ariaProps.invalid;
                break;
            case 'label':
                domProperties['aria-label'] = ariaProps.label;
                break;
            case 'labelledBy':
                domProperties['aria-labelledby'] = joinListOfTokens(ariaProps.labelledBy);
                break;
            case 'level':
                domProperties['aria-level'] = ariaProps.level;
                break;
            case 'live':
                domProperties['aria-live'] = ariaProps.live;
                break;
            case 'multiline':
                domProperties['aria-multiline'] = ariaProps.multiline;
                break;
            case 'multiselectable':
                domProperties['aria-multiselectable'] = ariaProps.multiselectable;
                break;
            case 'orientation':
                domProperties['aria-orientation'] = ariaProps.orientation;
                break;
            case 'owns':
                domProperties['aria-owns'] = joinListOfTokens(ariaProps.owns);
                break;
            case 'positionInSet':
                domProperties['aria-posinset'] = ariaProps.positionInSet;
                break;
            case 'pressed':
                domProperties['aria-pressed'] = ariaProps.pressed;
                break;
            case 'readonly':
                domProperties['aria-readonly'] = ariaProps.readonly;
                break;
            case 'relevant':
                domProperties['aria-relevant'] = joinListOfTokens(ariaProps.relevant);
                break;
            case 'required':
                domProperties['aria-required'] = ariaProps.required;
                break;
            case 'selected':
                domProperties['aria-selected'] = ariaProps.selected;
                break;
            case 'setSize':
                domProperties['aria-setsize'] = ariaProps.setSize;
                break;
            case 'sort':
                domProperties['aria-sort'] = ariaProps.sort;
                break;
            case 'valueMax':
                domProperties['aria-valuemax'] = ariaProps.valueMax;
                break;
            case 'valueMin':
                domProperties['aria-valuemin'] = ariaProps.valueMin;
                break;
            case 'valueNow':
                domProperties['aria-valuenow'] = ariaProps.valueNow;
                break;
            case 'valueText':
                domProperties['aria-valuetext'] = ariaProps.valueText;
                break;
        }
    }
    /* tslint:enable:no-string-literal */
    return domProperties;
}
exports.generateDomPropertiesForAria = generateDomPropertiesForAria;
//# sourceMappingURL=generateDomPropertiesForAria.js.map

/***/ }),

/***/ 1741:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(1752), exports);
//# sourceMappingURL=TextField.js.map

/***/ }),

/***/ 1752:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(1753), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 1753:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var Label_1 = __webpack_require__(1559);
var Icon_1 = __webpack_require__(43);
var Utilities_1 = __webpack_require__(7);
var stylesImport = __webpack_require__(1754);
var styles = stylesImport;
var Styling_1 = __webpack_require__(21);
var TextField = /** @class */ (function (_super) {
    tslib_1.__extends(TextField, _super);
    function TextField(props) {
        var _this = _super.call(this, props) || this;
        _this._warnDeprecations({
            'iconClass': 'iconProps',
            'addonString': 'prefix',
            'onRenderAddon': 'onRenderPrefix'
        });
        _this._warnMutuallyExclusive({
            'value': 'defaultValue'
        });
        _this._id = Utilities_1.getId('TextField');
        _this._descriptionId = Utilities_1.getId('TextFieldDescription');
        _this.state = {
            value: props.value || props.defaultValue || '',
            isFocused: false,
            errorMessage: ''
        };
        _this._onInputChange = _this._onInputChange.bind(_this);
        _this._onFocus = _this._onFocus.bind(_this);
        _this._onBlur = _this._onBlur.bind(_this);
        _this._delayedValidate = _this._async.debounce(_this._validate, _this.props.deferredValidationTime);
        _this._lastValidation = 0;
        _this._isDescriptionAvailable = false;
        return _this;
    }
    Object.defineProperty(TextField.prototype, "value", {
        /**
         * Gets the current value of the text field.
         */
        get: function () {
            return this.state.value;
        },
        enumerable: true,
        configurable: true
    });
    TextField.prototype.componentDidMount = function () {
        this._isMounted = true;
        this._adjustInputHeight();
        if (this.props.validateOnLoad) {
            this._validate(this.state.value);
        }
    };
    TextField.prototype.componentWillReceiveProps = function (newProps) {
        var onBeforeChange = this.props.onBeforeChange;
        if (newProps.value !== undefined && newProps.value !== this.state.value) {
            if (onBeforeChange) {
                onBeforeChange(newProps.value);
            }
            this._latestValue = newProps.value;
            this.setState({
                value: newProps.value,
                errorMessage: ''
            });
            this._delayedValidate(newProps.value);
        }
    };
    TextField.prototype.componentWillUnmount = function () {
        this._isMounted = false;
    };
    TextField.prototype.render = function () {
        var _a = this.props, className = _a.className, description = _a.description, disabled = _a.disabled, iconClass = _a.iconClass, iconProps = _a.iconProps, multiline = _a.multiline, required = _a.required, underlined = _a.underlined, borderless = _a.borderless, addonString = _a.addonString, // @deprecated
        prefix = _a.prefix, suffix = _a.suffix, _b = _a.onRenderAddon, onRenderAddon = _b === void 0 ? this._onRenderAddon : _b, // @deprecated
        _c = _a.onRenderPrefix, // @deprecated
        onRenderPrefix = _c === void 0 ? this._onRenderPrefix : _c, _d = _a.onRenderSuffix, onRenderSuffix = _d === void 0 ? this._onRenderSuffix : _d, _e = _a.onRenderLabel, onRenderLabel = _e === void 0 ? this._onRenderLabel : _e;
        var isFocused = this.state.isFocused;
        var errorMessage = this._errorMessage;
        this._isDescriptionAvailable = Boolean(description || errorMessage);
        var renderProps = tslib_1.__assign({}, this.props, { componentId: this._id });
        var textFieldClassName = Utilities_1.css('ms-TextField', styles.root, className, (_f = {},
            _f['is-required ' + styles.rootIsRequiredLabel] = this.props.label && required,
            _f['is-required ' + styles.rootIsRequiredPlaceholderOnly] = !this.props.label && required,
            _f['is-disabled ' + styles.rootIsDisabled] = disabled,
            _f['is-active ' + styles.rootIsActive] = isFocused,
            _f['ms-TextField--multiline ' + styles.rootIsMultiline] = multiline,
            _f['ms-TextField--underlined ' + styles.rootIsUnderlined] = underlined,
            _f['ms-TextField--borderless ' + styles.rootIsBorderless] = borderless,
            _f));
        return (React.createElement("div", { className: textFieldClassName },
            React.createElement("div", { className: Utilities_1.css('ms-TextField-wrapper', styles.wrapper, underlined ? errorMessage && styles.invalid : '') },
                onRenderLabel(renderProps, this._onRenderLabel),
                React.createElement("div", { className: Utilities_1.css('ms-TextField-fieldGroup', styles.fieldGroup, isFocused && styles.fieldGroupIsFocused, errorMessage && styles.invalid) },
                    (addonString !== undefined || this.props.onRenderAddon) && (React.createElement("div", { className: Utilities_1.css('ms-TextField-prefix', styles.fieldPrefixSuffix) }, onRenderAddon(this.props, this._onRenderAddon))),
                    (prefix !== undefined || this.props.onRenderPrefix) && (React.createElement("div", { className: Utilities_1.css('ms-TextField-prefix', styles.fieldPrefixSuffix) }, onRenderPrefix(this.props, this._onRenderPrefix))),
                    multiline ? this._renderTextArea() : this._renderInput(),
                    (iconClass || iconProps) && React.createElement(Icon_1.Icon, tslib_1.__assign({ className: Utilities_1.css(iconClass, styles.icon) }, iconProps)),
                    (suffix !== undefined || this.props.onRenderSuffix) && (React.createElement("div", { className: Utilities_1.css('ms-TextField-suffix', styles.fieldPrefixSuffix) }, onRenderSuffix(this.props, this._onRenderSuffix))))),
            this._isDescriptionAvailable &&
                React.createElement("span", { id: this._descriptionId },
                    description && React.createElement("span", { className: Utilities_1.css('ms-TextField-description', styles.description) }, description),
                    errorMessage &&
                        React.createElement("div", null,
                            React.createElement(Utilities_1.DelayedRender, null,
                                React.createElement("p", { className: Utilities_1.css('ms-TextField-errorMessage', Styling_1.AnimationClassNames.slideDownIn20, styles.errorMessage) },
                                    React.createElement("span", { "aria-live": 'assertive', className: styles.errorText, "data-automation-id": 'error-message' }, errorMessage)))))));
        var _f;
    };
    /**
     * Sets focus on the text field
     */
    TextField.prototype.focus = function () {
        if (this._textElement) {
            this._textElement.focus();
        }
    };
    /**
     * Selects the text field
     */
    TextField.prototype.select = function () {
        if (this._textElement) {
            this._textElement.select();
        }
    };
    /**
     * Sets the selection start of the text field to a specified value
     */
    TextField.prototype.setSelectionStart = function (value) {
        if (this._textElement) {
            this._textElement.selectionStart = value;
        }
    };
    /**
     * Sets the selection end of the text field to a specified value
     */
    TextField.prototype.setSelectionEnd = function (value) {
        if (this._textElement) {
            this._textElement.selectionEnd = value;
        }
    };
    Object.defineProperty(TextField.prototype, "selectionStart", {
        /**
         * Gets the selection start of the text field
         */
        get: function () {
            return this._textElement ? this._textElement.selectionStart : -1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextField.prototype, "selectionEnd", {
        /**
         * Gets the selection end of the text field
         */
        get: function () {
            return this._textElement ? this._textElement.selectionEnd : -1;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Sets the start and end positions of a selection in a text field.
     * @param start Index of the start of the selection.
     * @param end Index of the end of the selection.
     */
    TextField.prototype.setSelectionRange = function (start, end) {
        if (this._textElement) {
            this._textElement.setSelectionRange(start, end);
        }
    };
    TextField.prototype._onFocus = function (ev) {
        if (this.props.onFocus) {
            this.props.onFocus(ev);
        }
        this.setState({ isFocused: true });
        if (this.props.validateOnFocusIn) {
            this._validate(this.state.value);
        }
    };
    TextField.prototype._onBlur = function (ev) {
        if (this.props.onBlur) {
            this.props.onBlur(ev);
        }
        this.setState({ isFocused: false });
        if (this.props.validateOnFocusOut) {
            this._validate(this.state.value);
        }
    };
    TextField.prototype._onRenderLabel = function (props) {
        var label = props.label, componentId = props.componentId;
        if (label) {
            return (React.createElement(Label_1.Label, { htmlFor: componentId }, label));
        }
        return null;
    };
    // @deprecated
    TextField.prototype._onRenderAddon = function (props) {
        var addonString = props.addonString;
        return (React.createElement("span", { style: { paddingBottom: '1px' } }, addonString));
    };
    TextField.prototype._onRenderPrefix = function (props) {
        var prefix = props.prefix;
        return (React.createElement("span", { style: { paddingBottom: '1px' } }, prefix));
    };
    TextField.prototype._onRenderSuffix = function (props) {
        var suffix = props.suffix;
        return (React.createElement("span", { style: { paddingBottom: '1px' } }, suffix));
    };
    TextField.prototype._getTextElementClassName = function () {
        var textFieldClassName;
        if (this.props.multiline && !this.props.resizable) {
            textFieldClassName = Utilities_1.css('ms-TextField-field ms-TextField-field--unresizable', styles.field, styles.fieldIsUnresizable);
        }
        else {
            textFieldClassName = Utilities_1.css('ms-TextField-field', styles.field);
        }
        return Utilities_1.css(textFieldClassName, this.props.inputClassName, (_a = {},
            _a[styles.hasIcon] = !!this.props.iconClass,
            _a));
        var _a;
    };
    Object.defineProperty(TextField.prototype, "_errorMessage", {
        get: function () {
            var errorMessage = this.state.errorMessage;
            if (!errorMessage) {
                errorMessage = this.props.errorMessage;
            }
            return errorMessage;
        },
        enumerable: true,
        configurable: true
    });
    TextField.prototype._renderTextArea = function () {
        var textAreaProps = Utilities_1.getNativeProps(this.props, Utilities_1.textAreaProperties, ['defaultValue']);
        return (React.createElement("textarea", tslib_1.__assign({ id: this._id }, textAreaProps, { ref: this._resolveRef('_textElement'), value: this.state.value, onInput: this._onInputChange, onChange: this._onInputChange, className: this._getTextElementClassName(), "aria-describedby": this._isDescriptionAvailable ? this._descriptionId : null, "aria-invalid": !!this.state.errorMessage, "aria-label": this.props.ariaLabel, onFocus: this._onFocus, onBlur: this._onBlur })));
    };
    TextField.prototype._renderInput = function () {
        var inputProps = Utilities_1.getNativeProps(this.props, Utilities_1.inputProperties, ['defaultValue']);
        return (React.createElement("input", tslib_1.__assign({ type: 'text', id: this._id }, inputProps, { ref: this._resolveRef('_textElement'), value: this.state.value, onInput: this._onInputChange, onChange: this._onInputChange, className: this._getTextElementClassName(), "aria-label": this.props.ariaLabel, "aria-describedby": this._isDescriptionAvailable ? this._descriptionId : null, "aria-invalid": !!this.state.errorMessage, onFocus: this._onFocus, onBlur: this._onBlur })));
    };
    TextField.prototype._onInputChange = function (event) {
        var _this = this;
        var element = event.target;
        var value = element.value;
        // Avoid doing unnecessary work when the value has not changed.
        if (value === this._latestValue) {
            return;
        }
        this._latestValue = value;
        this.setState({
            value: value,
            errorMessage: ''
        }, function () {
            _this._adjustInputHeight();
            if (_this.props.onChanged) {
                _this.props.onChanged(value);
            }
        });
        var _a = this.props, validateOnFocusIn = _a.validateOnFocusIn, validateOnFocusOut = _a.validateOnFocusOut;
        if (!(validateOnFocusIn || validateOnFocusOut)) {
            this._delayedValidate(value);
        }
        var onBeforeChange = this.props.onBeforeChange;
        onBeforeChange(value);
    };
    TextField.prototype._validate = function (value) {
        var _this = this;
        // In case of _validate called multi-times during executing validate logic with promise return.
        if (this._latestValidateValue === value) {
            return;
        }
        this._latestValidateValue = value;
        var onGetErrorMessage = this.props.onGetErrorMessage;
        var result = onGetErrorMessage(value || '');
        if (result !== undefined) {
            if (typeof result === 'string') {
                this.setState({
                    errorMessage: result
                });
                this._notifyAfterValidate(value, result);
            }
            else {
                var currentValidation_1 = ++this._lastValidation;
                result.then(function (errorMessage) {
                    if (_this._isMounted && currentValidation_1 === _this._lastValidation) {
                        _this.setState({ errorMessage: errorMessage });
                    }
                    _this._notifyAfterValidate(value, errorMessage);
                });
            }
        }
        else {
            this._notifyAfterValidate(value, '');
        }
    };
    TextField.prototype._notifyAfterValidate = function (value, errorMessage) {
        if (this._isMounted &&
            value === this.state.value &&
            this.props.onNotifyValidationResult) {
            this.props.onNotifyValidationResult(errorMessage, value);
        }
    };
    TextField.prototype._adjustInputHeight = function () {
        if (this._textElement && this.props.autoAdjustHeight && this.props.multiline) {
            var textField = this._textElement;
            textField.style.height = '';
            var scrollHeight = textField.scrollHeight + 2; // +2 to avoid vertical scroll bars
            textField.style.height = scrollHeight + 'px';
        }
    };
    TextField.defaultProps = {
        multiline: false,
        resizable: true,
        autoAdjustHeight: false,
        underlined: false,
        borderless: false,
        onChanged: function () { },
        onBeforeChange: function () { },
        onNotifyValidationResult: function () { },
        onGetErrorMessage: function () { return undefined; },
        deferredValidationTime: 200,
        errorMessage: '',
        validateOnFocusIn: false,
        validateOnFocusOut: false,
        validateOnLoad: true,
    };
    return TextField;
}(Utilities_1.BaseComponent));
exports.TextField = TextField;
//# sourceMappingURL=TextField.js.map

/***/ }),

/***/ 1754:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = __webpack_require__(8);
load_themed_styles_1.loadStyles([{ "rawString": ".root_5c753ca1{-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-box-shadow:none;box-shadow:none;margin:0;padding:0;position:relative}.screenReaderOnly_5c753ca1{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0, 0, 0, 0);border:0}.fieldGroup_5c753ca1{-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-box-shadow:none;box-shadow:none;margin:0;padding:0;border:1px solid " }, { "theme": "inputBorder", "defaultValue": "#a6a6a6" }, { "rawString": ";background:" }, { "theme": "bodyBackground", "defaultValue": "#ffffff" }, { "rawString": ";height:32px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;position:relative}.fieldGroup_5c753ca1:hover{border-color:" }, { "theme": "inputBorderHovered", "defaultValue": "#212121" }, { "rawString": "}.fieldGroup_5c753ca1.fieldGroupIsFocused_5c753ca1{border-color:" }, { "theme": "inputFocusBorderAlt", "defaultValue": "#0078d7" }, { "rawString": "}.rootIsDisabled_5c753ca1 .fieldGroup_5c753ca1{background-color:" }, { "theme": "disabledBackground", "defaultValue": "#f4f4f4" }, { "rawString": ";border-color:" }, { "theme": "disabledBackground", "defaultValue": "#f4f4f4" }, { "rawString": ";pointer-events:none;cursor:default}@media screen and (-ms-high-contrast: active){.fieldGroup_5c753ca1:hover,.fieldGroup_5c753ca1.fieldGroupIsFocused_5c753ca1{border-color:Highlight}}.fieldGroup_5c753ca1::-ms-clear{display:none}.root_5c753ca1.rootIsDisabled_5c753ca1 .field{background-color:" }, { "theme": "disabledBackground", "defaultValue": "#f4f4f4" }, { "rawString": ";border-color:" }, { "theme": "disabledBackground", "defaultValue": "#f4f4f4" }, { "rawString": ";pointer-events:none;cursor:default}.fieldPrefixSuffix_5c753ca1{background:" }, { "theme": "neutralLighter", "defaultValue": "#f4f4f4" }, { "rawString": ";color:" }, { "theme": "neutralSecondary", "defaultValue": "#666666" }, { "rawString": ";display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:0 10px;line-height:1}.field_5c753ca1{-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-box-shadow:none;box-shadow:none;margin:0;padding:0;font-size:14px;border-radius:0;border:none;background:none;color:" }, { "theme": "bodyText", "defaultValue": "#333333" }, { "rawString": ";padding:0 12px 0 12px;width:100%;text-overflow:ellipsis;outline:0}[dir='rtl'] .field_5c753ca1{padding:0 12px 0 12px}.field_5c753ca1:active,.field_5c753ca1:focus,.field_5c753ca1:hover{outline:0}[dir='ltr'] .field_5c753ca1.hasIcon_5c753ca1{padding-right:24px}[dir='rtl'] .field_5c753ca1.hasIcon_5c753ca1{padding-left:24px}.field_5c753ca1[disabled]{background-color:transparent;border-color:transparent;pointer-events:none;cursor:default}.field_5c753ca1 .field_5c753ca1::-webkit-input-placeholder{color:" }, { "theme": "disabledText", "defaultValue": "#a6a6a6" }, { "rawString": "}.field_5c753ca1 .field_5c753ca1:-ms-input-placeholder{color:" }, { "theme": "disabledText", "defaultValue": "#a6a6a6" }, { "rawString": "}.field_5c753ca1 .field_5c753ca1::-ms-input-placeholder{color:" }, { "theme": "disabledText", "defaultValue": "#a6a6a6" }, { "rawString": "}.field .field::-webkit-input-placeholder{color:" }, { "theme": "disabledText", "defaultValue": "#a6a6a6" }, { "rawString": "}.field .field:-ms-input-placeholder{color:" }, { "theme": "disabledText", "defaultValue": "#a6a6a6" }, { "rawString": "}.field .field::-ms-input-placeholder{color:" }, { "theme": "disabledText", "defaultValue": "#a6a6a6" }, { "rawString": "}.field_5c753ca1 .field_5c753ca1::placeholder{color:" }, { "theme": "disabledText", "defaultValue": "#a6a6a6" }, { "rawString": "}.root_5c753ca1.rootIsRequiredLabel_5c753ca1 .ms-Label::after{content:' *';color:" }, { "theme": "error", "defaultValue": "#a80000" }, { "rawString": "}.root_5c753ca1.rootIsRequiredPlaceholderOnly_5c753ca1 .ms-TextField-fieldGroup::after{content:'*';color:" }, { "theme": "error", "defaultValue": "#a80000" }, { "rawString": ";position:absolute;top:-5px}[dir='ltr'] .root_5c753ca1.rootIsRequiredPlaceholderOnly_5c753ca1 .ms-TextField-fieldGroup::after{right:-10px}[dir='rtl'] .root_5c753ca1.rootIsRequiredPlaceholderOnly_5c753ca1 .ms-TextField-fieldGroup::after{left:-10px}.root_5c753ca1.rootIsActive_5c753ca1{border-color:" }, { "theme": "inputFocusBorderAlt", "defaultValue": "#0078d7" }, { "rawString": "}.icon_5c753ca1{pointer-events:none;position:absolute;bottom:5px;top:auto;font-size:16px;line-height:18px}html[dir='ltr'] .icon_5c753ca1{right:8px}html[dir='rtl'] .icon_5c753ca1{left:8px}.description_5c753ca1{color:" }, { "theme": "bodySubtext", "defaultValue": "#666666" }, { "rawString": ";font-size:11px}.rootIsBorderless_5c753ca1 .fieldGroup_5c753ca1{border-color:transparent;border-width:0}.root_5c753ca1.rootIsUnderlined_5c753ca1{border-width:0px}.root_5c753ca1.rootIsUnderlined_5c753ca1:hover:not(.rootIsDisabled_5c753ca1){border-color:" }, { "theme": "inputBorderHovered", "defaultValue": "#212121" }, { "rawString": "}@media screen and (-ms-high-contrast: active){.root_5c753ca1.rootIsUnderlined_5c753ca1:hover:not(.rootIsDisabled_5c753ca1){border-color:Highlight}}.root_5c753ca1.rootIsUnderlined_5c753ca1 .wrapper_5c753ca1{display:-webkit-box;display:-ms-flexbox;display:flex;border-bottom:1px solid " }, { "theme": "inputBorder", "defaultValue": "#a6a6a6" }, { "rawString": ";width:100%}.root_5c753ca1.rootIsUnderlined_5c753ca1 .wrapper_5c753ca1.invalid_5c753ca1,.root_5c753ca1.rootIsUnderlined_5c753ca1 .wrapper_5c753ca1.invalid_5c753ca1:focus,.root_5c753ca1.rootIsUnderlined_5c753ca1 .wrapper_5c753ca1.invalid_5c753ca1:hover{border-bottom:1px solid " }, { "theme": "errorText", "defaultValue": "#a80000" }, { "rawString": "}.root_5c753ca1.rootIsUnderlined_5c753ca1 .ms-Label{font-size:14px;line-height:22px;height:32px}[dir='ltr'] .root_5c753ca1.rootIsUnderlined_5c753ca1 .ms-Label{margin-right:8px}[dir='rtl'] .root_5c753ca1.rootIsUnderlined_5c753ca1 .ms-Label{margin-left:8px}[dir='ltr'] .root_5c753ca1.rootIsUnderlined_5c753ca1 .ms-Label{padding-left:12px}[dir='rtl'] .root_5c753ca1.rootIsUnderlined_5c753ca1 .ms-Label{padding-right:12px}.root_5c753ca1.rootIsUnderlined_5c753ca1 .fieldGroup_5c753ca1{-webkit-box-flex:1;-ms-flex:1 1 0px;flex:1 1 0px;border-width:0}[dir='ltr'] .root_5c753ca1.rootIsUnderlined_5c753ca1 .fieldGroup_5c753ca1{text-align:left}[dir='rtl'] .root_5c753ca1.rootIsUnderlined_5c753ca1 .fieldGroup_5c753ca1{text-align:right}.root_5c753ca1.rootIsUnderlined_5c753ca1.rootIsDisabled_5c753ca1{border-bottom-color:" }, { "theme": "disabledBackground", "defaultValue": "#f4f4f4" }, { "rawString": "}.root_5c753ca1.rootIsUnderlined_5c753ca1.rootIsDisabled_5c753ca1 .ms-Label{color:" }, { "theme": "neutralTertiary", "defaultValue": "#a6a6a6" }, { "rawString": "}.root_5c753ca1.rootIsUnderlined_5c753ca1.rootIsDisabled_5c753ca1 .field_5c753ca1{background-color:transparent;color:" }, { "theme": "disabledText", "defaultValue": "#a6a6a6" }, { "rawString": "}.root_5c753ca1.rootIsUnderlined_5c753ca1.rootIsDisabled_5c753ca1 .fieldGroup_5c753ca1{background-color:transparent}.root_5c753ca1.rootIsUnderlined_5c753ca1.rootIsActive_5c753ca1{border-color:" }, { "theme": "inputFocusBorderAlt", "defaultValue": "#0078d7" }, { "rawString": "}@media screen and (-ms-high-contrast: active){.root_5c753ca1.rootIsUnderlined_5c753ca1.rootIsActive_5c753ca1{border-color:Highlight}}.root_5c753ca1.rootIsMultiline_5c753ca1 .fieldGroup_5c753ca1{min-height:60px;height:auto;display:-webkit-box;display:-ms-flexbox;display:flex}.root_5c753ca1.rootIsMultiline_5c753ca1 .field_5c753ca1{line-height:17px;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;padding-top:6px;overflow:auto;width:100%}[dir='ltr'] .root_5c753ca1.rootIsMultiline_5c753ca1 .field_5c753ca1.hasIcon_5c753ca1{padding-right:40px}[dir='rtl'] .root_5c753ca1.rootIsMultiline_5c753ca1 .field_5c753ca1.hasIcon_5c753ca1{padding-left:40px}.errorMessage_5c753ca1{font-size:12px;font-weight:400;color:" }, { "theme": "errorText", "defaultValue": "#a80000" }, { "rawString": ";margin:0;padding-top:5px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.invalid_5c753ca1,.invalid_5c753ca1:focus,.invalid_5c753ca1:hover{border-color:" }, { "theme": "errorText", "defaultValue": "#a80000" }, { "rawString": "}[dir='ltr'] .root_5c753ca1.rootIsUnderlined_5c753ca1 .ms-Label{padding-left:12px}[dir='rtl'] .root_5c753ca1.rootIsUnderlined_5c753ca1 .ms-Label{padding-right:12px}[dir='ltr'] .root_5c753ca1.rootIsUnderlined_5c753ca1 .ms-Label{padding-right:0}[dir='rtl'] .root_5c753ca1.rootIsUnderlined_5c753ca1 .ms-Label{padding-left:0}html[dir='ltr'] .root_5c753ca1.rootIsUnderlined_5c753ca1 .field_5c753ca1{text-align:left}html[dir='rtl'] .root_5c753ca1.rootIsUnderlined_5c753ca1 .field_5c753ca1{text-align:right}.root_5c753ca1.rootIsMultiline_5c753ca1 .icon_5c753ca1{padding-bottom:8px;-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}[dir='ltr'] .root_5c753ca1.rootIsMultiline_5c753ca1 .icon_5c753ca1{padding-right:24px}[dir='rtl'] .root_5c753ca1.rootIsMultiline_5c753ca1 .icon_5c753ca1{padding-left:24px}.root_5c753ca1.rootIsMultiline_5c753ca1 .field_5c753ca1.fieldIsUnresizable_5c753ca1{resize:none}.hidden_5c753ca1{display:none}\n" }]);
exports.root = "root_5c753ca1";
exports.screenReaderOnly = "screenReaderOnly_5c753ca1";
exports.fieldGroup = "fieldGroup_5c753ca1";
exports.fieldGroupIsFocused = "fieldGroupIsFocused_5c753ca1";
exports.rootIsDisabled = "rootIsDisabled_5c753ca1";
exports.fieldPrefixSuffix = "fieldPrefixSuffix_5c753ca1";
exports.field = "field_5c753ca1";
exports.hasIcon = "hasIcon_5c753ca1";
exports.rootIsRequiredLabel = "rootIsRequiredLabel_5c753ca1";
exports.rootIsRequiredPlaceholderOnly = "rootIsRequiredPlaceholderOnly_5c753ca1";
exports.rootIsActive = "rootIsActive_5c753ca1";
exports.icon = "icon_5c753ca1";
exports.description = "description_5c753ca1";
exports.rootIsBorderless = "rootIsBorderless_5c753ca1";
exports.rootIsUnderlined = "rootIsUnderlined_5c753ca1";
exports.wrapper = "wrapper_5c753ca1";
exports.invalid = "invalid_5c753ca1";
exports.rootIsMultiline = "rootIsMultiline_5c753ca1";
exports.errorMessage = "errorMessage_5c753ca1";
exports.fieldIsUnresizable = "fieldIsUnresizable_5c753ca1";
exports.hidden = "hidden_5c753ca1";
//# sourceMappingURL=TextField.scss.js.map

/***/ }),

/***/ 1809:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var index_1 = __webpack_require__(20);
var keys = ['doneText', 'addRemoveTimezonesText', 'timezonesSearchHintText', 'localTimeText', 'timeZoneText', 'todayStringLowerCaseText', 'allDayDurationText', 'cancelLowerCaseText', 'previousMonthText', 'nextMonthText', 'selectDateAriaLabelText', 'cancelMeetingText', 'closeText', 'deleteEventConfirmationTitleText', 'deleteSeriesConfirmationTitleText', 'deleteEventConfirmationSubText', 'deleteEventSeriesConfirmationSubText', 'calendarModuleNameText', 'newCalendarEventText', 'calendarEllipsisAriaLabelText', 'calendarsAreNotAvailable', 'tryAgainByRefreshingBrowser', 'calendarLoadingEvents', 'calendarText', 'myCalendarsText', 'otherCalendarsText', 'peoplesCalendarsText', 'selectedCalendarText', 'notSelectedCalendarText', 'failedCreateCalendarGroupText', 'failedDeleteCalendarGroupText', 'failedCreateCalendarText', 'failedDeleteCalendarText', 'failedRenameCalendarText', 'failedRenameCalendarGroupText', 'failedSetCalendarColorText', 'failedUpdateCalendarText', 'open', 'openOccurrence', 'openSeries', 'charm', 'freeBusyItemSelectedScreenReaderText', 'freeBusyItemNotSelectedScreenReaderText', 'lightBlueCalendarColorText', 'lightGreenCalendarColorText', 'redCalendarColorText', 'darkBlueCalendarColorText', 'yellowCalendarColorText', 'tealCalendarColorText', 'lightPinkCalendarColorText', 'brownCalendarColorText', 'darkPinkCalendarColorText', 'blueCalendarColorText', 'greenCalendarColorText', 'indigoCalendarColorText', 'grayCalendarColorText', 'pinkCalendarColorText', 'orangeCalendarColorText', 'violetCalendarColorText', 'charmsCatAriaText', 'charmsDogAriaText', 'charmsPlaneAriaText', 'charmsCalculatorAriaText', 'charmsMedicalAriaText', 'charmsTrophyAriaText', 'charmsHouseAriaText', 'charmsMedicineAriaText', 'charmsBriefcaseAriaText', 'charmsCoffeeAriaText', 'charmsPeopleAriaText', 'charmsStopwatchAriaText', 'charmsMusicAriaText', 'charmsShoppingAriaText', 'charmsCarAriaText', 'charmsStarAriaText', 'charmsNoteAriaText', 'charmsPersonAriaText', 'charmsBalloonsAriaText', 'charmsForkAndKnifeAriaText', 'charmsHeartAriaText', 'charmsSoccerBallAriaText', 'charmsFilmAriaText', 'charmsChartAriaText', 'charmsBooksAriaText', 'charmsCakeAriaText', 'charmsTvPanelAriaText', 'charmsTravelAriaText', 'charmsPackageDeliveryAriaText', 'charmsPromotionAriaText', 'charmsEventAriaText', 'charmsHotelAriaText', 'sundayAbbreviated', 'mondayAbbreviated', 'tuesdayAbbreviated', 'wednesdayAbbreviated', 'thursdayAbbreviated', 'fridayAbbreviated', 'saturdayAbbreviated', 'organizerInvitedYou', 'youAreOrganizer', 'eventPartOfSeries', 'noResponseReceivedAttendeesLabelAndCount', 'declinedAttendeesLabelAndCount', 'tentativelyAcceptedAttendeesLabelAndCount', 'acceptedAttendeesLabelAndCount', 'acceptedTime', 'tenativelyAcceptedTime', 'cancelledTime', 'edit', 'cancel', 'cancelError', 'thisEvent', 'allEventsInSeries', 'editorPlaceholderText', 'cancelEdit', 'cancelSendNow', 'cancelEditorText', 'cancelOccurrenceEditorText', 'cancelSeriesEditorText', 'delete', 'createError', 'deleteError', 'updateError', 'removeFromCalendar', 'removeSeriesFromCalendar', 'respondWithMessage', 'sendResponseNow', 'noSendResponse', 'cancelWithMessage', 'cancelNow', 'responseEditorWatermark', 'sendButtonString', 'discardButtonString', 'openItemButtonAriaLabel', 'acceptButtonText', 'acceptButtonAriaLabel', 'tentativeButtonText', 'tentativeButtonAriaLabel', 'declineButtonText', 'declineButtonAriaLabel', 'itemDeleteConfirmationDescriptionText', 'itemCancelConfirmationDescriptionText', 'itemDeleteConfirmationBackText', 'acceptedButtonLabel', 'tentativeButtonLabel', 'declineButtonLabel', 'acceptEvent', 'tentativelyAcceptEvent', 'declineEvent', 'acceptEventAndAddMessage', 'tentativelyAcceptEventAndAddMessage', 'declineEventAndAddMessage', 'acceptOccurrenceAndAddMessage', 'tentativelyAcceptOccurrenceAndAddMessage', 'declineOccurrenceAndAddMessage', 'acceptSeriesAndAddMessage', 'tentativelyAcceptSeriesAndAddMessage', 'declineSeriesAndAddMessage', 'addLocationText', 'addToCalendarText', 'durationDay', 'durationFirstPluralDays', 'durationSecondGenitivePluralDays', 'durationHour', 'durationFirstPluralHours', 'durationSecondGenitivePluralHours', 'reminderDay', 'reminderSingularHour', 'reminderSingularWeek', 'reminderFirstPluralHours', 'reminderSecondGenitivePluralHours', 'reminderFirstPluralMin', 'reminderSecondGenitiveMin', 'reminderBefore', 'reminderAfter', 'reminderDayOfEvent', 'reminderDayBeforeEvent', 'reminderWeekBeforeEvent', 'addToCalendar', 'allDay', 'atTimeOfEvent', 'custom', 'remindMe', 'repeat', 'noReminder', 'repeatNever', 'repeatNeverAriaText', 'repeatDaily', 'repeatWeekly', 'repeatMonthly', 'repeatYearly', 'recurrenceDropdownAriaText', 'repeatsWithEndAriaPlaceHolder', 'repeatsWithoutEndPlaceHolder', 'occursPlaceHolder', 'occursAriaPlaceHolder', 'occursUntilPlaceHolder', 'occursUntilAriaPlaceHolder', 'chooseEndDateLabel', 'save', 'discard', 'moreDetails', 'durationLabel', 'startTimeLabel', 'endTimeLabel', 'timeOptionsLabel', 'startDateLabel', 'endDateLabel', 'subjectDetailsLabel', 'selectEventCharmLabel', 'selectEventCalendarLabel', 'infoMessageEditOccurrence', 'infoMessageEditSeries', 'toText', 'changeRecurrenceConfirmationTitleText', 'changeRecurrenceSubText', 'titlePlaceholderText', 'goToTodayStringLowerCaseText', 'switchToDayText', 'switchToWeekText', 'switchToMonthText', 'goToPreviousDayStringLowerCaseText', 'goToNextDayStringLowerCaseText', 'goToPreviousWeekStringLowerCaseText', 'goToNextWeekStringLowerCaseText', 'goToPreviousMonthStringLowerCaseText', 'goToNextMonthStringLowerCaseText', 'goToPreviousYearStringLowerCaseText', 'goToNextYearStringLowerCaseText', 'am', 'pm', 'newCalendarString', 'newCalendarGroupString', 'renameCalendarGroupString', 'deleteCalendarGroupString', 'renameCalendarString', 'removeCalendarString', 'changeCalendarColorString', 'automaticColorString', 'toggleLeftPaneAriaLabel', 'eventLocationAriaText', 'eventOrganizerAriaText', 'eventDescriptionAriaText', 'allDayEventDescriptionAriaText', 'singleDayEventDescriptionAriaText', 'whenStartEndsSameDayLongAriaText', 'whenStartEndsDifferentDayLongAriaText', 'whenStartEndsDifferentDayDateOnlyLongAriaText', 'surfaceItemRecurrenceIconTitle', 'surfaceItemRecurrenceExceptionIconTitle', 'surfaceItemAttachmentIconTitle', 'surfaceItemPrivateIconTitle', 'leftRailRegionName', 'commandBarRegionName', 'newEventSkipLinkName', 'miniMonthRegionName', 'calendarPickerRegionName', 'surfaceCommandBarRegionName', 'timestripRegionName', 'calendarSurfaceRegionName', 'eventsLoadedLiveNotification', 'DiscoverCalendarsText', 'AddAndDiscoverCalendarsText', 'PoweredByText', 'BingText', 'PopularCalendarsText', 'PopularText', 'AddCalendarErrorText', 'RemoveCalendarErrorText', 'GetInterestingCalendarsErrorText', 'DataFromText', 'HolidaysText', 'AddCalendarText', 'FromFileText', 'FromWebText', 'ICErrorText', 'HolidaysErrorText', 'CancelText', 'ImportFromFileText', 'ImportFromWebText', 'ImportEventsText', 'ChooseICSFileText', 'ImportToText', 'BrowseText', 'ImportText', 'ImportingText', 'NoFileSelectedText', 'ICSFileTooLargeText', 'ICSFileErrorText', 'ImportedText', 'SubscribeOnlineText', 'LinkToCalendarText', 'LinkToCalendarPlaceholderText', 'CalendarNameText', 'CalendarNamePlaceholderText', 'WebcalSuccessText', 'WebcalSubscriptionExistsText', 'WebcalUrlErrorText', 'addALocationText', 'suggestedLocationsText', 'useThisLocationText', 'findLocationInfo_Searching', 'findLocationInfo_NoMatchFound', 'findLocationInfo_Loading', 'resolvedLocationAriaLabel', 'multipleLocationsFoundAriaLabel', 'locationSelectedAriaLabel', 'locationCardInformationLabel', 'locationCardMapLabel', 'attendeeWellTitle', 'sortByString', 'sortByDisplayName', 'sortByStatus', 'sortByOrderAdded', 'organizer', 'noResponseStatus', 'acceptedStatus', 'declinedStatus', 'tentativeStatus', 'showAsDropDownTitle', 'showAsFree', 'showAsWorkingElsewhere', 'showAsTentative', 'showAsBusy', 'showAsAway', 'reminderDropDownTitle', 'meetingFormEllipsisAriaLabelText', 'privateControlAltText', 'privateControlHoverTextForPrivate', 'privateControlHoverTextForNonPrivate', 'infobarCannotEditPublicMeeting', 'infobarCancelledMeeting', 'infobarEventInPast', 'infobarNoResponseRequested', 'infobarNoResponseReuqestedOrganizer', 'infobarAcceptedByUser', 'infobarAcceptedByDelegate', 'infobarTentativelyAcceptedByUser', 'infobarTentativelyAcceptedByDelegate', 'infobarDeclinedByUser', 'infobarDeclinedByDelegate', 'infobarViewSeries', 'noLocationText'];
var stringModule = index_1.registerStringPackage('owa-calendar-strings', null, keys);
var exportedObject = {
    stringsModule: stringModule,
};
keys.forEach(function (key) {
    Object.defineProperty(exportedObject, key, { get: function () { return stringModule.strings.get(key); } });
});
exports.default = exportedObject;


/***/ }),

/***/ 1887:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Txp_1 = __webpack_require__(3265);
exports.Txp = Txp_1.default;
var TxpWrapper_1 = __webpack_require__(4208);
exports.TxpWrapper = TxpWrapper_1.default;
var TxpPeekWrapper_1 = __webpack_require__(4253);
exports.TxpPeekWrapper = TxpPeekWrapper_1.default;
//# sourceMappingURL=lazyIndex.js.map

/***/ }),

/***/ 2623:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
var initialUserVoiceNpsState = {
    npsSurveyBody: '',
    npsSurveyRatings: '',
    isRatingSelected: false,
    isSent: false,
};
var initialUserVoiceSuggestionState = {
    message: '',
    isMessageEnabled: false,
    isSent: false,
};
exports.userVoiceNpsStore = satcheljs_1.createStore('UserVoiceNpsStore', initialUserVoiceNpsState)();
exports.userVoiceSuggestionStore = satcheljs_1.createStore('UserVoiceSuggestionStore', initialUserVoiceSuggestionState)();
//# sourceMappingURL=store.js.map

/***/ }),

/***/ 2627:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var isNullOrWhiteSpace_1 = __webpack_require__(2676);
exports.isNullOrWhiteSpace = isNullOrWhiteSpace_1.isNullOrWhiteSpace;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2676:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Checks if a given string is null, empty, or consists only of white-space characters.
 * @param text: the string to check
 */
function isNullOrWhiteSpace(text) {
    return text == null || text.trim().length == 0;
}
exports.isNullOrWhiteSpace = isNullOrWhiteSpace;
//# sourceMappingURL=isNullOrWhiteSpace.js.map

/***/ }),

/***/ 2703:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var index_1 = __webpack_require__(20);
var keys = ['flightBusStopLabelText', 'flightBusStopFirstLineFormatText', 'flightBusStopSummaryFormatText', 'flightBusStopSummaryWithDurationFormatText', 'flightSummaryFirstLine', 'flightSummarySecondLine', 'flightSummaryThirdLine', 'terminalText', 'gateText', 'terminalGateText', 'seatText', 'parcelDeliveryFirstLine', 'parcelDeliverySecondLine', 'deliveryTextRange', 'deliveryText', 'trackingText', 'hotelCheckInText', 'reservationText', 'hotelCheckOutText', 'checkInSuffixText', 'checkOutSuffixText', 'reservationCodeText', 'codeText', 'carText', 'dropOffText', 'pickUpText', 'pickUpSuffixText', 'dropOffSuffixText', 'reportAnIssueText', 'feedbackUsefulText', 'feedbackNotUsefulText', 'userVoiceFeedbackText', 'positiveTicketPopUpBodyText', 'negativeTicketPopUpBodyText', 'negativeTicketPopUpBodyHtmlText', 'negativeTicketPopUpDonateEmailText', 'negativeTicketPopUpEmailUseText', 'positiveTicketPopUpHeaderText', 'negativeTicketPopUpHeaderText', 'foundNewEventsText', 'foundNewEventSingularText', 'flightDepartureArrivalAriaText', 'flightBusStopAriaText', 'trackPackageButtonText', 'packageText', 'modifyReservationText', 'checkinText', 'viewCalendarText'];
var stringModule = index_1.registerStringPackage('owa-txp-strings', null, keys);
var exportedObject = {
    stringsModule: stringModule,
};
keys.forEach(function (key) {
    Object.defineProperty(exportedObject, key, { get: function () { return stringModule.strings.get(key); } });
});
exports.default = exportedObject;


/***/ }),

/***/ 2734:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var EntityType;
(function (EntityType) {
    /**
     * Event
     */
    EntityType[EntityType["EventReservation"] = 0] = "EventReservation";
    /**
     * Flight
     */
    EntityType[EntityType["FlightReservation"] = 1] = "FlightReservation";
    /**
     * Food
     */
    EntityType[EntityType["FoodReservation"] = 2] = "FoodReservation";
    /**
     * Invoice
     */
    EntityType[EntityType["Invoice"] = 3] = "Invoice";
    /**
     * Hotel
     */
    EntityType[EntityType["LodgingReservation"] = 4] = "LodgingReservation";
    /**
     * Parcel Delivery
     */
    EntityType[EntityType["ParcelDelivery"] = 5] = "ParcelDelivery";
    /**
     * Rental car
     */
    EntityType[EntityType["RentalCarReservation"] = 6] = "RentalCarReservation";
})(EntityType || (EntityType = {}));
exports.default = EntityType;
//# sourceMappingURL=EntityType.js.map

/***/ }),

/***/ 2735:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.NotApplicable = 'N/A';
exports.Empty = '';
exports.CheckError = 'CheckErrorDetails';
exports.ReactNpsClientName = 'React/Nps';
exports.NpsLogDatapointId = 'UVNpsRating';
exports.FeedbackTitle = '';
exports.FeedbackLogDatapointId = 'UVFeedback';
exports.ReactFeedbackClientName = 'React/Feedback';
function GetSurveyNumber(isFirstSurvey) {
    return isFirstSurvey ? '1' : '2';
}
exports.GetSurveyNumber = GetSurveyNumber;
//# sourceMappingURL=UserVoiceConstants.js.map

/***/ }),

/***/ 2747:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ActivityType;
(function (ActivityType) {
    /**
     * indicator for Txp Activity
     */
    ActivityType[ActivityType["TxpActivity"] = 0] = "TxpActivity";
    /**
     * Dining activity type
     */
    ActivityType[ActivityType["Dining"] = 1] = "Dining";
    /**
     * Event activity type
     */
    ActivityType[ActivityType["EventActivityType"] = 2] = "EventActivityType";
    /**
     * Flight Departure activity type
     */
    ActivityType[ActivityType["FlightDeparture"] = 3] = "FlightDeparture";
    /**
     * Hotel checkin activity type
     */
    ActivityType[ActivityType["HotelCheckin"] = 4] = "HotelCheckin";
    /**
     * Hotel checkout activity type
     */
    ActivityType[ActivityType["HotelCheckout"] = 5] = "HotelCheckout";
    /**
     * Invoice activity type
     */
    ActivityType[ActivityType["Invoice"] = 6] = "Invoice";
    /**
     * Parcel Delivery activity type
     */
    ActivityType[ActivityType["ParcelDelivery"] = 7] = "ParcelDelivery";
    /**
     * Rental car pick up activity type
     */
    ActivityType[ActivityType["RentalCarPickup"] = 8] = "RentalCarPickup";
    /**
     * Rental car drop off activity type
     */
    ActivityType[ActivityType["RentalCarDropOff"] = 9] = "RentalCarDropOff";
})(ActivityType || (ActivityType = {}));
exports.default = ActivityType;
//# sourceMappingURL=ActivityType.js.map

/***/ }),

/***/ 2748:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(4168);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 2749:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServiceRequest_1 = __webpack_require__(27);
var datapoint_1 = __webpack_require__(2812);
function logDatapointOperation(req, options) {
    if (req.datapoints !== undefined) {
        for (var i = 0; i < req.datapoints.length; i++) {
            if (req.datapoints[i] !== undefined && !req.datapoints[i]["__type"]) {
                req.datapoints[i] = datapoint_1.default(req.datapoints[i]);
            }
        }
    }
    return ServiceRequest_1.makeServiceRequest("LogDatapoint", req, options);
}
exports.default = logDatapointOperation;


/***/ }),

/***/ 2775:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServiceRequest_1 = __webpack_require__(27);
function getOwaNonBootUserConfigurationOperation(options) {
    return ServiceRequest_1.makeServiceRequest("GetOwaNonBootUserConfiguration", {}, options);
}
exports.default = getOwaNonBootUserConfigurationOperation;


/***/ }),

/***/ 2811:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ExpandingCardMode;
(function (ExpandingCardMode) {
    /**
     * To have top compact card only
     */
    ExpandingCardMode[ExpandingCardMode["compact"] = 0] = "compact";
    /**
     * To have both top compact and bottom expanded card
     */
    ExpandingCardMode[ExpandingCardMode["expanded"] = 1] = "expanded";
})(ExpandingCardMode = exports.ExpandingCardMode || (exports.ExpandingCardMode = {}));
var OpenCardMode;
(function (OpenCardMode) {
    /**
     * Open card by hover
     */
    OpenCardMode[OpenCardMode["hover"] = 0] = "hover";
    /**
     * Open card by hot key
     */
    OpenCardMode[OpenCardMode["hotKey"] = 1] = "hotKey";
})(OpenCardMode = exports.OpenCardMode || (exports.OpenCardMode = {}));
//# sourceMappingURL=ExpandingCard.types.js.map

/***/ }),

/***/ 2812:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function datapoint(data) {
    var result = tslib_1.__assign({ __type: 'Datapoint:#Exchange' }, data);
    return result;
}
exports.default = datapoint;


/***/ }),

/***/ 2914:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var resetUserVoiceSuggestion_1 = __webpack_require__(2992);
var UserVoiceSuggestion_1 = __webpack_require__(2993);
var store_1 = __webpack_require__(2623);
var postSuggestionAndSendLogDatapoint_1 = __webpack_require__(2999);
var owa_confirm_dialog_1 = __webpack_require__(223);
var owa_common_strings_1 = __webpack_require__(37);
var React = __webpack_require__(3);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.action('showUserVoiceSuggestionDialog')(function showUserVoiceSuggestionDialog(options) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var isConsentForm, blurb;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    isConsentForm = options.ewsId !== undefined;
                    blurb = null;
                    if (!options.blurbElement) {
                        blurb = options.blurb ? options.blurb : owa_common_strings_1.default.userVoiceExplanation;
                    }
                    return [4 /*yield*/, owa_confirm_dialog_1.confirm(options.header ? options.header : owa_common_strings_1.default.userVoiceSendFeedbackTitle, blurb, false, {
                            bodyElement: (React.createElement(UserVoiceSuggestion_1.default, { isConsentForm: isConsentForm, blurbElement: options.blurbElement })),
                            preventSoftDismiss: false,
                            okText: owa_common_strings_1.default.userVoiceFeedbackSendButton,
                            cancelText: owa_common_strings_1.default.userVoiceFeedbackDiscardButton,
                            focusOnCancel: isConsentForm,
                        }).then(function (response) {
                            if (response === 0 /* ok */) {
                                postSuggestionAndSendLogDatapoint_1.default(options.title, store_1.userVoiceSuggestionStore.message, options.feedbackType, options.ewsId, options.customTags, [], null, options.userVoiceForumId);
                            }
                            resetUserVoiceSuggestion_1.default();
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=showUserVoiceSuggestionDialog.js.map

/***/ }),

/***/ 2915:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var owa_bundling_1 = __webpack_require__(6);
var owa_delayed_initialization_1 = __webpack_require__(28);
var store_1 = __webpack_require__(2916);
exports.userVoiceSettingsStore = store_1.userVoiceSettingsStore;
var lazyModule = new owa_bundling_1.LazyModule(function () {
    return __webpack_require__.e/* import() */(103).then(__webpack_require__.bind(null, 3276));
});
// Side effects
exports.lazyGetUserVoiceData = new owa_bundling_1.LazyImport(lazyModule, function (m) { return m.getUserVoiceData; });
owa_delayed_initialization_1.runAfterInitialRender(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, exports.lazyGetUserVoiceData.import()];
            case 1:
                (_a.sent())();
                return [2 /*return*/];
        }
    });
}); });
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2916:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
var initialUserVoiceSettings = {
    userVoiceId: '',
    owaUrl: '',
    onlineBookingUrl: '',
    userCulture: '',
    whenMailboxCreated: '',
    isConsumer: true,
    owaVersion: '',
    userDisplayName: '',
    country: '',
    mailboxGuid: '',
};
exports.userVoiceSettingsStore = satcheljs_1.createStore('UserVoiceSettings', initialUserVoiceSettings)();
//# sourceMappingURL=store.js.map

/***/ }),

/***/ 2988:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getLocalFieldsOrder_1 = __webpack_require__(4172);
var owa_string_utils_1 = __webpack_require__(2627);
var CommaSeparator = ', ';
/**
 * Returns a string representaion of the postal address.
 * @param field1, field2, field3, field4, field5: the fields in the postal address. theu can be null or empty.
 * @param divider: the separator between the address fiends
 */
function computeAddress(field1, field2, field3, field4, field5, divider) {
    var address = [];
    // Field1 is in the first line
    if (!owa_string_utils_1.isNullOrWhiteSpace(field1)) {
        address[address.length] = field1;
    }
    // Field2, Field3 and Field4 are all in the second line
    var row2 = '';
    if (!owa_string_utils_1.isNullOrWhiteSpace(field2)) {
        row2 = field2;
    }
    if (!owa_string_utils_1.isNullOrWhiteSpace(field3)) {
        if (owa_string_utils_1.isNullOrWhiteSpace(row2)) {
            row2 = field3;
        }
        else {
            row2 = row2 + divider + field3;
        }
    }
    // (n-1)th field
    if (!owa_string_utils_1.isNullOrWhiteSpace(field4)) {
        if (owa_string_utils_1.isNullOrWhiteSpace(row2)) {
            row2 = field4;
        }
        else {
            row2 = row2 + divider + field4;
        }
    }
    if (!owa_string_utils_1.isNullOrWhiteSpace(row2)) {
        address[address.length] = row2;
    }
    // Last Field
    if (!owa_string_utils_1.isNullOrWhiteSpace(field5)) {
        address[address.length] = field5;
    }
    return address;
}
/**
 * Gets the display text from the location postal address
 * @param postalAddress: the location postal address
 */
function getLocalizedAddress(postalAddress) {
    var displayAddress = '';
    if (postalAddress) {
        var fieldsOrder = getLocalFieldsOrder_1.default();
        var address = [];
        var divider = CommaSeparator;
        switch (fieldsOrder) {
            case 'a_c_pc_pr_ctry':
                address = computeAddress(postalAddress.Street, postalAddress.City, postalAddress.PostalCode, postalAddress.State, postalAddress.Country, divider);
                break;
            case 'a_c_pr_ctry_pc':
                address = computeAddress(postalAddress.Street, postalAddress.City, postalAddress.State, postalAddress.Country, postalAddress.PostalCode, divider);
                break;
            case 'a_c_pr_pc_ctry':
                address = computeAddress(postalAddress.Street, postalAddress.City, postalAddress.State, postalAddress.PostalCode, postalAddress.Country, divider);
                break;
            case 'a_ctry_c_pr_pc':
                address = computeAddress(postalAddress.Street, postalAddress.Country, postalAddress.City, postalAddress.State, postalAddress.PostalCode, divider);
                break;
            case 'a_pc_c_pr_ctry':
                address = computeAddress(postalAddress.Street, postalAddress.PostalCode, postalAddress.City, postalAddress.State, postalAddress.Country, divider);
                break;
            case 'a_pc_pr_c_ctry':
                address = computeAddress(postalAddress.Street, postalAddress.PostalCode, postalAddress.State, postalAddress.City, postalAddress.Country, divider);
                break;
            case 'c_a_pc_pr_ctry':
                address = computeAddress(postalAddress.City, postalAddress.Street, postalAddress.PostalCode, postalAddress.State, postalAddress.Country, divider);
                break;
            case 'ctry_pc_pr_c_a':
                address = computeAddress(postalAddress.Country, postalAddress.PostalCode, postalAddress.State, postalAddress.City, postalAddress.Street, divider);
                break;
            case 'ctry_pr_c_pc_a':
                address = computeAddress(postalAddress.Country, postalAddress.State, postalAddress.City, postalAddress.PostalCode, postalAddress.Street, divider);
                break;
            case 'pc_ctry_pr_c_a':
                address = computeAddress(postalAddress.PostalCode, postalAddress.Country, postalAddress.State, postalAddress.City, postalAddress.Street, divider);
                break;
            case 'pc_pr_c_a_ctry':
                address = computeAddress(postalAddress.PostalCode, postalAddress.State, postalAddress.City, postalAddress.Street, postalAddress.Country, divider);
                break;
        }
        displayAddress = address.join(divider);
    }
    return displayAddress;
}
exports.getLocalizedAddress = getLocalizedAddress;
//# sourceMappingURL=getLocalizedAddress.js.map

/***/ }),

/***/ 2989:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
/* tslint:disable:no-unused-variable */
var React = __webpack_require__(3);
/* tslint:enable:no-unused-variable */
var Utilities_1 = __webpack_require__(7);
var ExpandingCard_types_1 = __webpack_require__(2811);
var Callout_1 = __webpack_require__(157);
var Styling_1 = __webpack_require__(21);
var FocusTrapZone_1 = __webpack_require__(3145);
var ExpandingCard_styles_1 = __webpack_require__(3270);
var ExpandingCard = /** @class */ (function (_super) {
    tslib_1.__extends(ExpandingCard, _super);
    function ExpandingCard(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            firstFrameRendered: false,
            needsScroll: false
        };
        return _this;
    }
    ExpandingCard.prototype.componentDidMount = function () {
        if (this._expandedElem && this._expandedElem.scrollHeight >= this.props.expandedCardHeight) {
            this.setState({
                needsScroll: true
            });
        }
        if (this.props.trapFocus) {
            this._events.on(this._expandingCard, 'keydown', this._onDismiss);
        }
    };
    ExpandingCard.prototype.componentWillUnmount = function () {
        this._async.dispose();
    };
    ExpandingCard.prototype.render = function () {
        var _a = this.props, targetElement = _a.targetElement, theme = _a.theme, customStyles = _a.styles, compactCardHeight = _a.compactCardHeight, directionalHintFixed = _a.directionalHintFixed, firstFocus = _a.firstFocus, expandedCardHeight = _a.expandedCardHeight;
        this._styles = ExpandingCard_styles_1.getStyles(theme, customStyles);
        var content = (React.createElement("div", { ref: this._resolveRef('_expandingCard'), onMouseEnter: this.props.onEnter, onMouseLeave: this.props.onLeave },
            this._onRenderCompactCard(),
            this._onRenderExpandedCard()));
        return (React.createElement(Callout_1.Callout, tslib_1.__assign({}, Utilities_1.getNativeProps(this.props, Utilities_1.divProperties), { componentRef: this._resolveRef('_callout'), className: Styling_1.mergeStyles(Styling_1.AnimationStyles.scaleUpIn100, this._styles.root), target: targetElement, isBeakVisible: false, directionalHint: this.props.directionalHint, directionalHintFixed: directionalHintFixed, finalHeight: compactCardHeight + expandedCardHeight, minPagePadding: 24, onDismiss: this.props.onLeave, gapSpace: this.props.gapSpace }), this.props.trapFocus ?
            React.createElement(FocusTrapZone_1.FocusTrapZone, { forceFocusInsideTrap: false, isClickableOutsideFocusTrap: true, disableFirstFocus: !firstFocus }, content) :
            content));
    };
    ExpandingCard.prototype._onDismiss = function (ev) {
        if (ev.type === 'keydown' && (ev.which !== 27 /* escape */)) {
            return;
        }
        else {
            this.props.onLeave && this.props.onLeave(ev);
        }
    };
    ExpandingCard.prototype._onRenderCompactCard = function () {
        return (React.createElement("div", { className: Styling_1.mergeStyles(this._styles.compactCard, { height: this.props.compactCardHeight + 'px' }) }, this.props.onRenderCompactCard(this.props.renderData)));
    };
    ExpandingCard.prototype._onRenderExpandedCard = function () {
        var _this = this;
        // firstFrameRendered helps in initially setting height of expanded card to 1px, even if
        // mode prop is set to ExpandingCardMode.expanded on first render. This is to make sure transition animation takes place.
        !this.state.firstFrameRendered && this._async.requestAnimationFrame(function () {
            _this.setState({
                firstFrameRendered: true
            });
        });
        return (React.createElement("div", { className: Styling_1.mergeStyles(this._styles.expandedCard, this.props.mode === ExpandingCard_types_1.ExpandingCardMode.expanded && this.state.firstFrameRendered && { height: this.props.expandedCardHeight + 'px' }, this.state.needsScroll && { overflowY: 'auto' }), ref: this._resolveRef('_expandedElem') },
            React.createElement("div", { className: this._styles.expandedCardScroll }, this.props.onRenderExpandedCard && this.props.onRenderExpandedCard(this.props.renderData))));
    };
    ExpandingCard.prototype._checkNeedsScroll = function () {
        var _this = this;
        if (this._expandedElem) {
            this._async.requestAnimationFrame(function () {
                if (_this._expandedElem.scrollHeight >= _this.props.expandedCardHeight) {
                    _this.setState({
                        needsScroll: true
                    });
                }
            });
        }
    };
    ExpandingCard.defaultProps = {
        compactCardHeight: 156,
        expandedCardHeight: 384,
        directionalHint: 4 /* bottomLeftEdge */,
        directionalHintFixed: true,
        gapSpace: 0
    };
    tslib_1.__decorate([
        Utilities_1.autobind
    ], ExpandingCard.prototype, "_onDismiss", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], ExpandingCard.prototype, "_onRenderCompactCard", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], ExpandingCard.prototype, "_onRenderExpandedCard", null);
    tslib_1.__decorate([
        Utilities_1.autobind
        // tslint:disable-next-line:no-unused-variable
    ], ExpandingCard.prototype, "_checkNeedsScroll", null);
    ExpandingCard = tslib_1.__decorate([
        Utilities_1.customizable('ExpandingCard', ['theme'])
    ], ExpandingCard);
    return ExpandingCard;
}(Utilities_1.BaseComponent));
exports.ExpandingCard = ExpandingCard;
//# sourceMappingURL=ExpandingCard.js.map

/***/ }),

/***/ 2990:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var datesAreEqual = __webpack_require__(708);
var startOfDay = __webpack_require__(64);
var owa_datetime_1 = __webpack_require__(207);
// This method doesn't show the time part of dateTimeToParse if it's at midnight.
// So this shouldn't be used for scenarios like Flight cards.
function convertDateTimeToString(dateTimeToParse, isAccessible) {
    var dateTimeString = '';
    // Is there a time part to this date? i.e. Is time at midnight?
    var midnight = owa_datetime_1.assumeDisplayDate(startOfDay(dateTimeToParse));
    var midnightDisplayDate = owa_datetime_1.assumeDisplayDate(midnight);
    if (datesAreEqual(midnight, dateTimeToParse)) {
        // If the parsed time occurs at midnight the server is indicating that the input time doesn't have a time part.
        // In that case we should only show the date part.
        if (!isAccessible) {
            dateTimeString = owa_datetime_1.formatWeekDayDate(midnightDisplayDate);
        }
        else {
            dateTimeString = owa_datetime_1.formatWeekDayMonthDayYear(midnightDisplayDate);
        }
    }
    else {
        if (!isAccessible) {
            dateTimeString = owa_datetime_1.formatWeekDayDateTime(owa_datetime_1.parseIsoDate(dateTimeToParse));
        }
        else {
            dateTimeString = owa_datetime_1.formatMonthDayShortTime(owa_datetime_1.parseIsoDate(dateTimeToParse));
        }
    }
    return dateTimeString;
}
exports.default = convertDateTimeToString;
//# sourceMappingURL=convertDateTimeToString.js.map

/***/ }),

/***/ 2991:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_bundling_1 = __webpack_require__(6);
var showUserVoiceSuggestionDialog_1 = __webpack_require__(2914);
exports.showUserVoiceSuggestionDialog = showUserVoiceSuggestionDialog_1.default;
var lazyModule = new owa_bundling_1.LazyModule(function () {
    return __webpack_require__.e/* import() */(89).then(__webpack_require__.bind(null, 3277));
});
exports.UserVoiceNps = owa_bundling_1.createLazyComponent(lazyModule, function (m) { return m.UserVoiceNps; });
exports.lazyShowUserVoiceSuggestionDialog = new owa_bundling_1.LazyAction(lazyModule, function (m) { return m.showUserVoiceSuggestionDialog; });
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2992:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2623);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.action('resetUserVoiceSuggestion')(legacy_1.select({
    store: function () { return store_1.userVoiceSuggestionStore; },
})(function resetUserVoiceSuggestion(state) {
    state.store.message = '';
    state.store.isMessageEnabled = false;
    state.store.isSent = false;
}));
//# sourceMappingURL=resetUserVoiceSuggestion.js.map

/***/ }),

/***/ 2993:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var UserVoiceSuggestionForm_1 = __webpack_require__(2994);
var setUserVoiceSuggestionMessage_1 = __webpack_require__(2997);
var setUserVoiceSuggestionEnableMessage_1 = __webpack_require__(2998);
var mobx_react_1 = __webpack_require__(11);
var React = __webpack_require__(3);
var store_1 = __webpack_require__(2623);
var UserVoiceSuggestion = /** @class */ (function (_super) {
    tslib_1.__extends(UserVoiceSuggestion, _super);
    function UserVoiceSuggestion() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChangeMessage = function (message) {
            setUserVoiceSuggestionMessage_1.default(message);
        };
        _this.onChangeEnableMessage = function (enabled) {
            setUserVoiceSuggestionEnableMessage_1.default(enabled);
        };
        return _this;
    }
    UserVoiceSuggestion.prototype.render = function () {
        var message = store_1.userVoiceSuggestionStore.message, isMessageEnabled = store_1.userVoiceSuggestionStore.isMessageEnabled;
        return (React.createElement(UserVoiceSuggestionForm_1.default, { onChangeMessage: this.onChangeMessage, onChangeEnableMessage: this.onChangeEnableMessage, message: message, isConsentForm: this.props.isConsentForm, isMessageEnabled: isMessageEnabled, blurbElement: this.props.blurbElement }));
    };
    UserVoiceSuggestion = tslib_1.__decorate([
        mobx_react_1.observer
    ], UserVoiceSuggestion);
    return UserVoiceSuggestion;
}(React.Component));
exports.default = UserVoiceSuggestion;
//# sourceMappingURL=UserVoiceSuggestion.js.map

/***/ }),

/***/ 2994:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var mobx_react_1 = __webpack_require__(11);
var Button_1 = __webpack_require__(62);
var TextField_1 = __webpack_require__(1741);
var React = __webpack_require__(3);
var owa_common_strings_1 = __webpack_require__(37);
var styles = __webpack_require__(2995);
var UserVoiceSuggestionForm = /** @class */ (function (_super) {
    tslib_1.__extends(UserVoiceSuggestionForm, _super);
    function UserVoiceSuggestionForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onEnableMessage = function () {
            _this.props.onChangeEnableMessage(true);
        };
        return _this;
    }
    UserVoiceSuggestionForm.prototype.render = function () {
        return (React.createElement("div", null,
            this.props.blurbElement,
            this.props.isConsentForm && !this.props.isMessageEnabled
                ? React.createElement(Button_1.Button, { buttonType: Button_1.ButtonType.command, className: styles.addDescription, onClick: this.onEnableMessage }, owa_common_strings_1.default.userVoiceFeedbackButtonTitle)
                : null,
            !this.props.isConsentForm || this.props.isMessageEnabled
                ? React.createElement(TextField_1.TextField, { multiline: true, value: this.props.message, className: styles.suggestion, onChanged: this.props.onChangeMessage, placeholder: owa_common_strings_1.default.userVoiceFeedbackPlaceholder })
                : null));
    };
    UserVoiceSuggestionForm = tslib_1.__decorate([
        mobx_react_1.observer
    ], UserVoiceSuggestionForm);
    return UserVoiceSuggestionForm;
}(React.Component));
exports.default = UserVoiceSuggestionForm;
//# sourceMappingURL=UserVoiceSuggestionForm.js.map

/***/ }),

/***/ 2995:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(2996);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 2996:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, "._3tRThdODpCeEaoeB4KGMr4{font-size:14px;font-weight:400;font-weight:300}._23B_y9QvG9MJ9KCwf1uN9L{font-size:12px;font-weight:400;font-weight:300;line-height:1.5}html[dir] ._23B_y9QvG9MJ9KCwf1uN9L{margin-bottom:10px}._2QxSYZQQX8tKwmnr9x5ZRl{width:100%;color:\"[theme:themePrimary, default:#0078D7]\"}html[dir] ._2QxSYZQQX8tKwmnr9x5ZRl{margin-bottom:10px}html[dir=ltr] ._2QxSYZQQX8tKwmnr9x5ZRl{padding-left:0}html[dir=rtl] ._2QxSYZQQX8tKwmnr9x5ZRl{padding-right:0}html[dir=ltr] ._2QxSYZQQX8tKwmnr9x5ZRl div{margin-left:0}html[dir=rtl] ._2QxSYZQQX8tKwmnr9x5ZRl div{margin-right:0}._2CI_r7G-IpB_6wvE13e6oB::-webkit-input-placeholder{font-size:14px;font-weight:400;font-weight:100}._2CI_r7G-IpB_6wvE13e6oB:-ms-input-placeholder{font-size:14px;font-weight:400;font-weight:100}._2CI_r7G-IpB_6wvE13e6oB::placeholder{font-size:14px;font-weight:400;font-weight:100}", ""]);

// exports
exports.locals = {
	"bodyText": "_3tRThdODpCeEaoeB4KGMr4",
	"blurb": "_23B_y9QvG9MJ9KCwf1uN9L",
	"addDescription": "_2QxSYZQQX8tKwmnr9x5ZRl",
	"suggestion": "_2CI_r7G-IpB_6wvE13e6oB"
};

/***/ }),

/***/ 2997:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2623);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.action('setUserVoiceSuggestionMessage')(legacy_1.select({
    store: function () { return store_1.userVoiceSuggestionStore; },
})(function setUserVoiceSuggestionMessage(message, state) {
    state.store.message = message;
}));
//# sourceMappingURL=setUserVoiceSuggestionMessage.js.map

/***/ }),

/***/ 2998:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2623);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.action('setUserVoiceSuggestionEnableMessage')(legacy_1.select({
    store: function () { return store_1.userVoiceSuggestionStore; },
})(function setUserVoiceSuggestionEnableMessage(enable, state) {
    state.store.isMessageEnabled = enable;
}));
//# sourceMappingURL=setUserVoiceSuggestionEnableMessage.js.map

/***/ }),

/***/ 2999:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var sendSuggestionLogDatapoint_1 = __webpack_require__(3000);
var UserVoiceConstants = __webpack_require__(2735);
var owa_analytics_1 = __webpack_require__(12);
var getOwaNonBootUserConfigurationOperation_1 = __webpack_require__(2775);
var postNewUserVoiceSuggestionOperation_1 = __webpack_require__(3001);
var owa_uservoicedata_1 = __webpack_require__(2915);
function postSuggestionAndSendLogDatapoint(title, message, feedbackType, ewsId, customTags, attachments, feedbackSentiment, forumId) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var feedbackCustomTags, suggestion, suggestionResponse, errorMessage_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, owa_uservoicedata_1.lazyGetUserVoiceData.import()];
                case 1: 
                // Fetch the promise from UserVoiceData package which ensures that the settings are fetched in advance
                // And if post nps operation occurs during the GetUserVoiceData fetch operation
                // It will wait at the promise to finish.
                return [4 /*yield*/, (_a.sent())()];
                case 2:
                    // Fetch the promise from UserVoiceData package which ensures that the settings are fetched in advance
                    // And if post nps operation occurs during the GetUserVoiceData fetch operation
                    // It will wait at the promise to finish.
                    _a.sent();
                    feedbackCustomTags = customTags ? convertCustomTags(customTags) : [];
                    suggestion = {
                        Title: title,
                        Message: message.length > 0 ? message : UserVoiceConstants.NotApplicable,
                        Type: feedbackType,
                        EwsId: ewsId,
                        TicketCustomFields: feedbackCustomTags,
                        UserLocation: owa_uservoicedata_1.userVoiceSettingsStore.country,
                        MailBoxGuid: owa_uservoicedata_1.userVoiceSettingsStore.mailboxGuid,
                        Attachments: attachments,
                        FeedbackSentiment: feedbackSentiment ? feedbackSentiment : UserVoiceConstants.NotApplicable,
                        ForumId: forumId,
                    };
                    _a.label = 3;
                case 3:
                    _a.trys.push([3, 6, , 8]);
                    return [4 /*yield*/, postNewUserVoiceSuggestionOperation_1.default(suggestion)];
                case 4:
                    suggestionResponse = _a.sent();
                    return [4 /*yield*/, getOwaNonBootConfigAndLog(suggestion, suggestionResponse, UserVoiceConstants.Empty)];
                case 5:
                    _a.sent();
                    return [3 /*break*/, 8];
                case 6:
                    errorMessage_1 = _a.sent();
                    return [4 /*yield*/, getOwaNonBootConfigAndLog(suggestion, null, errorMessage_1)];
                case 7:
                    _a.sent();
                    return [3 /*break*/, 8];
                case 8: return [2 /*return*/];
            }
        });
    });
}
exports.default = postSuggestionAndSendLogDatapoint;
function convertCustomTags(tags) {
    return Object.keys(tags).map(function (key) {
        return {
            Name: key,
            Value: tags[key],
        };
    });
}
function getOwaNonBootConfigAndLog(suggestion, response, error) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var suggestionId, stampStatus, owaUserConfig, licenseInfo, errorMessage_2;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    suggestionId = response ? response.PostedSuggestionId : UserVoiceConstants.CheckError;
                    stampStatus = response ? response.StampStatus : UserVoiceConstants.CheckError;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 6]);
                    return [4 /*yield*/, getOwaNonBootUserConfigurationOperation_1.default()];
                case 2:
                    owaUserConfig = _a.sent();
                    licenseInfo = owaUserConfig.ConsumerSubscriptions
                        ? owaUserConfig.ConsumerSubscriptions.join(',')
                        : UserVoiceConstants.Empty;
                    return [4 /*yield*/, logUsageAndSendDatapoint(suggestion, suggestionId, stampStatus, error, licenseInfo)];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 6];
                case 4:
                    errorMessage_2 = _a.sent();
                    return [4 /*yield*/, logUsageAndSendDatapoint(suggestion, suggestionId, stampStatus, error, UserVoiceConstants.CheckError)];
                case 5:
                    _a.sent();
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    });
}
function logUsageAndSendDatapoint(suggestion, suggestionId, stampStatus, error, licenseInfo) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var attachmentNames;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    attachmentNames = suggestion.Attachments
                        ? suggestion.Attachments
                            .map(function (attachment) {
                            return attachment.Name;
                        })
                            .join(' | ')
                        : '';
                    // Aria Log usage
                    return [4 /*yield*/, owa_analytics_1.logUsage(UserVoiceConstants.FeedbackLogDatapointId, [
                            suggestionId,
                            suggestion.Title,
                            suggestion.Message,
                            mapFeedbackTypeToName(suggestion.Type),
                            attachmentNames,
                            suggestion.MailBoxGuid,
                            suggestion.EwsId,
                            suggestion.UserLocation,
                            stampStatus,
                            error,
                            licenseInfo,
                            UserVoiceConstants.ReactFeedbackClientName,
                        ])];
                case 1:
                    // Aria Log usage
                    _a.sent();
                    // Suggestion Send Log Datapoint
                    return [4 /*yield*/, sendSuggestionLogDatapoint_1.sendSuggestionLogDatapoint({
                            id: suggestionId,
                            title: suggestion.Title,
                            message: suggestion.Message,
                            type: mapFeedbackTypeToName(suggestion.Type),
                            attachmentName: attachmentNames,
                            mailboxGuid: suggestion.MailBoxGuid,
                            ewsId: suggestion.EwsId,
                            userLocation: suggestion.UserLocation,
                            propsStampStatus: stampStatus,
                            error: error,
                            licenseInfo: licenseInfo,
                            forumId: suggestion.ForumId,
                        })];
                case 2:
                    // Suggestion Send Log Datapoint
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
function mapFeedbackTypeToName(type) {
    switch (type) {
        case 0 /* Feedback */:
            return 'Feedback';
        case 1 /* TailoredExperiences */:
            return 'TailoredExperiences';
        case 2 /* Bookings */:
            return 'Bookings';
        case 3 /* Hashtag */:
            return 'Hashtag';
        case 4 /* Clutter */:
            return 'Clutter';
        case 5 /* Schedules */:
            return 'Schedules';
        default:
            return 'Feedback';
    }
}
//# sourceMappingURL=postSuggestionAndSendLogDatapoint.js.map

/***/ }),

/***/ 3000:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var logDatapointOperation_1 = __webpack_require__(2749);
var UserVoiceConstants = __webpack_require__(2735);
function sendSuggestionLogDatapoint(datapointProps) {
    var keys = [
        'fbid',
        'fbt',
        'fbm',
        'fbtp',
        'fbl',
        'fbe',
        'fba',
        'fbmbg',
        'fbeid',
        'fbul',
        'fbss',
        'fbfid',
    ];
    var values = [
        datapointProps.id,
        datapointProps.title,
        datapointProps.message,
        datapointProps.type,
        datapointProps.licenseInfo,
        datapointProps.error,
        datapointProps.attachmentName,
        datapointProps.mailboxGuid,
        datapointProps.ewsId ? datapointProps.ewsId : UserVoiceConstants.NotApplicable,
        datapointProps.userLocation,
        datapointProps.propsStampStatus,
        datapointProps.forumId !== undefined ? datapointProps.forumId.toString() : '0',
    ];
    var feedbackLogDatapoint = {
        Id: UserVoiceConstants.FeedbackLogDatapointId,
        Consumers: 1 /* Analytics */,
        Time: new Date(Date.now()).toString(),
        Keys: keys,
        Values: values,
    };
    return logDatapointOperation_1.default({ datapoints: [feedbackLogDatapoint] });
}
exports.sendSuggestionLogDatapoint = sendSuggestionLogDatapoint;
//# sourceMappingURL=sendSuggestionLogDatapoint.js.map

/***/ }),

/***/ 3001:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServiceRequest_1 = __webpack_require__(27);
var userVoiceSuggestion_1 = __webpack_require__(3002);
function postNewUserVoiceSuggestionOperation(req, options) {
    if (req !== undefined && !req["__type"]) {
        req = userVoiceSuggestion_1.default(req);
    }
    return ServiceRequest_1.makeServiceRequest("PostNewUserVoiceSuggestion", req, options);
}
exports.default = postNewUserVoiceSuggestionOperation;


/***/ }),

/***/ 3002:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function userVoiceSuggestion(data) {
    var result = tslib_1.__assign({ __type: 'UserVoiceSuggestion:#Exchange' }, data);
    return result;
}
exports.default = userVoiceSuggestion;


/***/ }),

/***/ 3145:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(674), exports);
//# sourceMappingURL=FocusTrapZone.js.map

/***/ }),

/***/ 3146:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function isEnhancedLocation(location) {
    if (!location) {
        return false;
    }
    if (location.LocationUri) {
        return true;
    }
    if (location.Latitude && location.Longitude) {
        return true;
    }
    return false;
}
exports.default = isEnhancedLocation;
//# sourceMappingURL=isEnhancedLocation.js.map

/***/ }),

/***/ 3265:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var CardCollection_1 = __webpack_require__(4157);
var PopulateViewCards_1 = __webpack_require__(4184);
var React = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(11);
var styles = __webpack_require__(2748);
var classNames = __webpack_require__(30).bind(styles);
var viewData;
var Txp = /** @class */ (function (_super) {
    tslib_1.__extends(Txp, _super);
    function Txp() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Txp.prototype.render = function () {
        var _a = this.props, txpObject = _a.txpObject, onExpandCard = _a.onExpandCard, className = _a.className, source = _a.source, onActionButtonClicked = _a.onActionButtonClicked, calendarEventIds = _a.calendarEventIds, txpStyle = _a.txpStyle, txpLocation = _a.txpLocation, showEnhancedLocation = _a.showEnhancedLocation;
        if (txpObject) {
            viewData = PopulateViewCards_1.default(txpObject, calendarEventIds, source, showEnhancedLocation);
        }
        var cards = viewData ? viewData.cardItems : null;
        var isBusStopEnabled = viewData ? viewData.isBusStopEnabled : null;
        if (cards) {
            return (React.createElement("div", { className: classNames([className]) },
                React.createElement(CardCollection_1.default, { cardItems: cards, isBusStopEnabled: isBusStopEnabled, onExpandCard: onExpandCard, source: source, onActionButtonClicked: onActionButtonClicked, txpStyle: txpStyle, txpLocation: txpLocation, showEnhancedLocation: showEnhancedLocation })));
        }
        else {
            return null;
        }
    };
    Txp = tslib_1.__decorate([
        mobx_react_1.observer
    ], Txp);
    return Txp;
}(React.Component));
exports.default = Txp;
//# sourceMappingURL=Txp.js.map

/***/ }),

/***/ 3266:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var charsWithinParenthesisRegex = /\(([^)]*)\)/gi;
var excludedCharactersRegex = /\([^)]*\)|[\0-\u001F\!-/:-@\[-`\{-\u00BF\u0250-\u036F\uD800-\uFFFF]/gi;
var multipleSpacesRegex = /\s+/gi;
function getInitial(name) {
    var initials = '';
    if (!name) {
        return initials;
    }
    name = name.replace(charsWithinParenthesisRegex, ''); // remove chars inside paranthesis
    name = name.replace(excludedCharactersRegex, ''); // remove non-alphanumeric chars
    name = name.replace(multipleSpacesRegex, ' '); // replace multiple spaces with single
    name = name.trim();
    var splits = name.split(' ');
    if (splits.length >= 2) {
        initials += splits[0].charAt(0).toUpperCase();
        initials += splits[splits.length - 1].charAt(0).toUpperCase();
    }
    else if (splits.length != 0) {
        initials += splits[0].charAt(0).toUpperCase();
    }
    return initials;
}
exports.default = getInitial;
//# sourceMappingURL=getInitial.js.map

/***/ }),

/***/ 3267:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Persona_1 = __webpack_require__(234);
var initialColorCount = Object.keys(Persona_1.PersonaInitialsColor).length / 2;
function getTextBoyColor(name) {
    if (!name) {
        return null;
    }
    var hashCode = 0;
    for (var i = name.length - 1; i >= 0; i--) {
        var ch = name.charCodeAt(i);
        var shift = i % 8;
        hashCode ^= (ch << shift) + (ch >> (8 - shift));
    }
    return (hashCode % initialColorCount);
}
exports.default = getTextBoyColor;
//# sourceMappingURL=getTextBoyColor.js.map

/***/ }),

/***/ 3268:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(3269), exports);
//# sourceMappingURL=HoverCard.js.map

/***/ }),

/***/ 3269:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(2989), exports);
tslib_1.__exportStar(__webpack_require__(2811), exports);
tslib_1.__exportStar(__webpack_require__(3271), exports);
tslib_1.__exportStar(__webpack_require__(246), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 3270:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = __webpack_require__(7);
var Styling_1 = __webpack_require__(21);
exports.getStyles = Utilities_1.memoizeFunction(function (theme, customStyles) {
    var styles = {
        root: {
            width: '340px',
            pointerEvents: 'none',
            selectors: {
                '.ms-Callout': {
                    boxShadow: '0 0 20px rgba(0, 0, 0, .2)',
                    border: 'none',
                    selectors: (_a = {},
                        _a[Styling_1.HighContrastSelector] = {
                            border: '1px solid WindowText',
                        },
                        _a)
                }
            }
        },
        compactCard: {
            pointerEvents: 'auto',
            position: 'relative'
        },
        expandedCard: [
            {
                height: '1px',
                overflowY: 'hidden',
                pointerEvents: 'auto',
                transition: 'height 0.467s cubic-bezier(0.5, 0, 0, 1)',
                selectors: {
                    ':before': {
                        content: '""',
                        position: 'relative',
                        display: 'block',
                        top: '0',
                        left: '24px',
                        width: '292px',
                        height: '1px',
                        backgroundColor: theme.palette.neutralLighter
                    }
                }
            }
        ],
        expandedCardScroll: {
            height: '100%',
            boxSizing: 'border-box',
            overflowY: 'auto'
        }
    };
    return Styling_1.concatStyleSets(styles, customStyles);
    var _a;
});
//# sourceMappingURL=ExpandingCard.styles.js.map

/***/ }),

/***/ 3271:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
/* tslint:disable:no-unused-variable */
var React = __webpack_require__(3);
/* tslint:enable:no-unused-variable */
var Utilities_1 = __webpack_require__(7);
var Styling_1 = __webpack_require__(21);
var ExpandingCard_1 = __webpack_require__(2989);
var ExpandingCard_types_1 = __webpack_require__(2811);
var HoverCard_styles_1 = __webpack_require__(3272);
var HoverCard = /** @class */ (function (_super) {
    tslib_1.__extends(HoverCard, _super);
    // Constructor
    function HoverCard(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isHoverCardVisible: false,
            mode: ExpandingCard_types_1.ExpandingCardMode.compact,
            openMode: ExpandingCard_types_1.OpenCardMode.hover
        };
        return _this;
    }
    HoverCard.prototype.componentDidMount = function () {
        var target = this._getTargetElement();
        this._events.on(target, 'mouseenter', this._cardOpen);
        this._events.on(target, 'mouseleave', this._cardDismiss);
        if (this.props.trapFocus) {
            this._events.on(target, 'keydown', this._cardOpen);
        }
        else {
            this._events.on(target, 'focus', this._cardOpen);
            this._events.on(target, 'blur', this._cardDismiss);
        }
        if (this.props.instantOpenOnClick) {
            this._events.on(target, 'click', this._instantOpenExpanded);
        }
        else {
            this._events.on(target, 'mousedown', this._cardDismiss);
            this._events.on(target, 'keydown', this._cardDismiss);
        }
    };
    HoverCard.prototype.componentWillUpdate = function (newProps, newState) {
        var _this = this;
        if (newState.isHoverCardVisible !== this.state.isHoverCardVisible) {
            if (newState.isHoverCardVisible) {
                this._async.setTimeout(function () {
                    _this.setState({
                        mode: ExpandingCard_types_1.ExpandingCardMode.expanded
                    });
                }, this.props.expandedCardOpenDelay);
                this.props.onCardVisible && this.props.onCardVisible();
            }
            else {
                this.setState({
                    mode: ExpandingCard_types_1.ExpandingCardMode.compact
                });
                this.props.onCardHide && this.props.onCardHide();
            }
        }
    };
    // Render
    HoverCard.prototype.render = function () {
        var _a = this.props, expandingCardProps = _a.expandingCardProps, children = _a.children, id = _a.id, _b = _a.setAriaDescribedBy, setAriaDescribedBy = _b === void 0 ? true : _b, customStyles = _a.styles;
        var _c = this.state, isHoverCardVisible = _c.isHoverCardVisible, mode = _c.mode, openMode = _c.openMode;
        var hoverCardId = id || Utilities_1.getId('hoverCard');
        this._styles = HoverCard_styles_1.getStyles(customStyles);
        return (React.createElement("div", { className: Styling_1.mergeStyles(this._styles.host), ref: this._resolveRef('_hoverCard'), "aria-describedby": setAriaDescribedBy && isHoverCardVisible ? hoverCardId : undefined },
            children,
            isHoverCardVisible &&
                React.createElement(ExpandingCard_1.ExpandingCard, tslib_1.__assign({ componentRef: this._resolveRef('_expandingCard') }, Utilities_1.getNativeProps(this.props, Utilities_1.divProperties), { id: hoverCardId, trapFocus: !!this.props.trapFocus, firstFocus: openMode === ExpandingCard_types_1.OpenCardMode.hotKey, targetElement: this._getTargetElement(), onEnter: this._cardOpen, onLeave: this._executeCardDimiss, mode: mode }, expandingCardProps))));
    };
    HoverCard.prototype._getTargetElement = function () {
        var target = this.props.target;
        switch (typeof target) {
            case 'string':
                return Utilities_1.getDocument().querySelector(target);
            case 'object':
                return target;
            default:
                return this._hoverCard;
        }
    };
    // Show HoverCard
    HoverCard.prototype._cardOpen = function (ev) {
        if (ev.type === 'keydown' && !(ev.which === 67 /* c */)) {
            return;
        }
        this._async.clearTimeout(this._dismissTimerId);
        if (ev.type === 'mouseenter') {
            this._currentMouseTarget = ev.currentTarget;
        }
        this._executeCardOpen(ev);
    };
    HoverCard.prototype._executeCardOpen = function (ev) {
        var _this = this;
        this._openTimerId = this._async.setTimeout(function () {
            if (!_this.state.isHoverCardVisible) {
                _this.setState({
                    isHoverCardVisible: true,
                    mode: ExpandingCard_types_1.ExpandingCardMode.compact,
                    openMode: ev.type === 'keydown' ? ExpandingCard_types_1.OpenCardMode.hotKey : ExpandingCard_types_1.OpenCardMode.hover
                });
            }
        }, this.props.cardOpenDelay);
    };
    // Hide HoverCard
    HoverCard.prototype._cardDismiss = function (ev) {
        if (ev.type === 'keydown' && (ev.which !== 27 /* escape */)) {
            return;
        }
        this._async.clearTimeout(this._openTimerId);
        // Dismiss if not sticky and currentTarget is the same element that mouse last entered
        if (!this.props.sticky && (this._currentMouseTarget === ev.currentTarget || (ev.which === 27 /* escape */))) {
            this._executeCardDimiss();
        }
    };
    HoverCard.prototype._executeCardDimiss = function () {
        var _this = this;
        this._dismissTimerId = this._async.setTimeout(function () {
            _this.setState({
                isHoverCardVisible: false,
                mode: ExpandingCard_types_1.ExpandingCardMode.compact,
                openMode: ExpandingCard_types_1.OpenCardMode.hover
            });
        }, this.props.cardDismissDelay);
    };
    // Instant Open the card in Expanded mode
    HoverCard.prototype._instantOpenExpanded = function (ev) {
        this.setState({
            isHoverCardVisible: true,
            mode: ExpandingCard_types_1.ExpandingCardMode.expanded
        });
    };
    HoverCard.defaultProps = {
        cardOpenDelay: 500,
        cardDismissDelay: 100,
        expandedCardOpenDelay: 1500,
        instantOpenOnClick: false
    };
    tslib_1.__decorate([
        Utilities_1.autobind
    ], HoverCard.prototype, "_cardOpen", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], HoverCard.prototype, "_executeCardOpen", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], HoverCard.prototype, "_cardDismiss", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], HoverCard.prototype, "_executeCardDimiss", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], HoverCard.prototype, "_instantOpenExpanded", null);
    return HoverCard;
}(Utilities_1.BaseComponent));
exports.HoverCard = HoverCard;
//# sourceMappingURL=HoverCard.js.map

/***/ }),

/***/ 3272:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = __webpack_require__(7);
var Styling_1 = __webpack_require__(21);
exports.getStyles = Utilities_1.memoizeFunction(function (customStyles) {
    var styles = {
        host: {}
    };
    return Styling_1.mergeStyleSets(styles, customStyles);
});
//# sourceMappingURL=HoverCard.styles.js.map

/***/ }),

/***/ 3273:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(4178);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 3274:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ActivityType_1 = __webpack_require__(2747);
var ActivityTypeNames = {
    /**
     * indicator for Txp Activity
     */
    TxpActivity: 'TxpActivity',
    /**
     * Flight Departure activity type
     */
    flightdeparture: ActivityType_1.default.FlightDeparture,
    /**
     * Hotel checkin activity type
     */
    hotelcheckin: ActivityType_1.default.HotelCheckin,
    /**
     * Hotel checkout activity type
     */
    hotelcheckout: ActivityType_1.default.HotelCheckout,
    /**
     * Parcel Delivery activity type
     */
    parceldelivery: ActivityType_1.default.ParcelDelivery,
    /**
     * Rental car pick up activity type
     */
    rentalcarpickup: ActivityType_1.default.RentalCarPickup,
    /**
     * Rental car drop off activity type
     */
    rentalcardropoff: ActivityType_1.default.RentalCarDropOff,
    /**
     * Dining activity type
     */
    dining: ActivityType_1.default.Dining,
    /**
     * Event activity type
     */
    miscevent: ActivityType_1.default.EventActivityType,
};
exports.default = ActivityTypeNames;
//# sourceMappingURL=ActivityTypeNames.js.map

/***/ }),

/***/ 3275:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function assignPlace(basicEntity, placeBlob) {
    var newEntity = basicEntity;
    if (basicEntity && placeBlob) {
        newEntity = tslib_1.__assign({}, newEntity, {
            name: placeBlob.name,
            telephone: placeBlob.telephone,
            city: placeBlob['address/commonCity'],
        });
        if (placeBlob.address) {
            newEntity = tslib_1.__assign({}, newEntity, {
                address: tslib_1.__assign({}, placeBlob.address),
            });
        }
    }
    return newEntity;
}
exports.default = assignPlace;
//# sourceMappingURL=assignPlace.js.map

/***/ }),

/***/ 3568:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var ActivityType_1 = __webpack_require__(2747);
var FlightCard_1 = __webpack_require__(4159);
var Details_1 = __webpack_require__(4162);
var ActionButtons_1 = __webpack_require__(4165);
var Summary_1 = __webpack_require__(4169);
var React = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(11);
var TxpSource_1 = __webpack_require__(691);
var TxpLocation_1 = __webpack_require__(4170);
var styles = __webpack_require__(2748);
var classNames = __webpack_require__(30).bind(styles);
var CardComponent = /** @class */ (function (_super) {
    tslib_1.__extends(CardComponent, _super);
    function CardComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CardComponent.prototype.render = function () {
        var _a = this.props, cardItem = _a.cardItem, source = _a.source, onActionButtonClicked = _a.onActionButtonClicked, txpStyle = _a.txpStyle, txpLocation = _a.txpLocation, showEnhancedLocation = _a.showEnhancedLocation;
        var isFlightCard = cardItem.activityType == ActivityType_1.default.FlightDeparture;
        var detailsLines = cardItem.detailsData;
        var expandedCardClassNames = [styles.expandedCard];
        if (source !== TxpSource_1.default.CalendarPeek) {
            expandedCardClassNames.push(styles.horizontalExpandedCard);
        }
        return (React.createElement("div", { className: styles.containerCard },
            React.createElement("div", { className: classNames(expandedCardClassNames) },
                React.createElement(Summary_1.default, { lines: [
                        cardItem.summaryFirstLine,
                        cardItem.summarySecondLine,
                        cardItem.summaryThirdLine,
                        cardItem.summaryFourthLine,
                    ], imageSource: cardItem.imageSource, txpStyle: txpStyle }),
                React.createElement("div", { className: styles.detailsContainer, "aria-label": cardItem.ariaText, role: "listitem" },
                    isFlightCard &&
                        React.createElement(FlightCard_1.default, { txpStyle: txpStyle, flightCardItem: cardItem }),
                    !isFlightCard &&
                        React.createElement(Details_1.default, { txpStyle: txpStyle, lines: [
                                detailsLines.firstLine,
                                detailsLines.secondLine,
                                detailsLines.thirdLine,
                                detailsLines.fourthLine,
                                detailsLines.fifthLine,
                            ] }),
                    showEnhancedLocation &&
                        React.createElement(TxpLocation_1.default, { txpLocation: txpLocation, showLocationDisplay: cardItem.activityType != ActivityType_1.default.ParcelDelivery }),
                    React.createElement(ActionButtons_1.default, { cardItem: cardItem, source: source, onActionButtonClicked: onActionButtonClicked })))));
    };
    CardComponent = tslib_1.__decorate([
        mobx_react_1.observer
    ], CardComponent);
    return CardComponent;
}(React.Component));
exports.default = CardComponent;
//# sourceMappingURL=CardComponent.js.map

/***/ }),

/***/ 3569:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Gets the postalAddress from the location persona type. The default postal address is
 * the home address if present, otherwise the business address if present, otherwise
 * other address or null if no postal address is specified
 * @param persona: the location persona type
 */
function getLocationPostalAddress(persona) {
    if (!persona) {
        return null;
    }
    if (persona.HomeAddressesArray != null && persona.HomeAddressesArray.length > 0) {
        return persona.HomeAddressesArray[0].Value;
    }
    else if (persona.BusinessAddressesArray != null &&
        persona.BusinessAddressesArray.length > 0) {
        return persona.BusinessAddressesArray[0].Value;
    }
    else if (persona.OtherAddressesArray != null && persona.OtherAddressesArray.length > 0) {
        return persona.OtherAddressesArray[0].Value;
    }
    else {
        return null;
    }
}
exports.getLocationPostalAddress = getLocationPostalAddress;
//# sourceMappingURL=getLocationPostalAddress.js.map

/***/ }),

/***/ 3570:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getLocalizedAddress_1 = __webpack_require__(2988);
var owa_string_utils_1 = __webpack_require__(2627);
/**
 * Gets the Location display text from the location persona.
 * It is the display name of the location if present, the a localized postal address otherwise
 * @param postalAddress: the location persona
 * @param displayName: the location displayName
 */
function getLocationDisplayText(displayName, postalAddress) {
    return owa_string_utils_1.isNullOrWhiteSpace(displayName) ? getLocalizedAddress_1.getLocalizedAddress(postalAddress) : displayName;
}
exports.getLocationDisplayText = getLocationDisplayText;
//# sourceMappingURL=getLocationDisplayText.js.map

/***/ }),

/***/ 3571:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Creates a persona blob for a location
 */
function createNewPersonaBlob() {
    return {
        blobUrl: null,
        isPendingFetch: false,
        hasFetchFailed: false,
    };
}
exports.default = createNewPersonaBlob;
//# sourceMappingURL=createNewPersonaBlob.js.map

/***/ }),

/***/ 3572:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var getLocationPhoto_1 = __webpack_require__(4176);
var owa_string_utils_1 = __webpack_require__(2627);
var mobx_react_1 = __webpack_require__(11);
var Persona_1 = __webpack_require__(234);
var assign = __webpack_require__(26);
var LocationPersonaControl = /** @class */ (function (_super) {
    tslib_1.__extends(LocationPersonaControl, _super);
    function LocationPersonaControl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LocationPersonaControl.prototype.componentDidMount = function () {
        this.fetchPersonaPhoto(this.props);
    };
    LocationPersonaControl.prototype.componentWillReceiveProps = function (nextProps) {
        this.fetchPersonaPhoto(nextProps);
    };
    LocationPersonaControl.prototype.shouldComponentUpdate = function (nextProps) {
        if (this.props.locationPersona.personaControlId ==
            nextProps.locationPersona.personaControlId) {
            // If it's the same location persona, then we don't update the component
            return false;
        }
        return true;
    };
    /**
     * fetches the location persona photo
     * @param props the address and display text of the location
     */
    LocationPersonaControl.prototype.fetchPersonaPhoto = function (props) {
        if (props.locationPersona.postalAddress != null &&
            !owa_string_utils_1.isNullOrWhiteSpace(props.locationPersona.displayName)) {
            getLocationPhoto_1.default(props.locationPersona);
        }
    };
    LocationPersonaControl.prototype.render = function () {
        var _a = this.props, locationPersona = _a.locationPersona, className = _a.className, size = _a.size, showPersonaDetails = _a.showPersonaDetails;
        if (locationPersona) {
            var photoDisplayProps = {};
            if (locationPersona.personaBlob &&
                locationPersona.personaBlob.blobUrl &&
                !owa_string_utils_1.isNullOrWhiteSpace(locationPersona.personaBlob.blobUrl)) {
                assign(photoDisplayProps, {
                    imageUrl: locationPersona.personaBlob.blobUrl,
                    imageShouldFadeIn: false,
                });
            }
            else {
                assign(photoDisplayProps, {
                    imageInitials: locationPersona.initials,
                    initialsColor: locationPersona.textBoyColor,
                });
            }
            return (React.createElement(Persona_1.Persona, tslib_1.__assign({ className: className, presence: Persona_1.PersonaPresence.none, hidePersonaDetails: !showPersonaDetails, size: size, primaryText: locationPersona.displayName, secondaryText: locationPersona.displayAddress }, photoDisplayProps)));
        }
        return null;
    };
    LocationPersonaControl = tslib_1.__decorate([
        mobx_react_1.observer
    ], LocationPersonaControl);
    return LocationPersonaControl;
}(React.Component));
exports.LocationPersonaControl = LocationPersonaControl;
//# sourceMappingURL=LocationPersonaControl.js.map

/***/ }),

/***/ 3573:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getUserConfiguration_1 = __webpack_require__(9);
var owa_string_utils_1 = __webpack_require__(2627);
var owa_strings_1 = __webpack_require__(20);
/**
 * Calculates the picture url for a place
 * @param viewState: the persona control state, contains the information about the place
 * @param width: The width of the map
 * @param height: The height of the map
 */
function calculatePhotoUrl(viewState, width, height) {
    var userConfiguration = getUserConfiguration_1.default();
    var baseUrl = '';
    var key = '';
    var culture = '';
    // get the values of the baseUrl, key and culture directly from the userConfiguration
    if (userConfiguration != null &&
        userConfiguration.ApplicationSettings != null &&
        userConfiguration.SessionSettings != null &&
        userConfiguration.PolicySettings != null &&
        userConfiguration.PolicySettings.PlacesEnabled) {
        baseUrl = userConfiguration.ApplicationSettings.StaticMapUrl;
        key = userConfiguration.ApplicationSettings.MapControlKey;
        culture = userConfiguration.SessionSettings.UserCulture;
    }
    // if baseUrl, key, culture, latitude and longitude available then construnct the Url
    if (!owa_string_utils_1.isNullOrWhiteSpace(baseUrl) &&
        !owa_string_utils_1.isNullOrWhiteSpace(key) &&
        !owa_string_utils_1.isNullOrWhiteSpace(culture) &&
        viewState.postalAddress != null &&
        viewState.postalAddress.Latitude != undefined &&
        viewState.postalAddress.Longitude != undefined) {
        return owa_strings_1.format(baseUrl + '?centerPoint={0},{1}&pp={0},{1};51&ms={2},{3}&fmt=png&key={4}&c={5}', viewState.postalAddress.Latitude, viewState.postalAddress.Longitude, width, height, key, culture);
    }
    return '';
}
exports.default = calculatePhotoUrl;
//# sourceMappingURL=calculateMapUrl.js.map

/***/ }),

/***/ 3574:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var createNewPersonaBlob_1 = __webpack_require__(3571);
var getInitial_1 = __webpack_require__(3266);
var getTextBoyColor_1 = __webpack_require__(3267);
var getLocalizedAddress_1 = __webpack_require__(2988);
/**
 * Create a Persona for postal addresses to show them as resolved entities
 * @param postalAddress: the location's postal address
 * @param locationName: location displayName
 */
function createLocationPersonaFromPostalAddress(postalAddress, locationName) {
    return {
        displayName: locationName,
        postalAddress: postalAddress,
        displayAddress: getLocalizedAddress_1.getLocalizedAddress(postalAddress),
        initials: getInitial_1.default(locationName),
        textBoyColor: getTextBoyColor_1.default(locationName),
        personaBlob: createNewPersonaBlob_1.default(),
        selectionSource: 'LocationWell',
        personaType: 'Unknown',
        personaControlId: locationName,
    };
}
exports.default = createLocationPersonaFromPostalAddress;
//# sourceMappingURL=createLocationPersonaFromPostalAddress.js.map

/***/ }),

/***/ 3575:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var isEnhancedLocation_1 = __webpack_require__(3146);
function isRoom(postalAddress) {
    return isEnhancedLocation_1.default(postalAddress) && postalAddress.LocationSource === 'Resource';
}
exports.default = isRoom;
//# sourceMappingURL=isRoom.js.map

/***/ }),

/***/ 3576:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var LocationPersonaControl_1 = __webpack_require__(3572);
var Persona_1 = __webpack_require__(234);
var styles = __webpack_require__(3273);
var LocationCompactCard = /** @class */ (function (_super) {
    tslib_1.__extends(LocationCompactCard, _super);
    function LocationCompactCard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LocationCompactCard.prototype.render = function () {
        return (React.createElement(LocationPersonaControl_1.LocationPersonaControl, { className: styles.persona, showPersonaDetails: true, size: Persona_1.PersonaSize.large, locationPersona: this.props.locationPersona }));
    };
    return LocationCompactCard;
}(React.Component));
exports.default = LocationCompactCard;
//# sourceMappingURL=LocationCompactCard.js.map

/***/ }),

/***/ 3577:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var Icon_1 = __webpack_require__(43);
var calculateMapUrl_1 = __webpack_require__(3573);
var getBingUrl_1 = __webpack_require__(4179);
var owa_calendar_strings_1 = __webpack_require__(1809);
var styles = __webpack_require__(3273);
var classNames = __webpack_require__(30).bind(styles);
var MAP_WIDTH = 290;
var MAP_HEIGHT = 135;
var LocationExpandedCard = /** @class */ (function (_super) {
    tslib_1.__extends(LocationExpandedCard, _super);
    function LocationExpandedCard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.openDirections = function () {
            window.open(getBingUrl_1.default(_this.props.locationPersona.postalAddress, _this.props.locationPersona.displayName), '_blank');
        };
        _this.onKeyDown = function (ev) {
            if (ev.which == 13 /* enter */) {
                _this.openDirections();
            }
        };
        return _this;
    }
    LocationExpandedCard.prototype.render = function () {
        var locationPersona = this.props.locationPersona;
        var imageUrl = calculateMapUrl_1.default(locationPersona, MAP_WIDTH, MAP_HEIGHT);
        return (React.createElement("span", null,
            locationPersona.displayAddress &&
                React.createElement("div", { className: styles.cardSection },
                    React.createElement("div", { className: styles.sectionHeader }, owa_calendar_strings_1.default.locationCardInformationLabel),
                    React.createElement(Icon_1.Icon, { className: styles.icon, iconName: "Poi" /* Poi */ }),
                    React.createElement("div", { tabIndex: 0, "aria-label": locationPersona.displayName, role: "button", className: classNames(styles.linkToBing, styles.informationRow), onClick: this.openDirections, onKeyDown: this.onKeyDown }, locationPersona.displayAddress),
                    React.createElement("div", { className: styles.clearFix })),
            imageUrl &&
                React.createElement("div", { className: styles.cardSection },
                    React.createElement("div", { className: styles.sectionHeader }, owa_calendar_strings_1.default.locationCardMapLabel),
                    React.createElement("img", { className: styles.linkToBing, src: imageUrl, onClick: this.openDirections, onKeyDown: this.onKeyDown }))));
    };
    return LocationExpandedCard;
}(React.Component));
exports.default = LocationExpandedCard;
//# sourceMappingURL=LocationExpandedCard.js.map

/***/ }),

/***/ 3578:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Role;
(function (Role) {
    /**
     * Primary role value
     */
    Role[Role["Primary"] = 0] = "Primary";
    /**
     * Secondary role value
     */
    Role[Role["Secondary"] = 1] = "Secondary";
})(Role || (Role = {}));
exports.default = Role;
//# sourceMappingURL=Role.js.map

/***/ }),

/***/ 3579:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ActivityType_1 = __webpack_require__(2747);
var CreateFlightCard_1 = __webpack_require__(4187);
var createParcelDeliveryCard_1 = __webpack_require__(4200);
var createRentalCarCard_1 = __webpack_require__(4201);
var createLodgingCard_1 = __webpack_require__(4203);
var getCalendarEventId_1 = __webpack_require__(4205);
function createCardItem(activityItem, currentEntity, isBusStop, source, showEnhancedLocation, cardRole, calendarEventIds) {
    var currentCard;
    var calendarEventId;
    var activityId = activityItem.activityId;
    if (calendarEventIds) {
        calendarEventId = getCalendarEventId_1.default(activityItem, calendarEventIds);
    }
    switch (activityItem.type) {
        case ActivityType_1.default.FlightDeparture: {
            var flightEntity = currentEntity;
            currentCard = CreateFlightCard_1.default(flightEntity, isBusStop, activityId, source, calendarEventId);
            break;
        }
        case ActivityType_1.default.ParcelDelivery: {
            var parcelDeliveryEntity = currentEntity;
            currentCard = createParcelDeliveryCard_1.default(parcelDeliveryEntity, activityId, source, !showEnhancedLocation, calendarEventId);
            break;
        }
        case ActivityType_1.default.RentalCarPickup:
        case ActivityType_1.default.RentalCarDropOff: {
            var rentalCarEntity = currentEntity;
            currentCard = createRentalCarCard_1.default(rentalCarEntity, isBusStop, activityItem.type, activityId, source, !showEnhancedLocation, cardRole, calendarEventId);
            break;
        }
        case ActivityType_1.default.HotelCheckin:
        case ActivityType_1.default.HotelCheckout: {
            var lodgingEntity = currentEntity;
            currentCard = createLodgingCard_1.default(lodgingEntity, isBusStop, activityItem.type, activityId, source, !showEnhancedLocation, cardRole, calendarEventId);
            break;
        }
        default: {
            currentCard = null;
        }
    }
    return currentCard;
}
exports.default = createCardItem;
//# sourceMappingURL=CreateCardItem.js.map

/***/ }),

/***/ 3580:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_common_strings_1 = __webpack_require__(37);
var createAbbreviatedDurationFormatter_1 = __webpack_require__(4189);
var getUserConfiguration_1 = __webpack_require__(9);
/** Creates a duration formatter using the user's culture and the standard abbreviated strings. */
function createAbbreviatedFormatter(options) {
    return createAbbreviatedDurationFormatter_1.default(getUserConfiguration_1.default().SessionSettings.UserCulture, owa_common_strings_1.default, options);
}
exports.createAbbreviatedFormatter = createAbbreviatedFormatter;
/**
 * Format a duration value using the user's culture and the standard abbreviated strings.
 * When formatting multiple values, it is better to use createFormatter and then
 * invoke it multiple times.
 */
function abbreviatedFormatDuration(value, options) {
    var formatter = createAbbreviatedFormatter(options);
    return formatter(value);
}
exports.default = abbreviatedFormatDuration;
//# sourceMappingURL=abbreviated.js.map

/***/ }),

/***/ 3581:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var PopulateActivities_1 = __webpack_require__(4209);
var PopulateEntities_1 = __webpack_require__(4214);
var foundEntities_1 = __webpack_require__(4230);
var foundActivities_1 = __webpack_require__(4231);
/**
 * @serverTxpBlob - the string of txp blob we get from the server
 * The function returns an object with parsed data - entities and activities.
 * The object is a valid prop for the TXP control.
 */
function convertTxpBlobToObject(serverTxpBlob) {
    // parse the data into Json
    if (serverTxpBlob) {
        var parsedEntities = void 0;
        var parsedActivities = void 0;
        var parsedBlob = void 0;
        try {
            parsedBlob = JSON.parse(serverTxpBlob);
        }
        catch (e) {
            parsedBlob = null;
        }
        if (parsedBlob) {
            // parse entities
            var blobEntities = foundEntities_1.default(parsedBlob);
            parsedEntities = PopulateEntities_1.default(blobEntities);
            // parse activities
            var blobActivities = foundActivities_1.default(parsedBlob);
            parsedActivities = PopulateActivities_1.default(blobActivities);
            if (parsedEntities && parsedActivities) {
                return {
                    txpEntities: parsedEntities,
                    txpActivities: parsedActivities,
                };
            }
        }
    }
    return null;
}
exports.default = convertTxpBlobToObject;
//# sourceMappingURL=ConvertTxpBlobToObject.js.map

/***/ }),

/***/ 3582:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function assignAddress(basicEntity, addressBlob) {
    return tslib_1.__assign({}, basicEntity, {
        streetAddress: addressBlob.streetAddress,
        addressLocality: addressBlob.addressLocality,
        addressRegion: addressBlob.addressRegion,
        addressCountry: addressBlob.addressCountry,
        postalCode: addressBlob.postalCode,
        postOfficeBoxNumber: addressBlob.postOfficeBoxNumber,
    });
}
exports.default = assignAddress;
//# sourceMappingURL=assignAddress.js.map

/***/ }),

/***/ 4157:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var BusStopComponent_1 = __webpack_require__(4158);
var CardComponent_1 = __webpack_require__(3568);
var React = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(11);
var owa_accessibility_1 = __webpack_require__(79);
var CardCollection = /** @class */ (function (_super) {
    tslib_1.__extends(CardCollection, _super);
    function CardCollection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CardCollection.prototype.render = function () {
        var _a = this.props, cardItems = _a.cardItems, isBusStopEnabled = _a.isBusStopEnabled, onExpandCard = _a.onExpandCard, source = _a.source, onActionButtonClicked = _a.onActionButtonClicked, txpStyle = _a.txpStyle, txpLocation = _a.txpLocation, showEnhancedLocation = _a.showEnhancedLocation;
        var renderedCards = [];
        var ariaProps = {
            role: owa_accessibility_1.AriaRoles.listbox,
        };
        cardItems.forEach(function (card) {
            if (card) {
                if (isBusStopEnabled) {
                    renderedCards.push(React.createElement(BusStopComponent_1.default, { key: card.id, cardItem: card, onExpandCard: onExpandCard, source: source, onActionButtonClicked: onActionButtonClicked, txpStyle: txpStyle }));
                }
                else {
                    renderedCards.push(React.createElement(CardComponent_1.default, { key: card.id, cardItem: card, source: source, onActionButtonClicked: onActionButtonClicked, txpStyle: txpStyle, txpLocation: txpLocation, showEnhancedLocation: showEnhancedLocation }));
                }
            }
        });
        return (React.createElement("div", tslib_1.__assign({}, owa_accessibility_1.generateDomPropertiesForAria(ariaProps)), renderedCards));
    };
    CardCollection = tslib_1.__decorate([
        mobx_react_1.observer
    ], CardCollection);
    return CardCollection;
}(React.Component));
exports.default = CardCollection;
//# sourceMappingURL=CardCollection.js.map

/***/ }),

/***/ 4158:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(11);
var CardComponent_1 = __webpack_require__(3568);
var Button_1 = __webpack_require__(62);
var TailoredActionName_1 = __webpack_require__(684);
var Icon_1 = __webpack_require__(43);
var owa_accessibility_1 = __webpack_require__(79);
var classNames = __webpack_require__(343);
var styles = __webpack_require__(2748);
var BusStopItemComponent = /** @class */ (function (_super) {
    tslib_1.__extends(BusStopItemComponent, _super);
    function BusStopItemComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.onExpandCard = function () {
            var _a = _this.props, onExpandCard = _a.onExpandCard, cardItem = _a.cardItem, source = _a.source;
            _this.setState({
                isExpanded: !_this.state.isExpanded,
            });
            if (onExpandCard) {
                var logExpandAction = {
                    entityNamesFlag: cardItem.entityType.toString(),
                    isExpanded: (!_this.state.isExpanded).toString(),
                    activityType: cardItem.activityType.toString(),
                    tailoredActionName: TailoredActionName_1.default.ExpandCard,
                    source: source,
                };
                onExpandCard(logExpandAction);
            }
        };
        _this.state = {
            isExpanded: !!props.expandOnMount,
        };
        return _this;
    }
    BusStopItemComponent.prototype.render = function () {
        var _this = this;
        var firstLineStyle = this.state.isExpanded
            ? classNames([styles.busStopFirstLine, styles.busStopFirstLineExpand])
            : styles.busStopFirstLine;
        var _a = this.props, cardItem = _a.cardItem, source = _a.source, onActionButtonClicked = _a.onActionButtonClicked, txpStyle = _a.txpStyle;
        var busStopData = cardItem.busStopData;
        var ariaDivProps = {
            role: owa_accessibility_1.AriaRoles.listitem,
        };
        return (React.createElement("div", tslib_1.__assign({ className: styles.busStop }, owa_accessibility_1.generateDomPropertiesForAria(ariaDivProps)),
            React.createElement(Button_1.DefaultButton, { "aria-expanded": this.state.isExpanded, onClick: function () { return _this.onExpandCard(); }, className: firstLineStyle },
                React.createElement(Icon_1.Icon, { className: styles.busStopIcon, iconName: busStopData.icon }),
                React.createElement("div", { className: styles.busStopLabel }, busStopData.busStopLabel),
                React.createElement("div", { className: styles.busStopText }, busStopData.busStopText),
                React.createElement("span", { className: "screenReaderOnly" }, busStopData.ariaBusStopText)),
            React.createElement("div", null,
                this.state.isExpanded &&
                    React.createElement("div", { className: styles.cardInBusStop },
                        React.createElement(CardComponent_1.default, { cardItem: cardItem, source: source, onActionButtonClicked: onActionButtonClicked, txpStyle: txpStyle, showEnhancedLocation: false })),
                !this.state.isExpanded &&
                    React.createElement("div", { "aria-hidden": true, className: styles.collapsedText }, busStopData.collapsedText))));
    };
    BusStopItemComponent = tslib_1.__decorate([
        mobx_react_1.observer
    ], BusStopItemComponent);
    return BusStopItemComponent;
}(React.Component));
exports.default = BusStopItemComponent;
//# sourceMappingURL=BusStopComponent.js.map

/***/ }),

/***/ 4159:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var Icon_1 = __webpack_require__(43);
var React = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(11);
var styles = __webpack_require__(4160);
var classNames = __webpack_require__(30).bind(styles);
var FlightCard = /** @class */ (function (_super) {
    tslib_1.__extends(FlightCard, _super);
    function FlightCard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FlightCard.prototype.render = function () {
        var _a = this.props, flightCardItem = _a.flightCardItem, txpStyle = _a.txpStyle;
        var flightLineStyle = flightCardItem.isFutureFlight ? styles.futureFlight : null;
        return (React.createElement("div", { className: classNames(styles.details, txpStyle.cardDetails, 'allowTextSelection') },
            React.createElement("div", { className: styles.row },
                React.createElement("label", { className: styles.iata }, flightCardItem.departureIATA),
                React.createElement("div", { className: classNames(styles.lineContainer, flightLineStyle) },
                    React.createElement(Icon_1.Icon, { className: txpStyle.planeStyle, iconName: txpStyle.airPlaneIcon }),
                    React.createElement("div", { className: styles.line })),
                React.createElement("label", { className: styles.iata }, flightCardItem.arrivalIATA)),
            React.createElement("div", { className: styles.row },
                React.createElement("div", { className: styles.column },
                    React.createElement("label", { className: styles.time }, flightCardItem.departureTime),
                    React.createElement("label", { className: styles.smallText }, flightCardItem.departureDate),
                    React.createElement("label", { className: styles.smallText }, flightCardItem.departureCity),
                    flightCardItem.departureTerminalGate && (React.createElement("label", { className: styles.smallText }, flightCardItem.departureTerminalGate)),
                    flightCardItem.seat && (React.createElement("label", { className: styles.smallText }, flightCardItem.seat))),
                React.createElement("div", { className: styles.column },
                    React.createElement("label", { className: styles.time }, flightCardItem.arrivalTime),
                    React.createElement("label", { className: styles.smallText }, flightCardItem.arrivalDate),
                    React.createElement("label", { className: styles.smallText }, flightCardItem.arrivalCity),
                    flightCardItem.arrivalTerminalGate && (React.createElement("label", { className: styles.smallText }, flightCardItem.arrivalTerminalGate))))));
    };
    FlightCard = tslib_1.__decorate([
        mobx_react_1.observer
    ], FlightCard);
    return FlightCard;
}(React.Component));
exports.default = FlightCard;
//# sourceMappingURL=FlightCard.js.map

/***/ }),

/***/ 4160:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(4161);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 4161:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, "._1P_h72zpkYrhiPTnCuAg5q{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-flex:10;-ms-flex-positive:10;flex-grow:10}html[dir] ._1P_h72zpkYrhiPTnCuAg5q{padding-top:20px;padding-bottom:20px}._1YWJEhTyT8DBslfEvXe8-p{-webkit-box-flex:10;-ms-flex-positive:10;flex-grow:10;-webkit-box-orient:horizontal;-ms-flex-direction:row;flex-direction:row}._1YWJEhTyT8DBslfEvXe8-p,._1zeT1nH5qiJT-fFlM12vxO{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-direction:normal}._1zeT1nH5qiJT-fFlM12vxO{-webkit-box-orient:vertical;-ms-flex-direction:column;flex-direction:column;font-weight:400;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}._2l8qmUglb40TF1YvMK4VUZ{font-size:15px;color:\"[theme:neutralPrimary, default:#333333]\"}html[dir] ._2l8qmUglb40TF1YvMK4VUZ{padding-bottom:4px}.JstMUnjSbUj2doL5OLoax{font-size:12px;color:\"[theme:neutralSecondary, default:#666666]\"}html[dir] .JstMUnjSbUj2doL5OLoax{padding-bottom:4px}._1zeT1nH5qiJT-fFlM12vxO:last-child{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}._2aiGBpLqlImW1Lh2HTOhyQ{font-size:21px;color:\"[theme:neutralPrimary, default:#333333]\";font-weight:300}html[dir=ltr] ._2aiGBpLqlImW1Lh2HTOhyQ:first-child{padding-right:6px}html[dir=ltr] ._2aiGBpLqlImW1Lh2HTOhyQ:last-child,html[dir=rtl] ._2aiGBpLqlImW1Lh2HTOhyQ:first-child{padding-left:6px}html[dir=rtl] ._2aiGBpLqlImW1Lh2HTOhyQ:last-child{padding-right:6px}._2SAqezk6xgLwZYr0H8YpQy{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}html[dir] ._2SAqezk6xgLwZYr0H8YpQy:first-child{padding:10px 0 4px}.otdXbGC7a6ZzbXLDRlny5{-webkit-box-flex:10;-ms-flex-positive:10;flex-grow:10;top:13px;position:relative}html[dir] .otdXbGC7a6ZzbXLDRlny5{border-top:\"[theme:black, default:#000000]\" 2px solid}html[dir] ._2G481t1K1-yAAw7V_7SvF{padding:0}._37VNhXbOjm9dEkhsCz7TQJ{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}html[dir] ._37VNhXbOjm9dEkhsCz7TQJ{background-color:\"[theme:white, default:#ffffff]\"}._2Ii-sGPonJGIpe1O9emaYO{-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse}", ""]);

// exports
exports.locals = {
	"details": "_1P_h72zpkYrhiPTnCuAg5q",
	"lineContainer": "_1YWJEhTyT8DBslfEvXe8-p",
	"column": "_1zeT1nH5qiJT-fFlM12vxO",
	"time": "_2l8qmUglb40TF1YvMK4VUZ",
	"smallText": "JstMUnjSbUj2doL5OLoax",
	"iata": "_2aiGBpLqlImW1Lh2HTOhyQ",
	"row": "_2SAqezk6xgLwZYr0H8YpQy",
	"line": "otdXbGC7a6ZzbXLDRlny5",
	"txpContainer": "_2G481t1K1-yAAw7V_7SvF",
	"txpCardSummary": "_37VNhXbOjm9dEkhsCz7TQJ",
	"futureFlight": "_2Ii-sGPonJGIpe1O9emaYO"
};

/***/ }),

/***/ 4162:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(11);
var styles = __webpack_require__(4163);
var classNames = __webpack_require__(30).bind(styles);
var Details = /** @class */ (function (_super) {
    tslib_1.__extends(Details, _super);
    function Details() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Details.prototype.render = function () {
        var _a = this.props, lines = _a.lines, txpStyle = _a.txpStyle;
        var detailsLines = lines.map(function (text, index) {
            if (text) {
                return (React.createElement("label", { key: index, className: styles.detailsLabel }, text));
            }
            else {
                return null;
            }
        });
        return (React.createElement("div", { className: classNames(styles.details, 'allowTextSelection', txpStyle.cardDetails), role: "listitem" }, detailsLines));
    };
    Details = tslib_1.__decorate([
        mobx_react_1.observer
    ], Details);
    return Details;
}(React.Component));
exports.default = Details;
//# sourceMappingURL=Details.js.map

/***/ }),

/***/ 4163:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(4164);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 4164:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, "._3fIIG6foRJ-WsR5FhLPsgV{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-flex:10;-ms-flex-positive:10;flex-grow:10}html[dir] ._3fIIG6foRJ-WsR5FhLPsgV{padding-top:20px;padding-bottom:20px}html[dir=ltr] ._3fIIG6foRJ-WsR5FhLPsgV{text-align:left}html[dir=rtl] ._3fIIG6foRJ-WsR5FhLPsgV{text-align:right}._2GbDxhoiQxdvLe43rqoSwz{display:-webkit-box;display:-ms-flexbox;display:flex}html[dir] ._2GbDxhoiQxdvLe43rqoSwz{padding-top:5px}html[dir=ltr] ._2GbDxhoiQxdvLe43rqoSwz{text-align:left}html[dir=rtl] ._2GbDxhoiQxdvLe43rqoSwz{text-align:right}", ""]);

// exports
exports.locals = {
	"details": "_3fIIG6foRJ-WsR5FhLPsgV",
	"detailsLabel": "_2GbDxhoiQxdvLe43rqoSwz"
};

/***/ }),

/***/ 4165:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(11);
var Icon_1 = __webpack_require__(43);
var Button_1 = __webpack_require__(62);
var owa_txp_strings_1 = __webpack_require__(2703);
var getCalendarDeepLinkUrl_1 = __webpack_require__(4166);
var TailoredActionName_1 = __webpack_require__(684);
var getActionButtonDataPointData_1 = __webpack_require__(4167);
var styles = __webpack_require__(2748);
var ActionButtons = /** @class */ (function (_super) {
    tslib_1.__extends(ActionButtons, _super);
    function ActionButtons() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.viewInCalendarButtonElement = function () {
            var onViewInCalendar = function () { return _this.onClick(TailoredActionName_1.default.ViewCalendar); };
            return (React.createElement("a", { role: "button", onClick: onViewInCalendar, className: styles.viewButton, href: getCalendarDeepLinkUrl_1.default(_this.props.cardItem.calendarEventId), target: "_blank" },
                React.createElement(Icon_1.Icon, { className: styles.buttonImage, iconName: "Calendar" /* Calendar */ }),
                owa_txp_strings_1.default.viewCalendarText));
        };
        _this.actionButtonElement = function () {
            var onActionButton = function () {
                return _this.onClick(_this.props.cardItem.actionName, function () {
                    window.open(_this.props.cardItem.actionUrl);
                });
            };
            var _a = _this.props.cardItem, actionIconName = _a.actionIconName, actionButtonText = _a.actionButtonText;
            return (React.createElement(Button_1.DefaultButton, { className: styles.actionButton, onClick: onActionButton },
                React.createElement(Icon_1.Icon, { className: styles.buttonImage, iconName: actionIconName }),
                React.createElement("div", { className: styles.actionButtonText }, actionButtonText)));
        };
        _this.onClick = function (actionName, txpAction) {
            var _a = _this.props, onActionButtonClicked = _a.onActionButtonClicked, source = _a.source;
            var activityType = _this.props.cardItem.activityType;
            if (onActionButtonClicked) {
                var actionButtonDataPoint = getActionButtonDataPointData_1.default(actionName, activityType, source);
                onActionButtonClicked(actionButtonDataPoint);
            }
            if (txpAction) {
                txpAction();
            }
        };
        return _this;
    }
    ActionButtons.prototype.render = function () {
        var _a = this.props.cardItem, actionIconName = _a.actionIconName, actionButtonText = _a.actionButtonText, calendarEventId = _a.calendarEventId;
        var showActionButton = actionIconName && actionButtonText;
        if (showActionButton || calendarEventId) {
            return (React.createElement("div", { className: styles.containerButtons },
                calendarEventId && this.viewInCalendarButtonElement(),
                showActionButton && this.actionButtonElement()));
        }
        else {
            return null;
        }
    };
    ActionButtons = tslib_1.__decorate([
        mobx_react_1.observer
    ], ActionButtons);
    return ActionButtons;
}(React.Component));
exports.default = ActionButtons;
//# sourceMappingURL=ActionButtons.js.map

/***/ }),

/***/ 4166:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_url_1 = __webpack_require__(216);
function getCalendarDeepLinkUrl(itemId) {
    // TODO: VSO:11535 - Deeplink to react versions of the calendar forms once implemented
    var popoutQuerystringProps = {
        viewmodel: 'ICalendarItemDetailsViewModelFactory',
        ItemID: encodeURIComponent(itemId),
        ispopout: '1',
    };
    return owa_url_1.getOwaUrlWithAddedQueryParameters(popoutQuerystringProps);
}
exports.default = getCalendarDeepLinkUrl;
//# sourceMappingURL=getCalendarDeepLinkUrl.js.map

/***/ }),

/***/ 4167:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function getActionButtonDataPointData(actionName, activityType, source) {
    return {
        dataPointName: actionName,
        activityType: activityType,
        source: source,
    };
}
exports.default = getActionButtonDataPointData;
//# sourceMappingURL=getActionButtonDataPointData.js.map

/***/ }),

/***/ 4168:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, ".rfmHYSZ8tCwsa4WKyO0nX{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}html[dir=ltr] .rfmHYSZ8tCwsa4WKyO0nX{border-left:\"[theme:themeLight, default:#C7E0F4]\" 2px solid}html[dir=rtl] .rfmHYSZ8tCwsa4WKyO0nX{border-right:\"[theme:themeLight, default:#C7E0F4]\" 2px solid}html[dir] .rfmHYSZ8tCwsa4WKyO0nX:last-child{border:none}.SdA_nWXiU61WtlgfApo_6{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;height:24px}html[dir] .SdA_nWXiU61WtlgfApo_6{background-color:transparent}html[dir=ltr] .SdA_nWXiU61WtlgfApo_6{padding-left:12px;margin-left:-12px}html[dir=rtl] .SdA_nWXiU61WtlgfApo_6{padding-right:12px;margin-right:-12px}html[dir] .kMMwcA1h64ZWp6Z8eW6GI{margin-bottom:20px}.GTliPpS7B77m00_Xwy9lB{color:\"[theme:themePrimary, default:#0078D7]\";font-size:14px;font-weight:600}html[dir=ltr] .GTliPpS7B77m00_Xwy9lB{padding-left:5px}html[dir=rtl] .GTliPpS7B77m00_Xwy9lB{padding-right:5px}._3uK6beu6Jgt8VCNo7ocWEO{color:\"[theme:neutralSecondary, default:#666666]\";font-size:14px;font-weight:600}html[dir=ltr] ._3uK6beu6Jgt8VCNo7ocWEO{padding-left:3px}html[dir=rtl] ._3uK6beu6Jgt8VCNo7ocWEO{padding-right:3px}.ENraeCKRqCzLXoO4bMwaP{font-weight:400;font-size:12px;color:\"[theme:themePrimary, default:#0078D7]\";overflow:hidden;height:22px;min-width:0}html[dir] .ENraeCKRqCzLXoO4bMwaP{padding:0;background-color:transparent}.ENraeCKRqCzLXoO4bMwaP:hover{color:\"[theme:themePrimary, default:#0078D7]\"}._1YTUxVFUXAG3RBRRQ7I0-0{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;line-height:22px}html[dir] ._1YTUxVFUXAG3RBRRQ7I0-0{margin-top:10px}._289W9PMieBOGfSSccVBJee{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;line-height:22px}._2PJi9reZDih6ZdA98rzDSX{font-size:12px;color:\"[theme:neutralSecondary, default:#666666]\"}._1CbccnL0oU2gFH24Og3DWF{font-size:15px!important;overflow:hidden;-webkit-box-sizing:border-box;box-sizing:border-box;color:\"[theme:white, default:#ffffff]\";height:22px;width:22px;line-height:22px}html[dir] ._1CbccnL0oU2gFH24Og3DWF{border-radius:50%;-moz-border-radius:50%;-webkit-border-radius:50%;background-color:\"[theme:themePrimary, default:#0078D7]\"}html[dir=ltr] ._1CbccnL0oU2gFH24Og3DWF{margin-left:-12px}html[dir=rtl] ._1CbccnL0oU2gFH24Og3DWF{margin-right:-12px;-webkit-transform:rotateY(180deg);transform:rotateY(180deg)}.aRV8La04BKTe4-Rw0ch7y{color:\"[theme:neutralSecondary, default:#666666]\";font-size:14px;font-weight:300}html[dir=ltr] .aRV8La04BKTe4-Rw0ch7y{padding:5px 0 20px 17px}html[dir=rtl] .aRV8La04BKTe4-Rw0ch7y{padding:5px 17px 20px 0}html[dir=ltr] ._10jnOyB1ix5eDN5LL-QTdT{padding-left:18px}html[dir=rtl] ._10jnOyB1ix5eDN5LL-QTdT{padding-right:18px}._9m-_p2uj0CG0M09K1yg09._1FBePb78cXciJSVMJrd_EW{min-width:600px;-ms-flex-wrap:nowrap;flex-wrap:nowrap}html[dir=ltr] ._9m-_p2uj0CG0M09K1yg09._1FBePb78cXciJSVMJrd_EW{margin:0 20px 23px 0}html[dir=rtl] ._9m-_p2uj0CG0M09K1yg09._1FBePb78cXciJSVMJrd_EW{margin:0 0 23px 20px}._9m-_p2uj0CG0M09K1yg09{vertical-align:middle;max-width:700px;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:wrap;flex-wrap:wrap}html[dir] ._9m-_p2uj0CG0M09K1yg09{text-align:center;background-color:\"[theme:white, default:#ffffff]\";border:1px solid \"[theme:neutralLight, default:#eaeaea]\"}html[dir] ._2GRRwLAjjUdSSzHJREO4Y0{background-color:\"[theme:themePrimary, default:#0078D7]\"}._2GRRwLAjjUdSSzHJREO4Y0 img{width:100%}html[dir=rtl] ._2GRRwLAjjUdSSzHJREO4Y0{-webkit-transform:rotateY(180deg);transform:rotateY(180deg)}html[dir] .wCFvnOCFQJBrlRzydtjWh{padding:2px 20px 20px;padding-top:12px}html[dir=ltr] .wCFvnOCFQJBrlRzydtjWh{text-align:left}html[dir=rtl] .wCFvnOCFQJBrlRzydtjWh{text-align:right}._3NnW5LQ1Ukaa07u7prio0L{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-flex:1;-ms-flex:auto;flex:auto;max-width:378px}html[dir] ._3NnW5LQ1Ukaa07u7prio0L{padding:2px 20px 0}html[dir=ltr] ._3NnW5LQ1Ukaa07u7prio0L{text-align:left}html[dir=rtl] ._3NnW5LQ1Ukaa07u7prio0L{text-align:right}._2xUHqUSPMtLXal81-cVN60{display:block;color:\"[theme:themeDarkAlt, default:#005A9E]\"}._2xUHqUSPMtLXal81-cVN60:first-child{font-size:21px;font-weight:300}html[dir] ._2xUHqUSPMtLXal81-cVN60:first-child{padding:5px 0 6px}._2xUHqUSPMtLXal81-cVN60:not(:first-child){font-weight:400;font-size:14px}html[dir] ._2xUHqUSPMtLXal81-cVN60:not(:first-child){padding-bottom:2px}._10je33aiq6ZzlyroWVW1mo{display:block;color:\"[theme:neutralSecondary, default:#666666]\";font-weight:400;font-size:14px}html[dir] ._10je33aiq6ZzlyroWVW1mo{padding-bottom:5px}html[dir] ._10je33aiq6ZzlyroWVW1mo::-moz-selection{background-color:\"[theme:white, default:#ffffff]\"}html[dir] ._10je33aiq6ZzlyroWVW1mo::selection{background-color:\"[theme:white, default:#ffffff]\"}._1dlgggWJTdB7wWG5Tv1irs{display:block;color:\"[theme:neutralSecondary, default:#666666]\"}._1dlgggWJTdB7wWG5Tv1irs:first-child{font-size:21px;font-weight:300}html[dir] ._1dlgggWJTdB7wWG5Tv1irs:first-child{padding-top:5px 0 6px 0}._1dlgggWJTdB7wWG5Tv1irs:not(:first-child){font-weight:400;font-size:14px}html[dir] ._1dlgggWJTdB7wWG5Tv1irs:not(:first-child){padding-bottom:2px}html[dir] ._1dlgggWJTdB7wWG5Tv1irs::-moz-selection{background-color:\"[theme:white, default:#ffffff]\"}html[dir] ._1dlgggWJTdB7wWG5Tv1irs::selection{background-color:\"[theme:white, default:#ffffff]\"}._3OU-lLVf6t75NacO7hst2V{display:block;color:\"[theme:neutralSecondary, default:#666666]\";font-weight:400;font-size:14px}html[dir] ._3OU-lLVf6t75NacO7hst2V{padding-bottom:2px}html[dir] ._3OU-lLVf6t75NacO7hst2V::-moz-selection{background-color:\"[theme:white, default:#ffffff]\"}html[dir] ._3OU-lLVf6t75NacO7hst2V::selection{background-color:\"[theme:white, default:#ffffff]\"}.jwrs5obL6olxvXcjT7ne5{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;color:\"[theme:neutralPrimary, default:#333333]\";-webkit-box-align:center;-ms-flex-align:center;align-items:center}html[dir] .jwrs5obL6olxvXcjT7ne5{border-top:solid 1px \"[theme:neutralLight, default:#eaeaea]\";padding:5px 0 10px}._12k0K_WHgZQv6eLAiJdyu3{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-ms-flex-align:center;align-items:center;font-size:14px;color:\"[theme:neutralPrimary, default:#333333]\";text-decoration:none}html[dir] ._12k0K_WHgZQv6eLAiJdyu3{background-color:\"[theme:white, default:#ffffff]\";margin:10px 0}html[dir=ltr] ._12k0K_WHgZQv6eLAiJdyu3{padding-right:34px}html[dir=rtl] ._12k0K_WHgZQv6eLAiJdyu3{padding-left:34px}.lVMcryD_UMYSYtVQIgM_p{display:-webkit-box;display:-ms-flexbox;display:flex;font-size:14px;color:\"[theme:neutralPrimary, default:#333333]\"}html[dir] .lVMcryD_UMYSYtVQIgM_p{background-color:\"[theme:white, default:#ffffff]\"}._2SXZQvq-ErTuaUR53Oj3bf{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-ms-flex-align:center;align-items:center}html[dir] ._2SXZQvq-ErTuaUR53Oj3bf{background-color:\"[theme:white, default:#ffffff]\";padding:0}.mODgQRUpQ1IZhhqcEjJNX{font-size:16px;-webkit-box-align:center;-ms-flex-align:center;align-items:center}html[dir=ltr] .mODgQRUpQ1IZhhqcEjJNX{padding-left:4px}html[dir=rtl] .mODgQRUpQ1IZhhqcEjJNX{-webkit-transform:rotateY(180deg);transform:rotateY(180deg);padding-right:4px}._3VoB5e_UUjrme08SQWWU4V{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;max-width:280px}html[dir] ._3VoB5e_UUjrme08SQWWU4V{background-color:\"[theme:white, default:#ffffff]\"}html[dir=ltr] ._3VoB5e_UUjrme08SQWWU4V{border-right:solid 1px \"[theme:neutralLight, default:#eaeaea]\"}html[dir=rtl] ._3VoB5e_UUjrme08SQWWU4V{border-left:solid 1px \"[theme:neutralLight, default:#eaeaea]\"}._1BH_RsPteM603ru2W-zrVc{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}html[dir] ._1BH_RsPteM603ru2W-zrVc{background-color:\"[theme:white, default:#ffffff]\"}._3xNeTBxEVZhejMWDGbE_f-{display:-webkit-box;display:-ms-flexbox;min-height:32px;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}html[dir] ._3xNeTBxEVZhejMWDGbE_f-{margin:15px 0 12px}._1u6qAYfWALJMFP5VOhuNyv{font-size:17px}html[dir=ltr] ._1u6qAYfWALJMFP5VOhuNyv{padding-right:20px}html[dir=rtl] ._1u6qAYfWALJMFP5VOhuNyv{padding-left:20px}html[dir] ._2J2-c2-iSVk4Jw3c1ZKj85{border-bottom:\"[theme:neutralLight, default:#eaeaea]\" 1px solid}html[dir] ._3SuVvxJVNKJKJHY_cvM1S2{padding:2px 20px 0;padding-top:12px}html[dir=ltr] ._3SuVvxJVNKJKJHY_cvM1S2{text-align:left}html[dir=rtl] ._3SuVvxJVNKJKJHY_cvM1S2{text-align:right}._2V3fbqJeTBaplYY4nkvbYY{font-size:16px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}html[dir] ._2V3fbqJeTBaplYY4nkvbYY{margin:0 4px}html[dir=rtl] ._2V3fbqJeTBaplYY4nkvbYY{-webkit-transform:rotateY(180deg);transform:rotateY(180deg)}.isGDPjqyBOevfGw5MQjYq{font-size:22px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}html[dir] .isGDPjqyBOevfGw5MQjYq{margin:0 4px}html[dir=rtl] .isGDPjqyBOevfGw5MQjYq{-webkit-transform:rotateY(180deg);transform:rotateY(180deg)}._3LLt-aplAMWL3CdhfRY14c{width:32px;height:25px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}._1fEjw3APxfnJsa_5_izGTG,._3LLt-aplAMWL3CdhfRY14c{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._1fEjw3APxfnJsa_5_izGTG{width:320px}html[dir] ._1fEjw3APxfnJsa_5_izGTG{margin-top:43px}", ""]);

// exports
exports.locals = {
	"busStop": "rfmHYSZ8tCwsa4WKyO0nX",
	"busStopFirstLine": "SdA_nWXiU61WtlgfApo_6",
	"busStopFirstLineExpand": "kMMwcA1h64ZWp6Z8eW6GI",
	"busStopLabel": "GTliPpS7B77m00_Xwy9lB",
	"busStopText": "_3uK6beu6Jgt8VCNo7ocWEO",
	"userVoiceButton": "ENraeCKRqCzLXoO4bMwaP",
	"userVoiceContainer": "_1YTUxVFUXAG3RBRRQ7I0-0",
	"userVoiceButtonsContainer": "_289W9PMieBOGfSSccVBJee",
	"smallText": "_2PJi9reZDih6ZdA98rzDSX",
	"busStopIcon": "_1CbccnL0oU2gFH24Og3DWF",
	"collapsedText": "aRV8La04BKTe4-Rw0ch7y",
	"cardInBusStop": "_10jnOyB1ix5eDN5LL-QTdT",
	"expandedCard": "_9m-_p2uj0CG0M09K1yg09",
	"horizontalExpandedCard": "_1FBePb78cXciJSVMJrd_EW",
	"imageMail": "_2GRRwLAjjUdSSzHJREO4Y0",
	"summaryLines": "wCFvnOCFQJBrlRzydtjWh",
	"detailsContainer": "_3NnW5LQ1Ukaa07u7prio0L",
	"summaryLabel": "_2xUHqUSPMtLXal81-cVN60",
	"detailsLabel": "_10je33aiq6ZzlyroWVW1mo",
	"summaryLabelPeek": "_1dlgggWJTdB7wWG5Tv1irs",
	"detailsLabelPeek": "_3OU-lLVf6t75NacO7hst2V",
	"containerButtons": "jwrs5obL6olxvXcjT7ne5",
	"viewButton": "_12k0K_WHgZQv6eLAiJdyu3",
	"actionButtonText": "lVMcryD_UMYSYtVQIgM_p",
	"actionButton": "_2SXZQvq-ErTuaUR53Oj3bf",
	"buttonImage": "mODgQRUpQ1IZhhqcEjJNX",
	"txpCardSummary": "_3VoB5e_UUjrme08SQWWU4V",
	"txpPeekCardSummary": "_1BH_RsPteM603ru2W-zrVc",
	"peekDataRow": "_3xNeTBxEVZhejMWDGbE_f-",
	"iconLocation": "_1u6qAYfWALJMFP5VOhuNyv",
	"peekDetails": "_2J2-c2-iSVk4Jw3c1ZKj85",
	"PeekCardSummaryLines": "_3SuVvxJVNKJKJHY_cvM1S2",
	"peekPlane": "_2V3fbqJeTBaplYY4nkvbYY",
	"plane": "isGDPjqyBOevfGw5MQjYq",
	"peekDataRowIcon": "_3LLt-aplAMWL3CdhfRY14c",
	"spinner": "_1fEjw3APxfnJsa_5_izGTG"
};

/***/ }),

/***/ 4169:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var Image_1 = __webpack_require__(344);
var getPackageBaseUrl_1 = __webpack_require__(224);
var React = __webpack_require__(3);
var url_1 = __webpack_require__(155);
var mobx_react_1 = __webpack_require__(11);
var owa_accessibility_1 = __webpack_require__(79);
var merge_styles_1 = __webpack_require__(75);
var styles = __webpack_require__(2748);
var classNames = __webpack_require__(30).bind(styles);
var Summary = /** @class */ (function (_super) {
    tslib_1.__extends(Summary, _super);
    function Summary() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Summary.prototype.render = function () {
        var _a = this.props, lines = _a.lines, imageSource = _a.imageSource, txpStyle = _a.txpStyle;
        var imageClassName = txpStyle.imageClassName;
        // use imageClassName if there is one, if not- create classname with the txpColor
        var imageColor = imageClassName
            ? imageClassName
            : merge_styles_1.mergeStyles({
                background: txpStyle.txpColor,
            });
        var ariaProps = {
            role: owa_accessibility_1.AriaRoles.presentation,
        };
        var summaryLines = lines.map(function (text, index) {
            if (text) {
                return (React.createElement("label", { key: index, className: txpStyle.summaryLabel }, text));
            }
            else {
                return null;
            }
        });
        return (React.createElement("div", { className: txpStyle.cardSummaryContainer, role: "listitem" },
            React.createElement(Image_1.Image, tslib_1.__assign({ alt: "" }, owa_accessibility_1.generateDomPropertiesForAria(ariaProps), { className: classNames(imageColor), shouldFadeIn: false, shouldStartVisible: true, src: url_1.resolve(getPackageBaseUrl_1.default(), imageSource) })),
            React.createElement("div", { className: classNames(txpStyle.cardSummaryLines, 'allowTextSelection') }, summaryLines)));
    };
    Summary = tslib_1.__decorate([
        mobx_react_1.observer
    ], Summary);
    return Summary;
}(React.Component));
exports.default = Summary;
//# sourceMappingURL=Summary.js.map

/***/ }),

/***/ 4170:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(11);
var owa_location_persona_1 = __webpack_require__(4171);
var Icon_1 = __webpack_require__(43);
var styles = __webpack_require__(2748);
var TxpLocation = /** @class */ (function (_super) {
    tslib_1.__extends(TxpLocation, _super);
    function TxpLocation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TxpLocation.prototype.render = function () {
        var _a = this.props, txpLocation = _a.txpLocation, showLocationDisplay = _a.showLocationDisplay;
        var txpLocationDisplay = showLocationDisplay
            ? owa_location_persona_1.getLocationDisplayWithAddressText(txpLocation.DisplayName, txpLocation.PostalAddress)
            : txpLocation.DisplayName;
        return (React.createElement("div", { className: styles.peekDataRow },
            React.createElement("div", { className: styles.peekDataRowIcon },
                React.createElement(Icon_1.Icon, { iconName: "Poi" /* Poi */, className: styles.iconLocation })),
            React.createElement("div", { className: styles.peekDataRowValue },
                React.createElement(owa_location_persona_1.LocationCardWrapper, { name: txpLocation.DisplayName, postalAddress: txpLocation.PostalAddress, key: txpLocation.Id },
                    React.createElement("span", null, txpLocationDisplay)))));
    };
    TxpLocation = tslib_1.__decorate([
        mobx_react_1.observer
    ], TxpLocation);
    return TxpLocation;
}(React.Component));
exports.default = TxpLocation;
//# sourceMappingURL=TxpLocation.js.map

/***/ }),

/***/ 4171:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getLocationPostalAddress_1 = __webpack_require__(3569);
exports.getLocationPostalAddress = getLocationPostalAddress_1.getLocationPostalAddress;
var getLocationDisplayText_1 = __webpack_require__(3570);
exports.getLocationDisplayText = getLocationDisplayText_1.getLocationDisplayText;
var getLocationDisplayWithAddressText_1 = __webpack_require__(4173);
exports.getLocationDisplayWithAddressText = getLocationDisplayWithAddressText_1.getLocationDisplayWithAddressText;
var getLocalizedAddress_1 = __webpack_require__(2988);
exports.getLocalizedAddress = getLocalizedAddress_1.getLocalizedAddress;
var createLocationPersonaFromStringLocation_1 = __webpack_require__(4174);
exports.createLocationPersonaFromStringLocation = createLocationPersonaFromStringLocation_1.createLocationPersonaFromStringLocation;
var createLocationPersonaFromPersonaType_1 = __webpack_require__(4175);
exports.createLocationPersonaFromPersonaType = createLocationPersonaFromPersonaType_1.createLocationPersonaFromPersonaType;
var LocationPersonaControl_1 = __webpack_require__(3572);
exports.LocationPersonaControl = LocationPersonaControl_1.LocationPersonaControl;
var LocationCardWrapper_1 = __webpack_require__(4177);
exports.LocationCardWrapper = LocationCardWrapper_1.LocationCardWrapper;
var LocationCard_1 = __webpack_require__(4182);
exports.LocationCard = LocationCard_1.LocationCard;
var isBingPlace_1 = __webpack_require__(4183);
exports.isBingPlace = isBingPlace_1.default;
var isEnhancedLocation_1 = __webpack_require__(3146);
exports.isEnhancedLocation = isEnhancedLocation_1.default;
var isRoom_1 = __webpack_require__(3575);
exports.isRoom = isRoom_1.default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 4172:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getUserConfiguration_1 = __webpack_require__(9);
var owa_string_utils_1 = __webpack_require__(2627);
/**
 * Default localeId in case we fail locale lookup
 */
var DefaultLocaleId = 'en-us';
/**
 * Disctionary of locale to field order mapping.
 */
var LocalFieldOrderMapping = {
    'am-et': 'a_c_pc_pr_ctry',
    'ar-dz': 'a_pc_c_pr_ctry',
    'ar-bh': 'a_pc_c_pr_ctry',
    'ar-eg': 'a_ctry_c_pr_pc',
    'ar-iq': 'a_pc_c_pr_ctry',
    'ar-jo': 'a_c_pc_pr_ctry',
    'ar-kw': 'a_pc_c_pr_ctry',
    'ar-lb': 'a_c_pc_pr_ctry',
    'ar-ly': 'a_pc_c_pr_ctry',
    'ar-ma': 'a_pc_c_pr_ctry',
    'ar-om': 'a_c_pr_ctry_pc',
    'ar-qa': 'a_pc_c_pr_ctry',
    'ar-sa': 'a_c_pc_pr_ctry',
    'ar-sy': 'a_pc_c_pr_ctry',
    'ar-tn': 'a_pc_c_pr_ctry',
    'ar-ae': 'a_pc_c_pr_ctry',
    'ar-ye': 'a_pc_c_pr_ctry',
    'eu-es': 'a_pc_c_pr_ctry',
    'bn-in': 'a_c_pc_pr_ctry',
    'bg-bg': 'a_pc_c_pr_ctry',
    'ca-es': 'a_pc_c_pr_ctry',
    'zh-cn': 'pc_ctry_pr_c_a',
    'zh-sg': 'a_c_pc_pr_ctry',
    'zh-hk': 'ctry_pc_pr_c_a',
    'zh-mo': 'ctry_pr_c_pc_a',
    'zh-tw': 'pc_ctry_pr_c_a',
    'hr-hr': 'a_pc_c_pr_ctry',
    'cs-cz': 'a_pc_c_pr_ctry',
    'da-dk': 'a_pc_c_pr_ctry',
    'nl-be': 'a_pc_c_pr_ctry',
    'nl-nl': 'a_pc_c_pr_ctry',
    'en-au': 'a_c_pc_pr_ctry',
    'en-bz': 'a_pc_c_pr_ctry',
    'en-ca': 'a_c_pc_pr_ctry',
    'en-ie': 'a_c_pc_pr_ctry',
    'en-jm': 'a_pc_c_pr_ctry',
    'en-nz': 'a_c_pc_pr_ctry',
    'en-ph': 'a_pc_pr_c_ctry',
    'en-za': 'a_c_pc_pr_ctry',
    'en-tt': 'a_pc_c_pr_ctry',
    'en-gb': 'a_c_pc_pr_ctry',
    'en-us': 'a_c_pr_pc_ctry',
    'en-zw': 'a_pc_c_pr_ctry',
    'et-ee': 'a_pc_c_pr_ctry',
    'fil-ph': 'a_pc_pr_c_ctry',
    'fi-fi': 'a_pc_c_pr_ctry',
    'fr-be': 'a_pc_c_pr_ctry',
    'fr-ca': 'a_c_pc_pr_ctry',
    'fr-fr': 'a_pc_c_pr_ctry',
    'fr-lu': 'a_pc_c_pr_ctry',
    'fr-mc': 'a_pc_c_pr_ctry',
    'fr-ch': 'a_pc_c_pr_ctry',
    'gl-es': 'a_pc_c_pr_ctry',
    'de-at': 'a_pc_c_pr_ctry',
    'de-de': 'a_pc_c_pr_ctry',
    'de-li': 'a_pc_c_pr_ctry',
    'de-lu': 'a_pc_c_pr_ctry',
    'de-ch': 'a_pc_c_pr_ctry',
    'el-gr': 'a_pc_c_pr_ctry',
    'gu-in': 'a_c_pc_pr_ctry',
    'he-il': 'a_pc_c_pr_ctry',
    'hi-in': 'a_c_pc_pr_ctry',
    'hu-hu': 'c_a_pc_pr_ctry',
    'is-is': 'a_pc_c_pr_ctry',
    'id-id': 'a_c_pc_pr_ctry',
    'it-it': 'a_pc_c_pr_ctry',
    'it-ch': 'a_pc_c_pr_ctry',
    'ja-jp': 'pc_pr_c_a_ctry',
    'kn-in': 'a_c_pc_pr_ctry',
    'kk-kz': 'ctry_pr_c_pc_a',
    'sw-ke': 'a_c_pc_pr_ctry',
    'ko-kr': 'pc_pr_c_a_ctry',
    'lv-lv': 'a_c_pc_pr_ctry',
    'lt-lt': 'a_c_pc_pr_ctry',
    'ms-bn': 'a_c_pc_pr_ctry',
    'ms-my': 'a_pc_c_pr_ctry',
    'ml-in': 'a_c_pc_pr_ctry',
    'mr-in': 'a_c_pc_pr_ctry',
    'nb-no': 'a_pc_c_pr_ctry',
    'or-in': 'a_c_pc_pr_ctry',
    'fa-ir': 'a_c_pc_pr_ctry',
    'pl-pl': 'a_pc_c_pr_ctry',
    'pt-br': 'a_pc_c_pr_ctry',
    'pt-pt': 'a_pc_c_pr_ctry',
    'ro-ro': 'a_pc_c_pr_ctry',
    'ru-ru': 'ctry_pc_pr_c_a',
    'sr-cyrl-cs': 'a_pc_c_pr_ctry',
    'sk-sk': 'a_pc_c_pr_ctry',
    'sl-si': 'a_pc_c_pr_ctry',
    'es-ar': 'a_pc_c_pr_ctry',
    'es-bo': 'a_pc_c_pr_ctry',
    'es-cl': 'a_pc_c_pr_ctry',
    'es-co': 'a_pc_c_pr_ctry',
    'es-cr': 'a_pc_c_pr_ctry',
    'es-do': 'a_pc_c_pr_ctry',
    'es-ec': 'a_pc_c_pr_ctry',
    'es-sv': 'a_c_pc_pr_ctry',
    'es-gt': 'a_pc_c_pr_ctry',
    'es-hn': 'a_pc_c_pr_ctry',
    'es-mx': 'a_pc_c_pr_ctry',
    'es-ni': 'a_c_pc_pr_ctry',
    'es-pa': 'a_pc_c_pr_ctry',
    'es-py': 'a_pc_c_pr_ctry',
    'es-pe': 'a_pc_c_pr_ctry',
    'es-pr': 'a_c_pc_pr_ctry',
    'es-es': 'a_pc_c_pr_ctry',
    'es-us': 'a_c_pc_pr_ctry',
    'es-uy': 'a_pc_c_pr_ctry',
    'es-ve': 'a_pc_c_pr_ctry',
    'sv-fi': 'a_pc_c_pr_ctry',
    'sv-se': 'a_pc_c_pr_ctry',
    'ta-in': 'a_c_pc_pr_ctry',
    'te-in': 'a_c_pc_pr_ctry',
    'th-th': 'a_c_pc_pr_ctry',
    'tr-tr': 'a_pc_pr_c_ctry',
    'uk-ua': 'ctry_pc_pr_c_a',
    'ur-pk': 'a_c_pc_pr_ctry',
    'cy-gb': 'a_c_pc_pr_ctry',
};
/**
 * gets the appropriate fields order for the locale; if mapping is not found, then use mapping for default locale
 */
function getLocalFieldsOrder() {
    var userConfiguration = getUserConfiguration_1.default();
    var localeId = '';
    if (userConfiguration &&
        userConfiguration.SessionSettings &&
        !owa_string_utils_1.isNullOrWhiteSpace(userConfiguration.SessionSettings.UserCulture)) {
        localeId = userConfiguration.SessionSettings.UserCulture.toLowerCase();
    }
    // Fetch the appropriate fields order for the locale; if mapping is not found, then use mapping for default locale
    var fieldsOrder = LocalFieldOrderMapping[localeId];
    if (fieldsOrder == null) {
        fieldsOrder = LocalFieldOrderMapping[DefaultLocaleId];
    }
    return fieldsOrder;
}
exports.default = getLocalFieldsOrder;
//# sourceMappingURL=getLocalFieldsOrder.js.map

/***/ }),

/***/ 4173:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_strings_1 = __webpack_require__(20);
var getLocalizedAddress_1 = __webpack_require__(2988);
var owa_string_utils_1 = __webpack_require__(2627);
/**
 * Gets the Location display text from the location persona.
 * It is the display name of the location if present, the a localized postal address otherwise
 * @param postalAddress: the location persona
 * @param displayName: the location displayName
 */
function getLocationDisplayWithAddressText(displayName, postalAddress) {
    var postalAddressText = getLocalizedAddress_1.getLocalizedAddress(postalAddress);
    return owa_string_utils_1.isNullOrWhiteSpace(displayName)
        ? postalAddressText
        : postalAddressText == ''
            ? displayName
            : owa_strings_1.format('{0} ({1})', displayName, getLocalizedAddress_1.getLocalizedAddress(postalAddress));
}
exports.getLocationDisplayWithAddressText = getLocationDisplayWithAddressText;
//# sourceMappingURL=getLocationDisplayWithAddressText.js.map

/***/ }),

/***/ 4174:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getInitial_1 = __webpack_require__(3266);
var getTextBoyColor_1 = __webpack_require__(3267);
/**
 * Create a dummy Persona for string locations to show String locations as resolved entity
 * @param locationName: location displayName
 */
function createLocationPersonaFromStringLocation(locationName) {
    var postalAddress = createDefaultPostalAddress();
    return {
        displayName: locationName,
        postalAddress: postalAddress,
        displayAddress: '',
        initials: getInitial_1.default(locationName),
        textBoyColor: getTextBoyColor_1.default(locationName),
        personaBlob: createStringLocationPersonaBlob(),
        selectionSource: 'String',
        personaType: 'Unknown',
        personaControlId: locationName,
    };
}
exports.createLocationPersonaFromStringLocation = createLocationPersonaFromStringLocation;
/**
 * Creates a persona blob for a location with no map. This will represent the state of the persona blob after a fech photo would complete
 */
function createStringLocationPersonaBlob() {
    //  Personas with no photos would have hasFetchFailed= true after the feth complete.
    return {
        blobUrl: null,
        isPendingFetch: false,
        hasFetchFailed: true,
    };
}
/**
 * Creates a default postal address of Type "Home" and location soure "None"
 */
function createDefaultPostalAddress() {
    return {
        Type: 'Business',
        LocationSource: 'None',
    };
}
//# sourceMappingURL=createLocationPersonaFromStringLocation.js.map

/***/ }),

/***/ 4175:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var createNewPersonaBlob_1 = __webpack_require__(3571);
var getInitial_1 = __webpack_require__(3266);
var getTextBoyColor_1 = __webpack_require__(3267);
var getLocalizedAddress_1 = __webpack_require__(2988);
var getLocationDisplayText_1 = __webpack_require__(3570);
var getLocationPostalAddress_1 = __webpack_require__(3569);
var owa_string_utils_1 = __webpack_require__(2627);
/**
 * Create location persona from a personaType
 * @param persona: the persona type
 */
function createLocationPersonaFromPersonaType(persona) {
    if (persona) {
        var postalAddress = getLocationPostalAddress_1.getLocationPostalAddress(persona);
        var displayText = getLocationDisplayText_1.getLocationDisplayText(persona.DisplayName, postalAddress);
        return {
            displayName: displayText,
            postalAddress: postalAddress,
            displayAddress: getLocalizedAddress_1.getLocalizedAddress(postalAddress),
            initials: getInitial_1.default(displayText),
            textBoyColor: getTextBoyColor_1.default(displayText),
            personaBlob: createNewPersonaBlob_1.default(),
            selectionSource: 'LocationWell',
            personaType: owa_string_utils_1.isNullOrWhiteSpace(persona.PersonaTypeString)
                ? 'Unknown'
                : persona.PersonaTypeString,
            personaControlId: persona.PersonaId == null ? persona.FeedbackId : persona.PersonaId.Id,
        };
    }
    return null;
}
exports.createLocationPersonaFromPersonaType = createLocationPersonaFromPersonaType;
//# sourceMappingURL=createLocationPersonaFromPersonaType.js.map

/***/ }),

/***/ 4176:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var calculateMapUrl_1 = __webpack_require__(3573);
var legacy_1 = __webpack_require__(1);
var owa_string_utils_1 = __webpack_require__(2627);
var owa_trace_1 = __webpack_require__(14);
var minBlobSize = 100;
var defaultPhotoWidth = 64;
var defaultPhotoHeight = 64;
/**
 * Download the persona map for the specified place
 * @param viewState: the location persona control view state
 */
function downloadLocationPhoto(viewState) {
    var photoUrl = calculateMapUrl_1.default(viewState, defaultPhotoWidth, defaultPhotoHeight);
    if (!owa_string_utils_1.isNullOrWhiteSpace(photoUrl)) {
        var personaBlob_1 = viewState.personaBlob;
        personaBlob_1.isPendingFetch = true;
        var request_1 = new XMLHttpRequest();
        request_1.open('GET', photoUrl, true);
        request_1.responseType = 'blob';
        request_1.onreadystatechange = function () {
            if (request_1.readyState === 4) {
                var blob_1 = null;
                var isBlob_1 = false;
                if (request_1.status === 200) {
                    blob_1 = request_1.response;
                    var contentType = request_1.getResponseHeader('Content-Type');
                    isBlob_1 =
                        contentType &&
                            contentType.toLowerCase().indexOf('image') == 0 &&
                            blob_1 instanceof Blob;
                }
                legacy_1.action('getLocationPhoto:getLocationPhotoCallback')(function () {
                    if (isBlob_1 && blob_1 && blob_1.size > minBlobSize) {
                        personaBlob_1.blobUrl = URL.createObjectURL(blob_1);
                    }
                    else {
                        personaBlob_1.hasFetchFailed = true;
                        // Log that we failed to fetch the location photo. Not logging url for now, will add if we see enough number of errors
                        owa_trace_1.trace.warn('getLocationPhoto.downloadLocationPhoto failed');
                    }
                    personaBlob_1.isPendingFetch = false;
                })();
            }
        };
        request_1.send();
    }
}
/**
 * Action to get the location map
 */
exports.default = legacy_1.action('getLocationPhoto')(function getLocationPhoto(viewState) {
    if (viewState) {
        var personaBlob = viewState.personaBlob;
        if (personaBlob.isPendingFetch ||
            personaBlob.hasFetchFailed ||
            !owa_string_utils_1.isNullOrWhiteSpace(personaBlob.blobUrl)) {
            // If it already has a pending request or feth has completed, simply return.
            // when fetch is compteled the blob either have a blobUrl or maked as failed
            return;
        }
        downloadLocationPhoto(viewState);
    }
});
//# sourceMappingURL=getLocationPhoto.js.map

/***/ }),

/***/ 4177:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var HoverCard_1 = __webpack_require__(3268);
var createLocationPersonaFromPostalAddress_1 = __webpack_require__(3574);
var isEnhancedLocation_1 = __webpack_require__(3146);
var isRoom_1 = __webpack_require__(3575);
var LocationCompactCard_1 = __webpack_require__(3576);
var LocationExpandedCard_1 = __webpack_require__(3577);
var styles = __webpack_require__(4180);
var LocationCardWrapper = /** @class */ (function (_super) {
    tslib_1.__extends(LocationCardWrapper, _super);
    function LocationCardWrapper(props) {
        var _this = _super.call(this, props) || this;
        _this.onRenderCompactCard = function (locationPersona) {
            return React.createElement(LocationCompactCard_1.default, { locationPersona: locationPersona });
        };
        var _a = _this.props, postalAddress = _a.postalAddress, name = _a.name;
        var expandedCardHeight = 0;
        if (postalAddress.Street || postalAddress.LocationUri) {
            expandedCardHeight += 110;
        }
        if (postalAddress.Latitude && postalAddress.Longitude) {
            expandedCardHeight += 217;
        }
        _this.state = {
            expandingCardProps: {
                compactCardHeight: 93,
                expandedCardHeight: expandedCardHeight,
                onRenderCompactCard: _this.onRenderCompactCard,
                onRenderExpandedCard: _this.onRenderExpandedCard,
            },
            locationPersona: createLocationPersonaFromPostalAddress_1.default(postalAddress, name),
        };
        return _this;
    }
    LocationCardWrapper.prototype.render = function () {
        if (isEnhancedLocation_1.default(this.props.postalAddress) && !isRoom_1.default(this.props.postalAddress)) {
            return (React.createElement(HoverCard_1.HoverCard, { cardDismissDelay: 300, trapFocus: true, expandingCardProps: tslib_1.__assign({ renderData: this.state.locationPersona }, this.state.expandingCardProps), instantOpenOnClick: true },
                React.createElement("span", { className: styles.enhancedLocation, tabIndex: 0 }, this.props.children)));
        }
        return (React.createElement("span", null, this.props.children));
    };
    LocationCardWrapper.prototype.onRenderExpandedCard = function (locationPersona) {
        return React.createElement(LocationExpandedCard_1.default, { locationPersona: locationPersona });
    };
    return LocationCardWrapper;
}(React.Component));
exports.LocationCardWrapper = LocationCardWrapper;
//# sourceMappingURL=LocationCardWrapper.js.map

/***/ }),

/***/ 4178:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, "._3SRVqlMwVKW0w0VZl77g76{width:340px}html[dir=ltr] ._2OvZmh-0BiuPxNTb5J98xX{margin:20px 0 20px 24px}html[dir=rtl] ._2OvZmh-0BiuPxNTb5J98xX{margin:20px 24px 20px 0}html[dir] ._2c1i2ELSiQktyxatzd9vHK{padding:20px 24px;border-top:1px solid \"[theme:neutralLighter, default:#f4f4f4]\"}._33CDw2t5v7AndiNX92OY6-{font-weight:600;font-size:14px}html[dir] ._33CDw2t5v7AndiNX92OY6-{margin-bottom:12px}._2hEXVSinzMceHihGt6STlF{color:\"[theme:themePrimary, default:#0078D7]\";cursor:pointer}html[dir] ._2hEXVSinzMceHihGt6STlF{background-color:transparent}html[dir] ._2mZlMhalsU5to4oln7LSUq{margin-top:3px}html[dir=ltr] ._2mZlMhalsU5to4oln7LSUq{float:left}html[dir=rtl] ._2mZlMhalsU5to4oln7LSUq{float:right}._1NpSflk0clKv_NdiVPO5AP{width:244px;vertical-align:middle}html[dir=ltr] ._1NpSflk0clKv_NdiVPO5AP{float:left;margin-left:12px;text-align:left}html[dir=rtl] ._1NpSflk0clKv_NdiVPO5AP{float:right;margin-right:12px;text-align:right}._3hNx7DIIQc9q8nTkG4U3tl{clear:both}", ""]);

// exports
exports.locals = {
	"container": "_3SRVqlMwVKW0w0VZl77g76",
	"persona": "_2OvZmh-0BiuPxNTb5J98xX",
	"cardSection": "_2c1i2ELSiQktyxatzd9vHK",
	"sectionHeader": "_33CDw2t5v7AndiNX92OY6-",
	"linkToBing": "_2hEXVSinzMceHihGt6STlF",
	"icon": "_2mZlMhalsU5to4oln7LSUq",
	"informationRow": "_1NpSflk0clKv_NdiVPO5AP",
	"clearFix": "_3hNx7DIIQc9q8nTkG4U3tl"
};

/***/ }),

/***/ 4179:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_strings_1 = __webpack_require__(20);
var FULL_DETAILS_URL_FORMAT = 'https://www.bing.com/maps?v=2&rtp=~pos.{0}_{1}_{2}_{3}';
var ADDRESS_ONLY_URL_FORMAT = 'https://www.bing.com/maps?v=2&rtp=~adr.{0}_{1}';
/**
 * Gets the Bing directions url for a given postal address
 * @param postalAddress: The postal address to calculate the Bing url from.
 * @param name: The name of the postal address.
 */
function default_1(postalAddress, name) {
    if (postalAddress) {
        var Latitude = postalAddress.Latitude, Longitude = postalAddress.Longitude, FormattedAddress = postalAddress.FormattedAddress;
        if (Latitude && Longitude) {
            return owa_strings_1.format(FULL_DETAILS_URL_FORMAT, Latitude, Longitude, FormattedAddress, name);
        }
        if (FormattedAddress) {
            return owa_strings_1.format(ADDRESS_ONLY_URL_FORMAT, FormattedAddress, name);
        }
    }
    return null;
}
exports.default = default_1;
//# sourceMappingURL=getBingUrl.js.map

/***/ }),

/***/ 4180:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(4181);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 4181:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, "html[dir] ._3HOiTO5sQxEVdnUnjLSqcW{background:transparent}html[dir=ltr] ._3HOiTO5sQxEVdnUnjLSqcW{text-align:left}html[dir=rtl] ._3HOiTO5sQxEVdnUnjLSqcW{text-align:right}._2pUQIvnCjGQkHkqxQ1LO23{color:\"[theme:themePrimary, default:#0078D7]\";cursor:pointer}", ""]);

// exports
exports.locals = {
	"location": "_3HOiTO5sQxEVdnUnjLSqcW",
	"enhancedLocation": "_2pUQIvnCjGQkHkqxQ1LO23"
};

/***/ }),

/***/ 4182:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var Callout_1 = __webpack_require__(776);
var mobx_react_1 = __webpack_require__(11);
var createLocationPersonaFromPostalAddress_1 = __webpack_require__(3574);
var LocationCompactCard_1 = __webpack_require__(3576);
var LocationExpandedCard_1 = __webpack_require__(3577);
var styles = __webpack_require__(3273);
var LocationCard = /** @class */ (function (_super) {
    tslib_1.__extends(LocationCard, _super);
    function LocationCard(props) {
        var _this = _super.call(this, props) || this;
        _this.locationPersona = createLocationPersonaFromPostalAddress_1.default(props.postalAddress, props.name);
        return _this;
    }
    LocationCard.prototype.render = function () {
        var _a = this.props, target = _a.target, onDismiss = _a.onDismiss;
        return (React.createElement(Callout_1.Callout, { isBeakVisible: false, target: target, onDismiss: onDismiss, setInitialFocus: true },
            React.createElement("div", { className: styles.container, onMouseLeave: onDismiss },
                React.createElement(LocationCompactCard_1.default, { locationPersona: this.locationPersona }),
                React.createElement(LocationExpandedCard_1.default, { locationPersona: this.locationPersona }))));
    };
    LocationCard = tslib_1.__decorate([
        mobx_react_1.observer
    ], LocationCard);
    return LocationCard;
}(React.Component));
exports.LocationCard = LocationCard;
//# sourceMappingURL=LocationCard.js.map

/***/ }),

/***/ 4183:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var isEnhancedLocation_1 = __webpack_require__(3146);
function isBingPlace(postalAddress) {
    return (isEnhancedLocation_1.default(postalAddress) &&
        (postalAddress.LocationSource === 'LocationServices' ||
            postalAddress.LocationSource === 'PhonebookServices' ||
            postalAddress.LocationSource === 'Device'));
}
exports.default = isBingPlace;
//# sourceMappingURL=isBingPlace.js.map

/***/ }),

/***/ 4184:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var createEntitiesPrimaryHash_1 = __webpack_require__(4185);
var createCardsWithBusStop_1 = __webpack_require__(4186);
var createCardsNoBusStop_1 = __webpack_require__(4206);
var TxpConstants_1 = __webpack_require__(161);
function populateViewCards(txpParsedObject, calendarEventIds, source, showEnhancedLocation) {
    if (txpParsedObject) {
        var cardItems = [];
        var activities = txpParsedObject.txpActivities;
        var entities = txpParsedObject.txpEntities;
        var entitiesPrimaryHash = createEntitiesPrimaryHash_1.default(activities);
        var isBusStopEnabled = Object.keys(entitiesPrimaryHash).length > TxpConstants_1.BUS_STOP_THRESHOLD;
        if (activities && entities && entitiesPrimaryHash) {
            cardItems = isBusStopEnabled
                ? createCardsWithBusStop_1.default(activities, entities, source, showEnhancedLocation, calendarEventIds)
                : createCardsNoBusStop_1.default(activities, entities, entitiesPrimaryHash, source, showEnhancedLocation, calendarEventIds);
            return {
                cardItems: cardItems,
                isBusStopEnabled: isBusStopEnabled,
            };
        }
    }
    return null;
}
exports.default = populateViewCards;
//# sourceMappingURL=PopulateViewCards.js.map

/***/ }),

/***/ 4185:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Role_1 = __webpack_require__(3578);
function createEntitiesPrimaryHash(activities) {
    if (activities) {
        var mapEntitiesActivities_1 = {};
        activities.forEach(function (activityItem) {
            if (activityItem) {
                if (activityItem.role == Role_1.default.Primary) {
                    var entityId = activityItem.entityId;
                    if (mapEntitiesActivities_1[entityId]) {
                        mapEntitiesActivities_1[entityId] += 1;
                    }
                    else {
                        mapEntitiesActivities_1[entityId] = 1;
                    }
                }
            }
        });
        return mapEntitiesActivities_1;
    }
    return null;
}
exports.default = createEntitiesPrimaryHash;
//# sourceMappingURL=createEntitiesPrimaryHash.js.map

/***/ }),

/***/ 4186:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CreateCardItem_1 = __webpack_require__(3579);
function createCardsWithBusStop(activities, entities, source, showLocation, calendarEventIds) {
    var cardItems = [];
    activities.forEach(function (activityItem) {
        var currentEntity = entities[activityItem.entityId];
        var card = CreateCardItem_1.default(activityItem, currentEntity, true, source, showLocation, null, calendarEventIds);
        cardItems.push(card);
    });
    return cardItems;
}
exports.default = createCardsWithBusStop;
//# sourceMappingURL=createCardsWithBusStop.js.map

/***/ }),

/***/ 4187:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var populateFlightBusStopData_1 = __webpack_require__(4188);
var ActivityType_1 = __webpack_require__(2747);
var EntityType_1 = __webpack_require__(2734);
var differenceInSeconds = __webpack_require__(248);
var isAfter = __webpack_require__(781);
var abbreviated_1 = __webpack_require__(3580);
var owa_strings_1 = __webpack_require__(20);
var owa_txp_strings_1 = __webpack_require__(2703);
var TxpSource_1 = __webpack_require__(691);
var TxpConstants_1 = __webpack_require__(161);
var TailoredActionName_1 = __webpack_require__(684);
var owa_datetime_1 = __webpack_require__(207);
// Extracts the flight specific data needed for displaying the card
function createFlightCard(flightEntity, isBusStop, activityId, txpSource, calendarEventId) {
    var seat;
    var actionUrl;
    var actionButtonText;
    var actionIconName;
    var isFutureFlight = false;
    var summaryFirstLine = owa_strings_1.format(owa_txp_strings_1.default.flightSummaryFirstLine, flightEntity.arrivalAirport.city);
    var summarySecondLine = owa_strings_1.format(owa_txp_strings_1.default.flightSummarySecondLine, flightEntity.airline.name, flightEntity.airline.iataCode, flightEntity.flightNumber);
    var summaryThirdLine = flightEntity.reservationId &&
        owa_strings_1.format(owa_txp_strings_1.default.flightSummaryThirdLine, flightEntity.reservationId);
    var summaryFourthLine;
    var imageSource = txpSource == TxpSource_1.default.CalendarPeek
        ? TxpConstants_1.VERTICAL_FLIGHT_LIGHT
        : TxpConstants_1.FLIGHT_ILLUSTRATION;
    var departureTime = flightEntity.departureTime;
    var arrivalTime = flightEntity.arrivalTime;
    var busStopData;
    var departureIATA = flightEntity.departureAirport.iataCode;
    var departsCity = flightEntity.departureAirport.city;
    var departureDisplayDate = owa_datetime_1.parseIsoDate(departureTime);
    var departureTimeDisplayText = owa_datetime_1.formatUserTime(departureDisplayDate);
    var departureDateAriaText = owa_datetime_1.formatWeekDayMonthDayYear(departureDisplayDate);
    var departureDateDisplayText = owa_datetime_1.formatMonthDay(departureDisplayDate);
    var departureTerminalGate = extractTerminalGate(flightEntity.departureTerminal, flightEntity.departureGate);
    var arrivalIATA = flightEntity.arrivalAirport.iataCode;
    var arrivalCity = flightEntity.arrivalAirport.city;
    var arrivalDisplayDate = owa_datetime_1.parseIsoDate(arrivalTime);
    var arrivalTimeDisplayText = owa_datetime_1.formatUserTime(arrivalDisplayDate);
    var arrivalDateAriaText = owa_datetime_1.formatWeekDayMonthDayYear(arrivalDisplayDate);
    var arrivalDateDisplayText = owa_datetime_1.formatMonthDay(arrivalDisplayDate);
    var arrivalTerminalGate = extractTerminalGate(flightEntity.arrivalTerminal, flightEntity.arrivalGate);
    var ariaText = owa_strings_1.format(owa_txp_strings_1.default.flightDepartureArrivalAriaText, departureTimeDisplayText, departureDateAriaText, departsCity, departureIATA, arrivalTimeDisplayText, arrivalDateAriaText, arrivalCity, arrivalIATA);
    /** comparison between two system dates */
    var currentDepartureTimeZone = new Date(flightEntity.departureTimeUTC);
    var currentTime = new Date();
    if (departureTime &&
        flightEntity.checkinUrl &&
        isAfter(currentTime, currentDepartureTimeZone)) {
        actionIconName = "Airplane" /* Airplane */;
        actionUrl = flightEntity.checkinUrl;
        actionButtonText = owa_txp_strings_1.default.checkinText;
        isFutureFlight = true;
    }
    if (flightEntity.arrivalTimeUTC && flightEntity.departureTimeUTC) {
        var departureTimeUTC = new Date(flightEntity.departureTimeUTC);
        var arrivalTimeUTC = new Date(flightEntity.arrivalTimeUTC);
        var duration = differenceInSeconds(arrivalTimeUTC, departureTimeUTC);
        summaryFourthLine = abbreviated_1.default(duration);
    }
    if (flightEntity.reservedTicket &&
        flightEntity.reservedTicket.seat &&
        (flightEntity.reservedTicket.seat.seatNumber || flightEntity.reservedTicket.seat.row)) {
        seat = owa_strings_1.format(owa_txp_strings_1.default.seatText, flightEntity.reservedTicket.seat.seatNumber, flightEntity.reservedTicket.seat.row);
    }
    if (isBusStop) {
        busStopData = populateFlightBusStopData_1.default(flightEntity);
    }
    return {
        departureIATA: departureIATA,
        arrivalIATA: arrivalIATA,
        departureTime: departureTimeDisplayText,
        arrivalTime: arrivalTimeDisplayText,
        departureDate: departureDateDisplayText,
        arrivalDate: arrivalDateDisplayText,
        departureTerminalGate: departureTerminalGate,
        arrivalTerminalGate: arrivalTerminalGate,
        departureCity: departsCity,
        arrivalCity: arrivalCity,
        seat: seat,
        summaryFirstLine: summaryFirstLine,
        summarySecondLine: summarySecondLine,
        summaryThirdLine: summaryThirdLine,
        summaryFourthLine: summaryFourthLine,
        ariaText: ariaText,
        imageSource: imageSource,
        activityType: ActivityType_1.default.FlightDeparture,
        busStopData: busStopData,
        id: activityId,
        entityType: EntityType_1.default.FlightReservation,
        actionUrl: actionUrl,
        actionButtonText: actionButtonText,
        actionIconName: actionIconName,
        calendarEventId: calendarEventId,
        actionName: TailoredActionName_1.default.CheckIn,
        isFutureFlight: isFutureFlight,
    };
}
exports.default = createFlightCard;
// Extracts the terminal and gate string in the right format
function extractTerminalGate(terminal, gate) {
    var text;
    if (terminal) {
        if (gate) {
            text = owa_strings_1.format(owa_txp_strings_1.default.terminalGateText, terminal, gate);
        }
        else {
            text = owa_strings_1.format(owa_txp_strings_1.default.terminalText, terminal);
        }
    }
    else if (gate) {
        text = owa_strings_1.format(owa_txp_strings_1.default.gateText, gate);
    }
    return text;
}
//# sourceMappingURL=CreateFlightCard.js.map

/***/ }),

/***/ 4188:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var differenceInSeconds = __webpack_require__(248);
var abbreviated_1 = __webpack_require__(3580);
var owa_strings_1 = __webpack_require__(20);
var owa_txp_strings_1 = __webpack_require__(2703);
var owa_datetime_1 = __webpack_require__(207);
// Extracts the flight specific data needed for displaying the bus stop
function populateFlightBusStopData(flightEntity) {
    var departureDisplayDate = owa_datetime_1.parseIsoDate(flightEntity.departureTime);
    var departureTimeDisplayText = owa_datetime_1.formatUserTime(departureDisplayDate);
    var departureDateAriaText = owa_datetime_1.formatWeekDayMonthDayYear(departureDisplayDate);
    /** new Date is used for comparing differences between same Time zones- work item 22001 to avoid it */
    var durationString = null;
    if (flightEntity.arrivalTimeUTC && flightEntity.departureTimeUTC) {
        var departureTimeUTC = new Date(flightEntity.departureTimeUTC);
        var arrivalTimeUTC = new Date(flightEntity.arrivalTimeUTC);
        var duration = differenceInSeconds(arrivalTimeUTC, departureTimeUTC);
        durationString = abbreviated_1.default(duration);
    }
    var collapsedTextString = '';
    if (durationString) {
        collapsedTextString = owa_strings_1.format(owa_txp_strings_1.default.flightBusStopSummaryWithDurationFormatText, flightEntity.departureAirport.city, owa_datetime_1.formatWeekDayDateTime(departureDisplayDate), durationString);
    }
    else {
        collapsedTextString = owa_strings_1.format(owa_txp_strings_1.default.flightBusStopSummaryFormatText, flightEntity.departureAirport.city, owa_datetime_1.formatWeekDayDateTime(departureDisplayDate));
    }
    var ariaBusStopText = owa_strings_1.format(owa_txp_strings_1.default.flightBusStopAriaText, flightEntity.departureAirport.city, departureDateAriaText, departureTimeDisplayText);
    return {
        busStopLabel: owa_txp_strings_1.default.flightBusStopLabelText,
        busStopText: owa_strings_1.format(owa_txp_strings_1.default.flightBusStopFirstLineFormatText, flightEntity.airline.name, flightEntity.airline.iataCode, flightEntity.flightNumber, flightEntity.arrivalAirport.city),
        collapsedText: collapsedTextString,
        ariaBusStopText: ariaBusStopText,
        icon: "Airplane" /* Airplane */,
    };
}
exports.default = populateFlightBusStopData;
//# sourceMappingURL=populateFlightBusStopData.js.map

/***/ }),

/***/ 4189:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var createDurationFormatter_1 = __webpack_require__(4190);
var getAbbreviatedSingularPluralStrings_1 = __webpack_require__(4198);
/** Creates a duration formatter using the plural rules of the given culture and the given strings */
function createAbbreviatedDurationFormatter(userCulture, strings, options) {
    var singularPluralStrings = getAbbreviatedSingularPluralStrings_1.default(strings);
    return createDurationFormatter_1.default(userCulture, singularPluralStrings);
}
exports.default = createAbbreviatedDurationFormatter;
//# sourceMappingURL=createAbbreviatedDurationFormatter.js.map

/***/ }),

/***/ 4190:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var magnitudesInSeconds = __webpack_require__(4191);
var createDurationUnits_1 = __webpack_require__(4192);
var owa_measurement_formatter_1 = __webpack_require__(4196);
/** Creates a duration formatter using the plural rules of the given culture and
 *  the strings that represent the singular and plural forms of each unit.
 */
function createDurationFormatter(userCulture, singularPluralStrings, options) {
    var durationUnits = createDurationUnits_1.default(userCulture, magnitudesInSeconds, singularPluralStrings);
    var units = [
        durationUnits.minute,
        durationUnits.year,
        durationUnits.month,
        durationUnits.week,
        durationUnits.day,
        durationUnits.hour,
        durationUnits.second,
    ];
    return owa_measurement_formatter_1.default(units, options);
}
exports.default = createDurationFormatter;
//# sourceMappingURL=createDurationFormatter.js.map

/***/ }),

/***/ 4191:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// Duration Magnitudes, in seconds.
exports.second = 1;
exports.minute = 60 * exports.second;
exports.hour = 60 * exports.minute;
exports.day = 24 * exports.hour;
exports.week = 7 * exports.day;
exports.year = 365 * exports.day;
exports.month = exports.year / 12;
//# sourceMappingURL=magnitudesInSeconds.js.map

/***/ }),

/***/ 4192:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var createMeasurementUnit_1 = __webpack_require__(4193);
var getSingularPluralExpressions_1 = __webpack_require__(4195);
/** Creates the set of duration units, with the given set of magnitudes
 *  the strings that represent the singular and plural forms of each unit.
 */
function createDurationUnits(userCulture, magnitudes, strings) {
    var expressions = getSingularPluralExpressions_1.default(userCulture);
    return {
        year: createMeasurementUnit_1.default(magnitudes.year, strings.year, expressions),
        month: createMeasurementUnit_1.default(magnitudes.month, strings.month, expressions),
        week: createMeasurementUnit_1.default(magnitudes.week, strings.week, expressions),
        day: createMeasurementUnit_1.default(magnitudes.day, strings.day, expressions),
        hour: createMeasurementUnit_1.default(magnitudes.hour, strings.hour, expressions),
        minute: createMeasurementUnit_1.default(magnitudes.minute, strings.minute, expressions),
        second: createMeasurementUnit_1.default(magnitudes.second, strings.second, expressions),
    };
}
exports.default = createDurationUnits;
//# sourceMappingURL=createDurationUnits.js.map

/***/ }),

/***/ 4193:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getUnitString_1 = __webpack_require__(4194);
/** Creates a measurement unit whose suffix is formatted according
 *  to the plural rules specified in the given strings and expressions.
 *  NOTE: this is a port of LocalePluralsStringConverter; it is limited
 *  in the sense that it only deals with 2 types of plurals, but some
 *  languages have more than 2 plurals, so if we need to support them
 *  we might need to revisit this module.
 */
function createMeasurementUnit(magnitude, singularPluralStrings, singularPluralExpressions) {
    return {
        magnitude: magnitude,
        format: function (x) {
            return x + ' ' + getUnitString_1.default(x, singularPluralStrings, singularPluralExpressions);
        },
    };
}
exports.default = createMeasurementUnit;
//# sourceMappingURL=createMeasurementUnit.js.map

/***/ }),

/***/ 4194:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// DO NOT USE THIS MODULE OUTSIDE owa-measurementunit-formatter!!!
// This is virtually a plain port of what we had in Script# LocalePluralsStringConverter.cs.
// However, it does not deal with languages that have more than two types of plurals.
/**
 * Returns a string based on ordinal context rules.
 * For english, this will be the singularForm for 1, and firstPluralForm for everything else.
 * @param value                     Value of the unit being formatted
 * @param unitStrings               The different forms of the unit string (singular & plurals)
 * @param singularPluralExpressions RegExp that detect single or firstPlural values.
 */
function getUnitString(value, singularPluralStrings, singularPluralExpressions) {
    var s = value.toString(10);
    if (singularPluralExpressions.singular.test(s)) {
        return singularPluralStrings.singular;
    }
    if (singularPluralExpressions.firstPlural.test(s)) {
        return singularPluralStrings.firstPlural;
    }
    return singularPluralStrings.secondPlural;
}
exports.default = getUnitString;
//# sourceMappingURL=getUnitString.js.map

/***/ }),

/***/ 4195:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// This is virtually a plain port of what we had in Script# LocaleSpecific.cs.
// However plural rules are more complex than what we have expressed here.
// I would like us to move to better libraries, such as make-firstPlural, ilib or globalize.
// I'm porting the original code so we have at least parity and some level of unit tests.
// For reference:
// http://cldr.unicode.org/cldr-features
// http://cldr.unicode.org/index/cldr-spec/firstPlural-rules
// http://www.unicode.org/cldr/charts/latest/supplemental/language_plural_rules.html
// The regular expressions below are not dealing with fractionary numbers
// and are not dealing with languages that have more than two plurals
// and you cannot test the plural expression without testing the singular expression first!
function singularPlural(singular, firstPlural) {
    return {
        singular: singular,
        firstPlural: firstPlural,
    };
}
/// <summary>
/// The default expression matching singular numbers.
/// This expression will only match the number 1.
/// </summary>
var defaultSingular = new RegExp('^1$');
/// <summary>
/// The default expression for matching firstPlural numbers.
/// This expression will match any number, which means it
/// can only be evaluated after defaultSingular!
/// </summary>
var defaultPlural = new RegExp('.');
/// <summary>
/// The expression matching firstPlural numbers in Czech.
/// This expression will match only the exact numbers '2', '3' and '4'.
/// </summary>
var czechPlural = new RegExp('^[234]$');
/// <summary>
/// The regular expression matching singular numbers in Russian.
/// This expression will match any string ending in '1', except those ending in '11'.
/// </summary>
var russianSingular = new RegExp('^1$|[^1]1$');
/// <summary>
/// The expression matching firstPlural numbers in Russian and Polish
/// This expression will match any number ending
/// in '2', '3' or '4', except those ending in '12', '13' or '14'.
/// </summary>
var russianOrPolishPlural = new RegExp('^[234]$|[^1][234]$');
/// <summary>
/// The default regular expressions.
/// </summary>
var defaultExpressions = singularPlural(defaultSingular, defaultPlural);
/// <summary>
/// The regular expressions used for Czech numbers.
/// </summary>
var czech = singularPlural(defaultSingular, czechPlural);
/// <summary>
/// The regular expressions used for Russian numbers.
/// </summary>
var russian = singularPlural(russianSingular, russianOrPolishPlural);
/// <summary>
/// Dictionary mapping culture to regular expressions used to
/// determine correct form of word to return based on ordinal context.
/// </summary>
var ordinalRulesByCulture = {
    'cs-CZ': czech,
    'sk-SK': czech,
    'sl-SI': czech,
    'uk-UA': czech,
    'pl-PL': singularPlural(defaultSingular, russianOrPolishPlural),
    'ru-RU': russian,
    'sr-Latn-CS': russian,
    'sr-Cyrl-CS': russian,
    'lt-LT': russian,
    'lv-LV': russian,
};
function getSingularPluralExpressions(culture) {
    return ordinalRulesByCulture[culture] || defaultExpressions;
}
exports.default = getSingularPluralExpressions;
//# sourceMappingURL=getSingularPluralExpressions.js.map

/***/ }),

/***/ 4196:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var createMeasurementFormatter_1 = __webpack_require__(4197);
exports.default = createMeasurementFormatter_1.default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 4197:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Factory that creates a formatting function which formats measurement
 * values acoording to a given set of measurements units and formatting options.
 *
 * Formatting functions can be taylor-made for specific scenarios.
 * For example, one caller might require a formatting function that display time
 * duration as days and hours, while another might want to display hours and minutes.
 * Each can create a formatting function with just the units and options required.
 *
 * The expected usage is for an application to create and export such
 * formatting functions in one or more modules, then invoke the formatting
 * functions with different values thruought the lifetime of the application.
 *
 * @param units
 * A set of units to consider when formatting a value.
 * All units must have magnitudes relative to the same scale of measurement
 * and this scale should be used when passing values to the formatting function.
 * Ex: [hours, minutes, seconds] or [kilometers, meters, centimeters].
 * By default, the first unit in this list dictates how zero is formatted.
 * The formatted value will be based on the descending order of magnitude of these units.
 *
 * @param options
 * A set of options that controls how measurements are formatted.
 *
 * @returns
 * A formatting function that formats measurement values acoording to
 * the given set of measurements units and formatting options.
 * The magnitude of the given units determines the scale of the value being formatted
 * (ex: meters or kilometers, seconds or milliseconds).
 */
function createMeasurementFormatter(units, options) {
    if (options === void 0) { options = {}; }
    if (!units || units.length == 0) {
        throw new Error('units');
    }
    if (!options) {
        throw new Error('options');
    }
    // Capture and validate the options used to create the formatting function
    var zero = options.zero || units[0].format;
    var separator = options.separator == void 0 ? ' ' : options.separator;
    var maxUnits = Math.floor(options.maxUnits == void 0 ? Infinity : options.maxUnits);
    if (maxUnits < 1) {
        throw new Error('options.maxUnits');
    }
    var maxFractionalDigits = Math.floor(options.maxFractionalDigits || 0);
    if (maxFractionalDigits < 0) {
        throw new Error('options.maxFractionalDigits');
    }
    var absoluteLastUnitIndex = units.length - 1;
    var tentativeLastUnitIndex = maxUnits - 1;
    // Copy and sort the units array by magniture in descending order
    units = units.slice().sort(function (x, y) { return y.magnitude - x.magnitude; });
    // Return the reusable formatting function, so we don't need to
    // reprocess the array and options on each and every call.
    return function (measurement) {
        // Special case when measurement is zero.
        // Ex: show 0m instead of 0cm, or 0 minutes instead of 0 seconds.
        if (measurement == 0) {
            return typeof zero === 'string' ? zero : zero(0);
        }
        // Compute and append the string for each unit of measure.
        var formattedValues = [];
        for (var i = 0; i <= absoluteLastUnitIndex; i++) {
            // True if this is absolutely the last unit in the array.
            // The last unit is mandatory if no other unit contributed to the string.
            var isAbsoluteLastUnit = i == absoluteLastUnitIndex;
            // True if this might be the last unit we add to the formatted string (we might skip it too).
            var isTentativeLastUnit = formattedValues.length == tentativeLastUnitIndex;
            // Format this unit with a rounded value if it is the absolute last one
            // or if we think it might be the last one, based on maxUnits.
            var useRoundedValue = isAbsoluteLastUnit || isTentativeLastUnit;
            // Scale the current measurement by the magnitude of the current unit
            // then either round it or floor it, depending if it is the last unit to be added or not.
            var unit = units[i];
            var value = measurement / unit.magnitude;
            if (useRoundedValue) {
                var mult = Math.pow(10, maxFractionalDigits);
                value = Math.round(value * mult) / mult;
            }
            else {
                value = Math.floor(value);
            }
            // Only append this unit if the value is relevant or
            // if we are at the absolute last unit without anything else.
            var valueIsRelevant = value >= 1;
            var valueIsMandatory = isAbsoluteLastUnit && formattedValues.length == 0;
            if (valueIsRelevant || valueIsMandatory) {
                // Format and store the new string.
                // Break if we reached the desired number of units in the output.
                var formattedValue = unit.format(value);
                if (formattedValues.push(formattedValue) == maxUnits) {
                    break;
                }
                // Remaining units will process the left-overs, if there is any.
                measurement %= unit.magnitude;
                if (measurement == 0) {
                    break;
                }
            }
        }
        // We assume concatenation of formatted strings is ok in all languages
        // This was the case in the previous OwaDateTime functionality.
        return formattedValues.join(separator);
    };
}
exports.default = createMeasurementFormatter;
//# sourceMappingURL=createMeasurementFormatter.js.map

/***/ }),

/***/ 4198:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var createSingularPluralStrings_1 = __webpack_require__(4199);
// Groups the strings for each unit
function getAbbreviatedSingularPluralStrings(strings) {
    return {
        year: createSingularPluralStrings_1.default(strings.yearSingularAbbreviation, strings.yearFirstPluralAbbreviation, strings.yearSecondGenitivePluralAbbreviation),
        month: createSingularPluralStrings_1.default(strings.monthSingularAbbreviation, strings.monthFirstPluralAbbreviation, strings.monthSecondGenitivePluralAbbreviation),
        week: createSingularPluralStrings_1.default(strings.weekSingularAbbreviation, strings.weekFirstPluralAbbreviation, strings.weekSecondGenitivePluralAbbreviation),
        day: createSingularPluralStrings_1.default(strings.daySingularAbbreviation, strings.dayFirstPluralAbbreviation, strings.daySecondGenitivePluralAbbreviation),
        hour: createSingularPluralStrings_1.default(strings.hourSingularAbbreviation, strings.hourFirstPluralAbbreviation, strings.hourSecondGenitivePluralAbbreviation),
        minute: createSingularPluralStrings_1.default(strings.minuteSingularAbbreviation, strings.minuteFirstPluralAbbreviation, strings.minuteSecondGenitivePluralAbbreviation),
        second: createSingularPluralStrings_1.default(strings.secondSingularAbbreviation, strings.secondFirstPluralAbbreviation, strings.secondSecondGenitivePluralAbbreviation),
    };
}
exports.default = getAbbreviatedSingularPluralStrings;
//# sourceMappingURL=getAbbreviatedSingularPluralStrings.js.map

/***/ }),

/***/ 4199:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/** Creates an object that represent the different forms of a unit's suffix */
function createSingularPluralStrings(singular, firstPlural, secondPlural) {
    return {
        singular: singular,
        firstPlural: firstPlural,
        secondPlural: secondPlural,
    };
}
exports.default = createSingularPluralStrings;
//# sourceMappingURL=createSingularPluralStrings.js.map

/***/ }),

/***/ 4200:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ActivityType_1 = __webpack_require__(2747);
var EntityType_1 = __webpack_require__(2734);
var convertDateTimeToString_1 = __webpack_require__(2990);
var TxpSource_1 = __webpack_require__(691);
var isSameDay = __webpack_require__(644);
var owa_strings_1 = __webpack_require__(20);
var owa_txp_strings_1 = __webpack_require__(2703);
var TxpConstants_1 = __webpack_require__(161);
var TailoredActionName_1 = __webpack_require__(684);
/**
 * Extracts the Parcel Delivery specific data needed for displaying the card
 */
function createParcelDeliveryCard(parcelDeliveryEntity, activityId, txpSource, showLocation, calendarEventId) {
    var partOfOrder = parcelDeliveryEntity.partOfOrder;
    var actionUrl;
    var actionButtonText;
    var actionIconName;
    var imageSource = txpSource == TxpSource_1.default.CalendarPeek
        ? TxpConstants_1.VERTICAL_PACKAGE_LIGHT
        : TxpConstants_1.PARCEL_DELIVERY_ILLUSTRATION;
    // format lines for Summary
    var seller = partOfOrder.seller ? partOfOrder.seller.name : null;
    var orderNumber = partOfOrder ? partOfOrder.orderNumber : null;
    var summaryFirstLine = owa_strings_1.format(owa_txp_strings_1.default.parcelDeliveryFirstLine, seller);
    var summarySecondLine = owa_strings_1.format(owa_txp_strings_1.default.parcelDeliverySecondLine, orderNumber);
    // format the estimate time
    var latestDeliveryDate = parcelDeliveryEntity.expectedArrivalUntil;
    var earliestDeliveryDate = parcelDeliveryEntity.expectedArrivalFrom;
    var deliveryText;
    if (latestDeliveryDate) {
        if (earliestDeliveryDate && !isSameDay(earliestDeliveryDate, latestDeliveryDate)) {
            deliveryText = owa_strings_1.format(owa_txp_strings_1.default.deliveryTextRange, convertDateTimeToString_1.default(earliestDeliveryDate, false /* isAccessible */), convertDateTimeToString_1.default(latestDeliveryDate, false /* isAccessible */));
        }
        else {
            deliveryText = owa_strings_1.format(owa_txp_strings_1.default.deliveryText, convertDateTimeToString_1.default(latestDeliveryDate, false /* isAccessible */));
        }
    }
    // format lines for Details
    var trackingNumber = parcelDeliveryEntity.trackingNumber;
    var provider = parcelDeliveryEntity.provider ? parcelDeliveryEntity.provider.name : null;
    var orderedItem = partOfOrder ? partOfOrder.orderedItem : null;
    var itemText = partOfOrder && orderedItem && orderedItem.name ? orderedItem.name : null;
    var trackingText = trackingNumber && provider
        ? owa_strings_1.format(owa_txp_strings_1.default.trackingText, provider, trackingNumber)
        : null;
    var address = parcelDeliveryEntity.deliveryAddress;
    var addressText = address && address.streetAddress ? address.streetAddress : null;
    addressText = showLocation ? addressText : null;
    var trackingUrl = parcelDeliveryEntity.trackingUrl;
    if (trackingUrl) {
        actionIconName = "DeliveryTruck" /* DeliveryTruck */;
        actionUrl = trackingUrl;
        actionButtonText = owa_txp_strings_1.default.trackPackageButtonText;
    }
    return {
        id: activityId,
        imageSource: imageSource,
        activityType: ActivityType_1.default.ParcelDelivery,
        entityType: EntityType_1.default.ParcelDelivery,
        summaryFirstLine: summaryFirstLine,
        summarySecondLine: summarySecondLine,
        detailsData: {
            firstLine: itemText,
            secondLine: trackingText,
            thirdLine: deliveryText,
            fourthLine: addressText,
        },
        actionUrl: actionUrl,
        actionButtonText: actionButtonText,
        actionIconName: actionIconName,
        calendarEventId: calendarEventId,
        actionName: TailoredActionName_1.default.TrackPackage,
    };
}
exports.default = createParcelDeliveryCard;
//# sourceMappingURL=createParcelDeliveryCard.js.map

/***/ }),

/***/ 4201:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var populateRentalCarBusStopData_1 = __webpack_require__(4202);
var ActivityType_1 = __webpack_require__(2747);
var EntityType_1 = __webpack_require__(2734);
var TxpSource_1 = __webpack_require__(691);
var convertDateTimeToString_1 = __webpack_require__(2990);
var owa_strings_1 = __webpack_require__(20);
var owa_txp_strings_1 = __webpack_require__(2703);
var TxpConstants_1 = __webpack_require__(161);
var TailoredActionName_1 = __webpack_require__(684);
/**
 *  Extracts the rental car specific data needed for displaying the card
 */
function createRentalCarCard(rentalCarEntity, isBusStop, activityType, activityId, txpSource, showLocation, cardRole, calendarEventId) {
    var summaryFirstLine;
    var busStopData;
    var rentalCarText;
    var dropOffTime;
    var pickUpTime;
    var companyText;
    var locationText;
    var rentalCompanyPlace;
    var actionUrl;
    var actionButtonText;
    var actionIconName;
    var rentalCarDetails = rentalCarEntity.car;
    var imageSource = txpSource == TxpSource_1.default.CalendarPeek
        ? TxpConstants_1.VERTICAL_CAR_LIGHT
        : TxpConstants_1.RENTAL_CAR_ILLUSTRATION;
    var rentalCompanyName = rentalCarEntity.provider ? rentalCarEntity.provider.name : null;
    var parsedPickUpTime = convertDateTimeToString_1.default(rentalCarEntity.pickupTime, false /*isAccessible*/);
    var summarySecondLine = rentalCarEntity.reservationId &&
        owa_strings_1.format(owa_txp_strings_1.default.reservationCodeText, rentalCarEntity.reservationId);
    var parsedDropOffTime = convertDateTimeToString_1.default(rentalCarEntity.dropoffTime, false /*isAccessible*/);
    var modifyReservationUrl = rentalCarEntity.modifyReservationUrl;
    if (modifyReservationUrl) {
        actionIconName = "Edit" /* Edit */;
        actionUrl = modifyReservationUrl;
        actionButtonText = owa_txp_strings_1.default.modifyReservationText;
    }
    if (rentalCarDetails &&
        rentalCarDetails.model &&
        rentalCarDetails.brand &&
        rentalCarDetails.brand.name) {
        rentalCarText = owa_strings_1.format(owa_txp_strings_1.default.carText, rentalCarDetails.brand.name, rentalCarDetails.model);
    }
    if (cardRole == 1 /* Combined */) {
        rentalCompanyPlace = rentalCarEntity.dropoffLocation;
        summaryFirstLine = owa_strings_1.format(owa_txp_strings_1.default.reservationText, rentalCompanyName);
        dropOffTime = owa_strings_1.format(owa_txp_strings_1.default.dropOffText, parsedDropOffTime);
        pickUpTime = owa_strings_1.format(owa_txp_strings_1.default.pickUpText, parsedPickUpTime);
    }
    else if (activityType == ActivityType_1.default.RentalCarPickup) {
        rentalCompanyPlace = rentalCarEntity.pickupLocation;
        summaryFirstLine = owa_strings_1.format(owa_txp_strings_1.default.pickUpSuffixText, rentalCompanyName);
        pickUpTime = parsedPickUpTime;
    }
    else if (activityType == ActivityType_1.default.RentalCarDropOff) {
        rentalCompanyPlace = rentalCarEntity.dropoffLocation;
        summaryFirstLine = owa_strings_1.format(owa_txp_strings_1.default.dropOffSuffixText, rentalCompanyName);
        dropOffTime = parsedDropOffTime;
    }
    else {
        return null;
    }
    if (rentalCompanyPlace) {
        companyText = rentalCompanyPlace.name;
        locationText = rentalCompanyPlace.address ? rentalCompanyPlace.address.streetAddress : null;
    }
    if (isBusStop) {
        busStopData = populateRentalCarBusStopData_1.default(rentalCarEntity, activityType, rentalCompanyPlace, rentalCarEntity.dropoffTime, rentalCarEntity.pickupTime);
    }
    locationText = showLocation ? locationText : null;
    return {
        id: activityId,
        summaryFirstLine: summaryFirstLine,
        summarySecondLine: summarySecondLine,
        imageSource: imageSource,
        activityType: activityType,
        entityType: EntityType_1.default.RentalCarReservation,
        busStopData: busStopData,
        detailsData: {
            firstLine: companyText,
            secondLine: rentalCarText,
            thirdLine: pickUpTime,
            fourthLine: dropOffTime,
            fifthLine: locationText,
        },
        actionUrl: actionUrl,
        actionButtonText: actionButtonText,
        actionIconName: actionIconName,
        calendarEventId: calendarEventId,
        actionName: TailoredActionName_1.default.ModifyReservation,
    };
}
exports.default = createRentalCarCard;
//# sourceMappingURL=createRentalCarCard.js.map

/***/ }),

/***/ 4202:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TxpConstants_1 = __webpack_require__(161);
var ActivityType_1 = __webpack_require__(2747);
var convertDateTimeToString_1 = __webpack_require__(2990);
var owa_strings_1 = __webpack_require__(20);
var owa_txp_strings_1 = __webpack_require__(2703);
/**
 * Extracts the rental car specific data needed for displaying the bus stop
 */
function populateRentalCarBusStopData(rentalCarEntity, activityType, rentalCompanyPlace, dropOffTime, pickUpTime) {
    var collapsedText;
    var busStopLabel;
    var ariaBusStopText;
    var busStopText = rentalCompanyPlace ? rentalCompanyPlace.name : null;
    if (activityType == ActivityType_1.default.RentalCarPickup) {
        busStopLabel = owa_strings_1.format(owa_txp_strings_1.default.pickUpText, TxpConstants_1.EMPTY_STRING);
        collapsedText = convertDateTimeToString_1.default(rentalCarEntity.pickupTime, false /*isAccessible*/);
        ariaBusStopText = convertDateTimeToString_1.default(rentalCarEntity.pickupTime, true /*isAccessible*/);
    }
    else if (activityType == ActivityType_1.default.RentalCarDropOff) {
        busStopLabel = owa_strings_1.format(owa_txp_strings_1.default.dropOffText, TxpConstants_1.EMPTY_STRING);
        collapsedText = convertDateTimeToString_1.default(rentalCarEntity.dropoffTime, false /*isAccessible*/);
        ariaBusStopText = convertDateTimeToString_1.default(rentalCarEntity.dropoffTime, true /*isAccessible*/);
    }
    else {
        return null;
    }
    return {
        busStopLabel: busStopLabel,
        busStopText: busStopText,
        collapsedText: collapsedText,
        ariaBusStopText: ariaBusStopText,
        icon: "Car" /* Car */,
    };
}
exports.default = populateRentalCarBusStopData;
//# sourceMappingURL=populateRentalCarBusStopData.js.map

/***/ }),

/***/ 4203:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var populateLodgingBusStopData_1 = __webpack_require__(4204);
var ActivityType_1 = __webpack_require__(2747);
var EntityType_1 = __webpack_require__(2734);
var TxpSource_1 = __webpack_require__(691);
var convertDateTimeToString_1 = __webpack_require__(2990);
var owa_strings_1 = __webpack_require__(20);
var owa_txp_strings_1 = __webpack_require__(2703);
var TxpConstants_1 = __webpack_require__(161);
var TailoredActionName_1 = __webpack_require__(684);
/**
 *  Extracts the lodging specific data needed for displaying the card
 */
function createLodgingCard(lodgingEntity, isBusStop, activityType, activityId, source, showLocation, cardRole, calendarEventId) {
    var checkInTimeText;
    var checkOutTimeText;
    var summaryFirstLine;
    var actionUrl;
    var actionButtonText;
    var actionIconName;
    var busStopData;
    var imageSource = source == TxpSource_1.default.CalendarPeek
        ? TxpConstants_1.VERTICAL_HOTEL_LIGHT
        : TxpConstants_1.LODGING_ILLUSTRATION;
    var hotelDetails = lodgingEntity.lodgingBusiness;
    var hotelAddress = hotelDetails ? hotelDetails.address : null;
    var locationText = hotelDetails && hotelAddress ? hotelAddress.streetAddress : null;
    var summarySecondLine = lodgingEntity.reservationId &&
        owa_strings_1.format(owa_txp_strings_1.default.reservationCodeText, lodgingEntity.reservationId);
    var parsedCheckOutTimeText = convertDateTimeToString_1.default(lodgingEntity.checkoutTime, false /* isAccessible */);
    var parsedCheckInTimeText = convertDateTimeToString_1.default(lodgingEntity.checkinTime, false /* isAccessible */);
    var modifyReservationUrl = lodgingEntity.modifyReservationUrl;
    if (modifyReservationUrl) {
        actionIconName = "Edit" /* Edit */;
        actionUrl = modifyReservationUrl;
        actionButtonText = owa_txp_strings_1.default.modifyReservationText;
    }
    if (cardRole == 1 /* Combined */) {
        summaryFirstLine = owa_strings_1.format(owa_txp_strings_1.default.reservationText, hotelDetails.name);
        checkInTimeText = owa_strings_1.format(owa_txp_strings_1.default.hotelCheckInText, parsedCheckInTimeText);
        checkOutTimeText = owa_strings_1.format(owa_txp_strings_1.default.hotelCheckOutText, parsedCheckOutTimeText);
    }
    else if (activityType == ActivityType_1.default.HotelCheckout) {
        summaryFirstLine = owa_strings_1.format(owa_txp_strings_1.default.checkOutSuffixText, hotelDetails.name);
        checkOutTimeText = parsedCheckOutTimeText;
    }
    else if (activityType == ActivityType_1.default.HotelCheckin) {
        summaryFirstLine = owa_strings_1.format(owa_txp_strings_1.default.checkInSuffixText, hotelDetails.name);
        checkInTimeText = parsedCheckInTimeText;
    }
    if (isBusStop) {
        busStopData = populateLodgingBusStopData_1.default(lodgingEntity, activityType);
    }
    locationText = showLocation ? locationText : null;
    return {
        id: activityId,
        summaryFirstLine: summaryFirstLine,
        summarySecondLine: summarySecondLine,
        imageSource: imageSource,
        activityType: activityType,
        entityType: EntityType_1.default.LodgingReservation,
        busStopData: busStopData,
        detailsData: {
            firstLine: checkInTimeText,
            secondLine: checkOutTimeText,
            thirdLine: locationText,
        },
        actionUrl: actionUrl,
        actionButtonText: actionButtonText,
        actionIconName: actionIconName,
        calendarEventId: calendarEventId,
        actionName: TailoredActionName_1.default.ModifyReservation,
    };
}
exports.default = createLodgingCard;
//# sourceMappingURL=createLodgingCard.js.map

/***/ }),

/***/ 4204:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TxpConstants_1 = __webpack_require__(161);
var ActivityType_1 = __webpack_require__(2747);
var convertDateTimeToString_1 = __webpack_require__(2990);
var owa_strings_1 = __webpack_require__(20);
var owa_txp_strings_1 = __webpack_require__(2703);
/**
 * Extracts the lodging specific data needed for displaying the bus stop
 */
function populateLodgingBusStopData(lodgingEntity, activityType) {
    var collapsedText;
    var busStopLabel;
    var hotelName = lodgingEntity.lodgingBusiness ? lodgingEntity.lodgingBusiness.name : null;
    var ariaBusStopText;
    if (activityType == ActivityType_1.default.HotelCheckout) {
        busStopLabel = owa_strings_1.format(owa_txp_strings_1.default.hotelCheckOutText, TxpConstants_1.EMPTY_STRING);
        var parsedCheckOutTimeText = convertDateTimeToString_1.default(lodgingEntity.checkoutTime, false /* isAccessible */);
        ariaBusStopText = convertDateTimeToString_1.default(lodgingEntity.checkoutTime, true /* isAccessible */);
        collapsedText = parsedCheckOutTimeText;
    }
    else if (activityType == ActivityType_1.default.HotelCheckin) {
        busStopLabel = owa_strings_1.format(owa_txp_strings_1.default.hotelCheckInText, TxpConstants_1.EMPTY_STRING);
        var parsedCheckInTimeText = convertDateTimeToString_1.default(lodgingEntity.checkinTime, false /* isAccessible */);
        ariaBusStopText = convertDateTimeToString_1.default(lodgingEntity.checkinTime, true /* isAccessible */);
        collapsedText = parsedCheckInTimeText;
    }
    return {
        busStopLabel: busStopLabel,
        busStopText: hotelName,
        collapsedText: collapsedText,
        ariaBusStopText: ariaBusStopText,
        icon: "Hotel" /* Hotel */,
    };
}
exports.default = populateLodgingBusStopData;
//# sourceMappingURL=populateLodgingBusStopData.js.map

/***/ }),

/***/ 4205:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function getCalendarEventId(activityItem, calendarEventIds) {
    var calendarEventIdIndex = activityItem.calendarEventIdIndex;
    // When index is -1, it means that this activity does not have a calendar event
    if (calendarEventIdIndex === -1) {
        return null;
    }
    // use the index to find the calendarEvent in the indexs array
    var calendarEvent = calendarEventIds[calendarEventIdIndex];
    return calendarEvent ? calendarEvent.Id : null;
}
exports.default = getCalendarEventId;
//# sourceMappingURL=getCalendarEventId.js.map

/***/ }),

/***/ 4206:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CreateCardItem_1 = __webpack_require__(3579);
var GetCardRole_1 = __webpack_require__(4207);
function createCardsNoBusStop(activities, entities, entitiesPrimaryHash, source, showEnhancedLocation, calendarEventIds) {
    var cardItems = [];
    activities.forEach(function (activityItem) {
        var currentEntity = entities[activityItem.entityId];
        // when cardRole is null, no need to make a card.
        var cardRole = GetCardRole_1.default(activityItem, entitiesPrimaryHash);
        if (cardRole != null) {
            var card = CreateCardItem_1.default(activityItem, currentEntity, false /** not a bus-stop */, source, showEnhancedLocation, cardRole, calendarEventIds);
            cardItems.push(card);
        }
    });
    return cardItems;
}
exports.default = createCardsNoBusStop;
//# sourceMappingURL=createCardsNoBusStop.js.map

/***/ }),

/***/ 4207:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This fucntion iterate through all the activities. Using the hash - it decide when to create a card
 * @primaryActivityCounts - a hash that represent how many primary activities are for each entityID (should be 1 or 2)
 * ### One primary activity for entity ###
 * it means that
 * 1) for this entity there is also a secondary card
 * OR
 * 2) it has only one primary card
 * it should set the cardRole to be combined and set the hash value to 0, so when the iteration will get to the secondary activity
 * it won't create new card for it.
 * ### Two primary activities for entity ###
 * it means that
 * it should create two cards and set the cardRole to be Primary for each
 */
function getCardRole(activityItem, primaryActivityCounts) {
    var entityId = activityItem.entityId;
    var primaryRoleCount = primaryActivityCounts[entityId];
    if (primaryRoleCount == 2) {
        return 0 /* Primary */;
    }
    else if (primaryRoleCount == 1) {
        primaryActivityCounts[activityItem.entityId] = 0;
        return 1 /* Combined */;
    }
    else {
        return null;
    }
}
exports.default = getCardRole;
//# sourceMappingURL=GetCardRole.js.map

/***/ }),

/***/ 4208:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var Txp_1 = __webpack_require__(3265);
var React = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(11);
var ConvertTxpBlobToObject_1 = __webpack_require__(3581);
var UserVoice_1 = __webpack_require__(4232);
var TailoredActionName_1 = __webpack_require__(684);
var userVoiceReports_1 = __webpack_require__(4233);
var populateUserVoiceData_1 = __webpack_require__(4249);
var populateFeedbackDataPointData_1 = __webpack_require__(4252);
var owa_txp_strings_1 = __webpack_require__(2703);
var areAnyTXPEntitiesSupported_1 = __webpack_require__(713);
var owa_controls_feature_flags_1 = __webpack_require__(33);
var styles = __webpack_require__(2748);
var TxpWrapper = /** @class */ (function (_super) {
    tslib_1.__extends(TxpWrapper, _super);
    function TxpWrapper(props) {
        var _this = _super.call(this, props) || this;
        /**
         * Telemetry callback when 'send feedback' clicked with feedbackDataPoint
         */
        _this.onSendFeedback = function () {
            var onFeedbackClicked = _this.props.onFeedbackClicked;
            userVoiceReports_1.sendFeedback();
            if (onFeedbackClicked) {
                var feedbackDataPoint = _this.getDataPoint(TailoredActionName_1.default.Feedback);
                onFeedbackClicked(feedbackDataPoint);
            }
        };
        /**
         * Telemetry callback when 'report issue' clicked with feedbackDataPoint
         */
        _this.onReportIssue = function () {
            var onFeedbackClicked = _this.props.onFeedbackClicked;
            var userVoiceData = populateUserVoiceData_1.default(_this.txpObject);
            if (owa_controls_feature_flags_1.isControlFeatureEnabled('cal-txp-emailDonation')) {
                userVoiceReports_1.reportIssue(userVoiceData, _this.props.InternetMessageId, _this.props.ItemId, React.createElement("div", { className: styles.dsatSubText },
                    React.createElement("div", null, owa_txp_strings_1.default.negativeTicketPopUpDonateEmailText),
                    React.createElement("br", null),
                    React.createElement("div", null, owa_txp_strings_1.default.negativeTicketPopUpEmailUseText)));
            }
            else {
                userVoiceReports_1.sendNegativeFeedback(userVoiceData, _this.props.InternetMessageId);
            }
            if (onFeedbackClicked) {
                var feedbackDataPoint = _this.getDataPoint(TailoredActionName_1.default.ReportAnIssue);
                onFeedbackClicked(feedbackDataPoint);
            }
        };
        /**
         * Telemetry callback when useful / not useful clicked with feedbackDataPoint
         */
        _this.OnSentimentFeedbackClicked = function (isUseful) {
            var onFeedbackClicked = _this.props.onFeedbackClicked;
            if (onFeedbackClicked) {
                var feedbackClick = isUseful
                    ? TailoredActionName_1.default.FeedbackPositive
                    : TailoredActionName_1.default.FeedbackNegative;
                var dataPoint = _this.getDataPoint(feedbackClick);
                onFeedbackClicked(dataPoint);
            }
        };
        /**
         * This function return object for log datapoint
         */
        _this.getDataPoint = function (feedbackType) {
            return populateFeedbackDataPointData_1.default(_this.props.entityNamesMap, feedbackType, _this.props.source);
        };
        if (areAnyTXPEntitiesSupported_1.default(_this.props.entityNamesMap)) {
            _this.txpObject = ConvertTxpBlobToObject_1.default(props.txpBlob);
        }
        return _this;
    }
    TxpWrapper.prototype.render = function () {
        var _a = this.props, className = _a.className, onExpandCard = _a.onExpandCard, onActionButtonClicked = _a.onActionButtonClicked, calendarEventIds = _a.calendarEventIds;
        var txpStyle = {
            cardSummaryContainer: styles.txpCardSummary,
            cardSummaryLines: styles.summaryLines,
            airPlaneIcon: "Airplane" /* Airplane */,
            planeStyle: styles.plane,
            summaryLabel: styles.summaryLabel,
            detailsLabel: styles.detailsLabel,
            imageClassName: styles.imageMail,
        };
        if (this.txpObject) {
            return (React.createElement("div", { className: className },
                React.createElement(Txp_1.default, { txpStyle: txpStyle, txpObject: this.txpObject, onExpandCard: onExpandCard, source: this.props.source, onActionButtonClicked: onActionButtonClicked, calendarEventIds: calendarEventIds, showEnhancedLocation: false }),
                React.createElement(UserVoice_1.default, { onSendFeedback: this.onSendFeedback, onReportIssue: this.onReportIssue, OnSentimentFeedbackClicked: this.OnSentimentFeedbackClicked })));
        }
        else {
            return null;
        }
    };
    TxpWrapper = tslib_1.__decorate([
        mobx_react_1.observer
    ], TxpWrapper);
    return TxpWrapper;
}(React.Component));
exports.default = TxpWrapper;
//# sourceMappingURL=TxpWrapper.js.map

/***/ }),

/***/ 4209:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var createActivityItem_1 = __webpack_require__(4210);
function populateActivities(activities) {
    if (activities) {
        var parsedActivities_1 = [];
        activities.forEach(function (activityItem) {
            if (activityItem) {
                var newActivity = createActivityItem_1.default(activityItem);
                if (newActivity) {
                    parsedActivities_1.push(newActivity);
                }
                else {
                    return null;
                }
            }
        });
        if (parsedActivities_1.length == 0) {
            return null;
        }
        else {
            return parsedActivities_1;
        }
    }
    return null;
}
exports.default = populateActivities;
//# sourceMappingURL=PopulateActivities.js.map

/***/ }),

/***/ 4210:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ActivityTypeNames_1 = __webpack_require__(3274);
var CalendarEventOmissionNames_1 = __webpack_require__(4211);
var RoleNames_1 = __webpack_require__(4213);
var owa_guid_1 = __webpack_require__(585);
/**
 * create Activity item based on the type
 */
function createActivityItem(activity) {
    var activityTypeBlob = activity.type ? activity.type.toLowerCase() : null;
    var activityType = ActivityTypeNames_1.default[activityTypeBlob];
    if (activityType) {
        return createActivity(activity, activityType, activityTypeBlob);
    }
    else {
        return null;
    }
}
exports.default = createActivityItem;
/**
 * parse the data into Activity item
 */
function createActivity(activity, activityType, activityName) {
    var activityNewId = owa_guid_1.getGuid();
    // check if the properties in the blob - lowercase and save
    var eventOmissionBlob = activity.calendarEventOmission
        ? activity.calendarEventOmission.toLowerCase()
        : null;
    var roleBlob = activity.role ? activity.role.toLowerCase() : null;
    // create objects for the activity
    var activityEventOmission = CalendarEventOmissionNames_1.default[eventOmissionBlob];
    var activityRole = RoleNames_1.default[roleBlob];
    return {
        activityId: activityNewId,
        type: activityType,
        entityId: activity.entityId,
        calendarEventIdIndex: activity.calendarEventIdIndex,
        eventOmission: activityEventOmission,
        role: activityRole,
        activityName: activityName,
    };
}
//# sourceMappingURL=createActivityItem.js.map

/***/ }),

/***/ 4211:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CalendarEventOmission_1 = __webpack_require__(4212);
var CalendarEventOmissionNames = {
    /**
     * None - the event was created and not omitted
     */
    none: CalendarEventOmission_1.default.None,
    /**
     * Event sharing from mail
     */
    unexpected: CalendarEventOmission_1.default.Unexpected,
    /**
     * Email reminder
     */
    configuration: CalendarEventOmission_1.default.Configuration,
    /**
     * Event omitted because the trust score of the entity is under the acceptable threshold
     */
    trust: CalendarEventOmission_1.default.Trust,
    /**
     * Event omitted because an error occurred when trying to create it
     */
    error: CalendarEventOmission_1.default.Error,
    /**
     * Event omitted because we are not supposed to create it, i.e. a flight cancellation
     */
    bydesign: CalendarEventOmission_1.default.ByDesign,
    /**
     * Event omitted because it was in the past
     */
    inthepast: CalendarEventOmission_1.default.InThePast,
    /**
     * Event omitted because it was shared by another user
     */
    sharedevent: CalendarEventOmission_1.default.SharedEvent,
};
exports.default = CalendarEventOmissionNames;
//# sourceMappingURL=CalendarEventOmissionNames.js.map

/***/ }),

/***/ 4212:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CalendarEventOmission;
(function (CalendarEventOmission) {
    /**
     * Event sharing from calendar
     */
    CalendarEventOmission[CalendarEventOmission["None"] = 0] = "None";
    /**
     * Event sharing from mail
     */
    CalendarEventOmission[CalendarEventOmission["Unexpected"] = 1] = "Unexpected";
    /**
     * Email reminder
     */
    CalendarEventOmission[CalendarEventOmission["Configuration"] = 2] = "Configuration";
    /**
     * Event omitted because the trust score of the entity is under the acceptable threshold
     */
    CalendarEventOmission[CalendarEventOmission["Trust"] = 3] = "Trust";
    /**
     * Event omitted because an error occurred when trying to create it
     */
    CalendarEventOmission[CalendarEventOmission["Error"] = 4] = "Error";
    /**
     * Event omitted because we are not supposed to create it, i.e. a flight cancellation
     */
    CalendarEventOmission[CalendarEventOmission["ByDesign"] = 5] = "ByDesign";
    /**
     * Event omitted because it was in the past
     */
    CalendarEventOmission[CalendarEventOmission["InThePast"] = 6] = "InThePast";
    /**
     * Event omitted because it was shared by another user
     */
    CalendarEventOmission[CalendarEventOmission["SharedEvent"] = 7] = "SharedEvent";
})(CalendarEventOmission || (CalendarEventOmission = {}));
exports.default = CalendarEventOmission;
//# sourceMappingURL=CalendarEventOmission.js.map

/***/ }),

/***/ 4213:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Role_1 = __webpack_require__(3578);
var RoleNames = {
    /**
     * Dining activity type
     */
    primary: Role_1.default.Primary,
    /**
     * Dining activity type
     */
    secondary: Role_1.default.Secondary,
};
exports.default = RoleNames;
//# sourceMappingURL=RoleNames.js.map

/***/ }),

/***/ 4214:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tryCreateEntityItem_1 = __webpack_require__(4215);
/**
 * populate the entities in the store
 */
function populateEntities(entitiesBlob) {
    var entities = {};
    if (entitiesBlob) {
        entitiesBlob.forEach(function (entityItem) {
            var newEntity = tryCreateEntityItem_1.default(entityItem);
            if (newEntity) {
                entities[newEntity.id] = newEntity;
            }
            else {
                return null;
            }
        });
    }
    if (Object.keys(entities).length == 0) {
        return null;
    }
    return entities;
}
exports.default = populateEntities;
//# sourceMappingURL=PopulateEntities.js.map

/***/ }),

/***/ 4215:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var EntityTypeNames_1 = __webpack_require__(4216);
var SetBasicEntityData_1 = __webpack_require__(4217);
var setParcelDeliveryEntityData_1 = __webpack_require__(4220);
var setFlightEntityData_1 = __webpack_require__(4222);
var setRentalCarEntityData_1 = __webpack_require__(4224);
var SetReservationEntityData_1 = __webpack_require__(4226);
var setLodgingReservationEntityData_1 = __webpack_require__(4227);
var setEventEntityData_1 = __webpack_require__(4228);
var setDiningEntityData_1 = __webpack_require__(4229);
/**
 * create Entity item based on the type
 */
function tryCreateEntityItem(entityBlob) {
    if (entityBlob) {
        // create new Entity with basic data
        var entityItem = SetBasicEntityData_1.default(entityBlob);
        // check for entity type and parse data accordingly
        if (entityItem) {
            var entityType = entityBlob['@type'];
            if (isReservation(entityType)) {
                entityItem = SetReservationEntityData_1.default(entityItem, entityBlob, entityType == EntityTypeNames_1.default.FlightReservation /* flight doesn't Require Id */);
            }
            if (entityItem) {
                switch (entityType) {
                    case EntityTypeNames_1.default.FlightReservation: {
                        entityItem = setFlightEntityData_1.default(entityItem, entityBlob);
                        entityItem.entityName = EntityTypeNames_1.default.FlightReservation;
                        break;
                    }
                    case EntityTypeNames_1.default.RentalCarReservation: {
                        entityItem = setRentalCarEntityData_1.default(entityItem, entityBlob);
                        entityItem.entityName = EntityTypeNames_1.default.RentalCarReservation;
                        break;
                    }
                    case EntityTypeNames_1.default.ParcelDelivery: {
                        entityItem = setParcelDeliveryEntityData_1.default(entityItem, entityBlob);
                        entityItem.entityName = EntityTypeNames_1.default.ParcelDelivery;
                        break;
                    }
                    case EntityTypeNames_1.default.LodgingReservation: {
                        entityItem = setLodgingReservationEntityData_1.default(entityItem, entityBlob);
                        entityItem.entityName = EntityTypeNames_1.default.LodgingReservation;
                        break;
                    }
                    case EntityTypeNames_1.default.FoodReservation: {
                        entityItem = setDiningEntityData_1.default(entityItem, entityBlob);
                        entityItem.entityName = EntityTypeNames_1.default.FoodReservation;
                        break;
                    }
                    case EntityTypeNames_1.default.EventReservation: {
                        entityItem = setEventEntityData_1.default(entityItem, entityBlob);
                        entityItem.entityName = EntityTypeNames_1.default.EventReservation;
                        break;
                    }
                    default:
                        return null;
                }
                return entityItem;
            }
        }
    }
    return null;
}
exports.default = tryCreateEntityItem;
function isReservation(EntityType) {
    if (EntityType == EntityTypeNames_1.default.FlightReservation ||
        EntityType == EntityTypeNames_1.default.EventReservation ||
        EntityType == EntityTypeNames_1.default.LodgingReservation ||
        EntityType == EntityTypeNames_1.default.RentalCarReservation ||
        EntityType == EntityTypeNames_1.default.FoodReservation ||
        EntityType == EntityTypeNames_1.default.EventReservation) {
        return true;
    }
    return false;
}
exports.isReservation = isReservation;
//# sourceMappingURL=tryCreateEntityItem.js.map

/***/ }),

/***/ 4216:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var EntityTypeNames = {
    /**
     * Event
     */
    EventReservation: 'EventReservation',
    /**
     * Flight
     */
    FlightReservation: 'FlightReservation',
    /**
     * Food
     */
    FoodReservation: 'FoodEstablishmentReservation',
    /**
     * Invoice
     */
    Invoice: 'Invoice',
    /**
     * Hotel
     */
    LodgingReservation: 'LodgingReservation',
    /**
     * Parcel Delivery
     */
    ParcelDelivery: 'ParcelDelivery',
    /**
     * Rental car
     */
    RentalCarReservation: 'RentalCarReservation',
};
exports.default = EntityTypeNames;
//# sourceMappingURL=EntityTypeNames.js.map

/***/ }),

/***/ 4217:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AdditionalInfoNames_1 = __webpack_require__(4218);
/**
 * parse data for basic Entity
 */
function setBasicEntityData(entity) {
    if (entity) {
        var txpAdditionalType = entity['@txpAdditionalType'];
        var additionalInfoBlob = txpAdditionalType ? txpAdditionalType.toLowerCase() : null;
        var EntityAdditionalInfo = AdditionalInfoNames_1.default[additionalInfoBlob];
        var entityId = entity['@id'];
        if (entityId) {
            return {
                id: entityId,
                source: entity['@source'],
                trustScore: entity['@entityExtractionTrustLevel'],
                txpAdditionalType: EntityAdditionalInfo,
            };
        }
    }
    return null;
}
exports.default = setBasicEntityData;
//# sourceMappingURL=SetBasicEntityData.js.map

/***/ }),

/***/ 4218:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AdditionalInfo_1 = __webpack_require__(4219);
var AdditionalInfoNames = {
    /**
 * Event sharing from calendar
 */
    EventSharingFromCalendar: AdditionalInfo_1.default.EventSharingFromCalendar,
    /**
 * Event sharing from mail
 */
    EventSharingFromMail: AdditionalInfo_1.default.EventSharingFromMail,
    /**
 * Email reminder
 */
    EmailReminder: AdditionalInfo_1.default.EmailReminder,
};
exports.default = AdditionalInfoNames;
//# sourceMappingURL=AdditionalInfoNames.js.map

/***/ }),

/***/ 4219:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AdditionalInfo;
(function (AdditionalInfo) {
    /**
 * Event sharing from calendar
 */
    AdditionalInfo[AdditionalInfo["EventSharingFromCalendar"] = 0] = "EventSharingFromCalendar";
    /**
 * Event sharing from mail
 */
    AdditionalInfo[AdditionalInfo["EventSharingFromMail"] = 1] = "EventSharingFromMail";
    /**
 * Email reminder
 */
    AdditionalInfo[AdditionalInfo["EmailReminder"] = 2] = "EmailReminder";
})(AdditionalInfo || (AdditionalInfo = {}));
exports.default = AdditionalInfo;
//# sourceMappingURL=AdditionalInfo.js.map

/***/ }),

/***/ 4220:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var assignOrganization_1 = __webpack_require__(4221);
var assignAddress_1 = __webpack_require__(3582);
var EntityType_1 = __webpack_require__(2734);
/**
 * parse data for ParselDelivery Entity
 */
function setParcelDeliveryEntityData(entity, parcelEntity) {
    if (entity && parcelEntity) {
        if (isParcelDeliveryValid(parcelEntity)) {
            var partOfOrder = parcelEntity.partOfOrder;
            var seller = parcelEntity.partOfOrder.seller;
            // assign the parcel Delivery data
            var newParcelEntity = tslib_1.__assign({}, entity, {
                entityType: EntityType_1.default.ParcelDelivery,
                trackingUrl: parcelEntity.trackingUrl,
                trackingNumber: parcelEntity.trackingNumber,
                expectedArrivalFrom: parcelEntity.expectedArrivalFrom,
                expectedArrivalUntil: parcelEntity.expectedArrivalUntil,
                expectedArrivalUntilUtc: parcelEntity['expectedArrivalUntil/utc'],
                deliveryAddress: {},
                partOfOrder: {
                    orderNumber: partOfOrder.orderNumber,
                    orderStatus: partOfOrder.orderStatus,
                    seller: {
                        name: seller.name,
                        telephone: seller.telephone,
                    },
                },
            });
            // assign provider
            newParcelEntity.provider = assignOrganization_1.default({}, parcelEntity.provider);
            // assign address
            newParcelEntity.deliveryAddress = assignAddress_1.default({}, parcelEntity.deliveryAddress);
            // assign item details
            var orderedItem = parcelEntity.partOfOrder.orderedItem;
            if (orderedItem) {
                newParcelEntity.partOfOrder = tslib_1.__assign({}, newParcelEntity.partOfOrder, {
                    orderedItem: {
                        url: orderedItem.url,
                        name: orderedItem.name,
                        sku: orderedItem.sku,
                        description: orderedItem.description,
                        brand: orderedItem.brand,
                        color: orderedItem.color,
                    },
                });
            }
            return newParcelEntity;
        }
    }
    return null;
}
exports.default = setParcelDeliveryEntityData;
function isParcelDeliveryValid(parcelEntity) {
    if (parcelEntity) {
        var partOfOrder = parcelEntity.partOfOrder;
        if (partOfOrder &&
            partOfOrder.seller &&
            partOfOrder.seller.name &&
            (parcelEntity.expectedArrivalFrom || parcelEntity.expectedArrivalUntil) &&
            parcelEntity.deliveryAddress) {
            return true;
        }
    }
    return false;
}
exports.isParcelDeliveryValid = isParcelDeliveryValid;
//# sourceMappingURL=setParcelDeliveryEntityData.js.map

/***/ }),

/***/ 4221:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function assignOrganization(basicEntity, providerBlob) {
    if (providerBlob) {
        return tslib_1.__assign({ basicEntity: basicEntity }, {
            name: providerBlob.name,
            telephone: providerBlob.telephone,
        });
    }
    else {
        return null;
    }
}
exports.default = assignOrganization;
//# sourceMappingURL=assignOrganization.js.map

/***/ }),

/***/ 4222:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var assignAirport_1 = __webpack_require__(4223);
var EntityType_1 = __webpack_require__(2734);
/**
 * parse data for FlightReservation Entity
 */
function setFlightEntityData(entity, flightEntity) {
    if (entity && flightEntity) {
        var newFlightEntity = void 0;
        // assign the flight data
        if (isFlightValid(flightEntity)) {
            var reservationFor = flightEntity.reservationFor;
            var airline = reservationFor.provider;
            newFlightEntity = tslib_1.__assign({}, entity, {
                entityType: EntityType_1.default.FlightReservation,
                reservationId: flightEntity.reservationId,
                checkinUrl: flightEntity.potentialAction
                    ? flightEntity.potentialAction.target
                    : null,
                departureTime: reservationFor.departureTime,
                departureTimeUTC: reservationFor['departureTime/utc'],
                departureTerminal: reservationFor.departureTerminal,
                departureGate: reservationFor.departureGate,
                departureTimeZone: reservationFor['departureTime/windowsTimeZoneName'],
                arrivalTime: reservationFor.arrivalTime,
                arrivalTimeUTC: reservationFor['arrivalTime/utc'],
                arrivalTerminal: reservationFor.arrivalTerminal,
                arrivalGate: reservationFor.arrivalGate,
                arrivalTimeZone: reservationFor['arrivalTime/windowsTimeZoneName'],
                flightNumber: reservationFor.flightNumber,
                airline: {
                    name: airline.name,
                    iataCode: airline.iataCode,
                },
            });
            // assign data for departure airport
            newFlightEntity = tslib_1.__assign({}, newFlightEntity, {
                departureAirport: assignAirport_1.default(newFlightEntity, reservationFor.departureAirport),
            });
            // assign data for arrival airport
            newFlightEntity = tslib_1.__assign({}, newFlightEntity, {
                arrivalAirport: assignAirport_1.default(newFlightEntity, reservationFor.arrivalAirport),
            });
            return newFlightEntity;
        }
    }
    return null;
}
exports.default = setFlightEntityData;
function isFlightValid(flightEntity) {
    if (flightEntity && flightEntity.reservationFor && flightEntity.reservationFor.provider) {
        var reservationFor = flightEntity.reservationFor;
        var provider = flightEntity.reservationFor.provider;
        // validate Airline
        if (provider.iataCode &&
            provider.name &&
            // validate Airports
            isAirportValid(reservationFor.arrivalAirport) &&
            isAirportValid(reservationFor.departureAirport) &&
            // validate require flight details
            reservationFor.flightNumber &&
            reservationFor.arrivalTime &&
            reservationFor.departureTime &&
            reservationFor.arrivalTime) {
            return true;
        }
    }
    return false;
}
exports.isFlightValid = isFlightValid;
function isAirportValid(airportBlob) {
    if (airportBlob &&
        airportBlob.iataCode &&
        (airportBlob['address/commonCity'] ||
            (airportBlob.address.addressLocality && airportBlob.address))) {
        return true;
    }
    return false;
}
exports.isAirportValid = isAirportValid;
//# sourceMappingURL=setFlightEntityData.js.map

/***/ }),

/***/ 4223:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var assignPlace_1 = __webpack_require__(3275);
function assignAirport(basicEntity, airportBlob) {
    basicEntity = tslib_1.__assign({}, basicEntity, {
        iataCode: airportBlob.iataCode,
    });
    basicEntity = assignPlace_1.default(basicEntity, airportBlob);
    return basicEntity;
}
exports.default = assignAirport;
//# sourceMappingURL=assignAirport.js.map

/***/ }),

/***/ 4224:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var assignCar_1 = __webpack_require__(4225);
var assignPlace_1 = __webpack_require__(3275);
var EntityType_1 = __webpack_require__(2734);
/**
 * parse data for Rental Car Entity
 */
function setRentalCarEntityData(entity, rentalCarEntity) {
    if (entity && rentalCarEntity && isRentalCarEntityValid(rentalCarEntity)) {
        var newRentalCarEntity = tslib_1.__assign({}, entity, {
            entityType: EntityType_1.default.RentalCarReservation,
            reservationId: rentalCarEntity.reservationId,
            pickupTime: rentalCarEntity.pickupTime,
            pickupTimeUTC: rentalCarEntity['pickupTime/utc'],
            dropoffTime: rentalCarEntity.dropoffTime,
            dropoffTimeUTC: rentalCarEntity['dropoffTime/utc'],
            car: {},
            dropoffLocation: {},
            pickupLocation: {},
        });
        // assign car details
        newRentalCarEntity.car = assignCar_1.default(newRentalCarEntity, rentalCarEntity.reservationFor);
        // assign drop off location details
        newRentalCarEntity.dropoffLocation = assignPlace_1.default(newRentalCarEntity, rentalCarEntity.dropoffLocation);
        // assign pick off location details
        newRentalCarEntity.pickupLocation = assignPlace_1.default(newRentalCarEntity, rentalCarEntity.pickupLocation);
        // assign provider details
        if (rentalCarEntity.provider) {
            newRentalCarEntity.provider = tslib_1.__assign({}, rentalCarEntity.provider);
        }
        return newRentalCarEntity;
    }
    return null;
}
exports.default = setRentalCarEntityData;
function isRentalCarEntityValid(rentalCarEntity) {
    if (rentalCarEntity.reservationFor &&
        rentalCarEntity.dropoffLocation &&
        rentalCarEntity.pickupLocation &&
        rentalCarEntity.pickupTime &&
        rentalCarEntity.dropoffTime) {
        return true;
    }
    return false;
}
//# sourceMappingURL=setRentalCarEntityData.js.map

/***/ }),

/***/ 4225:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function assignCar(basicEntity, carBlob) {
    var newEntity = tslib_1.__assign({}, basicEntity, {
        name: carBlob.name,
        description: carBlob.addressLocality,
        model: carBlob.model,
    });
    if (carBlob.brand) {
        newEntity = tslib_1.__assign({}, newEntity, {
            brand: tslib_1.__assign({}, carBlob.brand),
        });
    }
    return newEntity;
}
exports.default = assignCar;
//# sourceMappingURL=assignCar.js.map

/***/ }),

/***/ 4226:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
/**
 * parse data for Reservation Entity
 */
function setReservationEntityData(entityItem, entityBlob, dontRequireId) {
    if (entityItem && entityBlob) {
        // get the correct ID
        var entityReservationId = void 0;
        if (entityBlob.reservationId) {
            entityReservationId = entityBlob.reservationId;
        }
        else if (entityBlob.reservationNumber) {
            entityReservationId = entityBlob.reservationNumber;
        }
        else if (!dontRequireId) {
            // don't create entity when no Reservation Id / Number and dontRequireId is false
            return null;
        }
        // assign reservation data
        var reservationEntity = tslib_1.__assign({}, entityItem, {
            reservationId: entityReservationId,
            reservationStatus: entityBlob.reservationStatus,
            modifyReservationUrl: entityBlob.modifyReservationUrl,
            underName: {
                name: entityBlob.underName ? entityBlob.underName.name : null,
            },
        });
        var reservedTicket = entityBlob.reservedTicket;
        if (reservedTicket) {
            var seat = reservedTicket.seat;
            reservationEntity = tslib_1.__assign({}, reservationEntity, {
                reservedTicket: {
                    ticketNumber: reservedTicket.ticketNumber,
                    seat: {
                        row: seat ? seat.row : null,
                        seatNumber: seat ? seat.seatNumber : null,
                    },
                },
            });
        }
        return reservationEntity;
    }
    return null;
}
exports.default = setReservationEntityData;
//# sourceMappingURL=SetReservationEntityData.js.map

/***/ }),

/***/ 4227:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var EntityType_1 = __webpack_require__(2734);
var assignAddress_1 = __webpack_require__(3582);
/**
 * parse data for Lodging Entity
 */
function setLodgingReservationEntityData(entity, lodgingEntity) {
    if (entity && lodgingEntity) {
        if (isLodgingReservationValid(lodgingEntity)) {
            var newLodgingEntity = tslib_1.__assign({}, entity, {
                reservationId: lodgingEntity.reservationId,
                entityType: EntityType_1.default.LodgingReservation,
                checkinTime: lodgingEntity.checkinTime,
                checkoutTime: lodgingEntity.checkoutTime,
                checkinTimeUTC: lodgingEntity['checkinTime/utc'],
                checkoutTimeUTC: lodgingEntity['checkoutTime/utc'],
                lodgingBusiness: {},
            });
            // assign address
            newLodgingEntity.lodgingBusiness.address = assignAddress_1.default({}, lodgingEntity.reservationFor.address);
            newLodgingEntity.lodgingBusiness.name = lodgingEntity.reservationFor.name;
            return newLodgingEntity;
        }
    }
    return null;
}
exports.default = setLodgingReservationEntityData;
function isLodgingReservationValid(lodgingEntity) {
    if (lodgingEntity) {
        if (lodgingEntity.checkinTime &&
            lodgingEntity.checkoutTime &&
            lodgingEntity.reservationFor) {
            return true;
        }
    }
    return false;
}
exports.isLodgingReservationValid = isLodgingReservationValid;
//# sourceMappingURL=setLodgingReservationEntityData.js.map

/***/ }),

/***/ 4228:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var EntityType_1 = __webpack_require__(2734);
var assignPlace_1 = __webpack_require__(3275);
/**
 * parse data for Food Reservation
 */
function setEventEntityData(entity, eventEntity) {
    if (entity && eventEntity) {
        var reservationfor = eventEntity.reservationFor;
        var newEventEntity = void 0;
        if (reservationfor) {
            newEventEntity = tslib_1.__assign({}, entity, {
                entityType: EntityType_1.default.EventReservation,
                reservationId: eventEntity.reservationId,
                name: reservationfor.name,
                startDate: reservationfor.startDate,
                startDateUtc: reservationfor['startDate/utc'],
                endDate: reservationfor.endDate,
                endDateUtc: reservationfor['endDate/utc'],
                location: {},
            });
            newEventEntity.numSeats = Number(eventEntity['numSeats/excludingOrganizer']);
            // assign event location details
            newEventEntity.location = assignPlace_1.default(newEventEntity, reservationfor.location);
            return newEventEntity;
        }
    }
    return null;
}
exports.default = setEventEntityData;
//# sourceMappingURL=setEventEntityData.js.map

/***/ }),

/***/ 4229:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var EntityType_1 = __webpack_require__(2734);
/**
 * parse data for Food Reservation
 */
function setDiningEntityData(entity, diningEntity) {
    if (entity && diningEntity) {
        if (isDiningEntityValid(diningEntity)) {
            var newFoodReservationEntity = tslib_1.__assign({}, entity, {
                reservationId: diningEntity.reservationId,
                entityType: EntityType_1.default.FoodReservation,
                startTime: diningEntity.startTime,
                startTimeUTC: diningEntity['startTime/utc'],
                partySize: Number(diningEntity.partySize),
            });
            return newFoodReservationEntity;
        }
    }
    return null;
}
exports.default = setDiningEntityData;
function isDiningEntityValid(diningEntity) {
    if (diningEntity && diningEntity.startTime) {
        return true;
    }
    return false;
}
exports.isDiningEntityValid = isDiningEntityValid;
//# sourceMappingURL=setDiningEntityData.js.map

/***/ }),

/***/ 4230:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ActivityTypeNames_1 = __webpack_require__(3274);
/**
 *  This function return the entities from the Txp Json blob.
 * filter the entities that are *not* TxpActivity type and get the entities array.
 */
function foundEntities(txpParsedBlob) {
    var entities;
    if (txpParsedBlob) {
        var notActivities = txpParsedBlob
            .filter(function (txpData) { return txpData.type != ActivityTypeNames_1.default.TxpActivity; })
            .map(function (entity) { return entity.entities; });
        entities = [].concat.apply([], notActivities);
    }
    return entities.length != 0 ? entities : null;
}
exports.default = foundEntities;
//# sourceMappingURL=foundEntities.js.map

/***/ }),

/***/ 4231:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ActivityTypeNames_1 = __webpack_require__(3274);
/**
 * This function return the activities from the Txp Json blob
 * filter the entities that are TxpActivity type and get the activities array
 */
function foundActivities(txpParsedBlob) {
    var activities;
    if (txpParsedBlob) {
        activities = txpParsedBlob
            .filter(function (txpData) { return txpData.type == ActivityTypeNames_1.default.TxpActivity; })
            .map(function (entity) { return entity.entities; });
    }
    return activities[0].length != 0 ? activities[0] : null;
}
exports.default = foundActivities;
//# sourceMappingURL=foundActivities.js.map

/***/ }),

/***/ 4232:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var owa_txp_strings_1 = __webpack_require__(2703);
var React = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(11);
var Button_1 = __webpack_require__(62);
var styles = __webpack_require__(2748);
var classNames = __webpack_require__(343);
var UserVoice = /** @class */ (function (_super) {
    tslib_1.__extends(UserVoice, _super);
    function UserVoice(props) {
        var _this = _super.call(this, props) || this;
        _this.onUseful = function () {
            _this.setState({
                buttonSet: 1 /* sendFeedback */,
            });
            _this.props.OnSentimentFeedbackClicked(true);
        };
        _this.onNotUseful = function () {
            _this.setState({
                buttonSet: 2 /* reportIssue */,
            });
            _this.props.OnSentimentFeedbackClicked(false);
        };
        _this.state = {
            buttonSet: 0 /* defaultState */,
        };
        return _this;
    }
    UserVoice.prototype.render = function () {
        var _this = this;
        var _a = this.props, onSendFeedback = _a.onSendFeedback, onReportIssue = _a.onReportIssue;
        return (React.createElement("div", { className: styles.userVoiceContainer },
            React.createElement("label", { className: styles.smallText }, owa_txp_strings_1.default.foundNewEventsText),
            this.state.buttonSet == 0 /* defaultState */ &&
                React.createElement("div", { className: styles.userVoiceButtonsContainer },
                    React.createElement(Button_1.Button, { buttonType: Button_1.ButtonType.normal, className: classNames(styles.userVoiceButton), onClick: function () { return _this.onUseful(); } }, owa_txp_strings_1.default.feedbackUsefulText),
                    React.createElement("div", { className: styles.smallText }, "|"),
                    React.createElement(Button_1.Button, { buttonType: Button_1.ButtonType.normal, className: classNames(styles.userVoiceButton), onClick: function () { return _this.onNotUseful(); } }, owa_txp_strings_1.default.feedbackNotUsefulText)),
            this.state.buttonSet == 1 /* sendFeedback */ &&
                React.createElement(Button_1.Button, { buttonType: Button_1.ButtonType.normal, className: classNames(styles.userVoiceButton), onClick: function () { return onSendFeedback(); } }, owa_txp_strings_1.default.userVoiceFeedbackText),
            this.state.buttonSet == 2 /* reportIssue */ &&
                React.createElement(Button_1.Button, { buttonType: Button_1.ButtonType.normal, className: classNames(styles.userVoiceButton), onClick: function () { return onReportIssue(); } }, owa_txp_strings_1.default.reportAnIssueText)));
    };
    UserVoice = tslib_1.__decorate([
        mobx_react_1.observer
    ], UserVoice);
    return UserVoice;
}(React.Component));
exports.default = UserVoice;
//# sourceMappingURL=UserVoice.js.map

/***/ }),

/***/ 4233:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_uservoice_1 = __webpack_require__(2991);
var owa_txp_strings_1 = __webpack_require__(2703);
var getCustomTags_1 = __webpack_require__(4248);
var TITLE = 'New Ticket from Outlook.com';
var UserVoiceForumUrl = 'https://outlook.uservoice.com/forums/601444-outlook-com-beta/category/322831-events-from-email';
function sendFeedback() {
    window.open(UserVoiceForumUrl, '_blank');
}
exports.sendFeedback = sendFeedback;
function reportIssue(userVoiceData, internetMessageId, itemId, blurbElement) {
    owa_uservoice_1.showUserVoiceSuggestionDialog({
        title: TITLE,
        feedbackType: 1 /* TailoredExperiences */,
        ewsId: itemId,
        header: owa_txp_strings_1.default.negativeTicketPopUpHeaderText,
        blurbElement: blurbElement,
        customTags: getCustomTags_1.default("Support" /* Support */, internetMessageId, userVoiceData),
    });
}
exports.reportIssue = reportIssue;
function sendNegativeFeedback(userVoiceData, internetMessageId) {
    owa_uservoice_1.showUserVoiceSuggestionDialog({
        title: TITLE,
        feedbackType: 1 /* TailoredExperiences */,
        header: owa_txp_strings_1.default.positiveTicketPopUpHeaderText,
        blurb: owa_txp_strings_1.default.positiveTicketPopUpBodyText,
        customTags: getCustomTags_1.default("General Negative" /* Negative */, internetMessageId, userVoiceData),
    });
}
exports.sendNegativeFeedback = sendNegativeFeedback;
//# sourceMappingURL=userVoiceReports.js.map

/***/ }),

/***/ 4248:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TxpConstants_1 = __webpack_require__(161);
function getCustomTags(typeValues, internetMessageId, userVoiceData) {
    return _a = {
            Type: typeValues
        },
        _a[TxpConstants_1.TEAM] = "Tailored Experiences Team" /* TailoredExperiencesTeam */,
        _a.internetMessageId = internetMessageId,
        _a.FeedbackLocationName = TxpConstants_1.LOCATION_NAME,
        _a.TXP_EntityTrustLevel = userVoiceData.TXP_EntityTrustLevel,
        _a.TXP_EntityNamesMap = userVoiceData.TXP_EntityNamesMap,
        _a.TXP_EntityOrActivityName = userVoiceData.TXP_EntityOrActivityName,
        _a.TXP_EntityExtractionSource = userVoiceData.TXP_EntityExtractionSource,
        // we are not yet supporting Status of the TxP processing and errors #20289
        _a.TXP_EntityStatus = null,
        _a.TXP_ProcessingError = null,
        _a;
    var _a;
}
exports.default = getCustomTags;
//# sourceMappingURL=getCustomTags.js.map

/***/ }),

/***/ 4249:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getActivityNames_1 = __webpack_require__(4250);
var getFeedbackData_1 = __webpack_require__(4251);
function populateUserVoiceData(txpObject) {
    var activitiesNames = getActivityNames_1.default(txpObject);
    var entityUserVoiceData = getFeedbackData_1.default(txpObject);
    return {
        TXP_EntityNamesMap: entityUserVoiceData.TXP_EntityNamesMap,
        TXP_EntityOrActivityName: activitiesNames,
        TXP_EntityExtractionSource: entityUserVoiceData.TXP_EntityExtractionSource,
        TXP_EntityTrustLevel: entityUserVoiceData.TXP_EntityTrustLevel,
    };
}
exports.default = populateUserVoiceData;
//# sourceMappingURL=populateUserVoiceData.js.map

/***/ }),

/***/ 4250:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function getActivityNames(txpObject) {
    if (txpObject && txpObject.txpActivities) {
        return txpObject.txpActivities.map(function (activity) { return activity.activityName; }).join(',');
    }
    else {
        return null;
    }
}
exports.default = getActivityNames;
//# sourceMappingURL=getActivityNames.js.map

/***/ }),

/***/ 4251:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function getFeedbackData(txpObject) {
    var txpEntities = txpObject.txpEntities;
    var entityTrustLevel = Object.keys(txpEntities)
        .map(function (key) { return txpEntities[key].trustScore; })
        .join(',');
    var entityExtractionSource = Object.keys(txpEntities)
        .map(function (key) { return txpEntities[key].source; })
        .join(',');
    var entitiesNamesMap = Object.keys(txpEntities)
        .map(function (key) { return txpEntities[key].entityName; })
        .join(',');
    return {
        TXP_EntityTrustLevel: entityTrustLevel,
        TXP_EntityExtractionSource: entityExtractionSource,
        TXP_EntityNamesMap: entitiesNamesMap,
    };
}
exports.default = getFeedbackData;
//# sourceMappingURL=getFeedbackData.js.map

/***/ }),

/***/ 4252:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DP_NAME = 'TXP_UserVoice_Mail';
/**
 * populate the data for the feedback dataPoint telemetry
 */
function populateFeedbackDataPointData(entityNamesMap, feedBackType, source) {
    return {
        entityNamesMap: entityNamesMap,
        feedbackActionType: feedBackType,
        source: source,
        origin: null,
        dataPointName: DP_NAME,
    };
}
exports.default = populateFeedbackDataPointData;
//# sourceMappingURL=populateFeedbackDataPointData.js.map

/***/ }),

/***/ 4253:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var Txp_1 = __webpack_require__(3265);
var React = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(11);
var ConvertTxpBlobToObject_1 = __webpack_require__(3581);
var areAnyTXPEntitiesSupported_1 = __webpack_require__(713);
var Spinner_1 = __webpack_require__(670);
var styles = __webpack_require__(2748);
var TxpPeekWrapper = /** @class */ (function (_super) {
    tslib_1.__extends(TxpPeekWrapper, _super);
    function TxpPeekWrapper(props) {
        var _this = _super.call(this, props) || this;
        if (areAnyTXPEntitiesSupported_1.default(_this.props.entityNamesMap) && props.txpBlob) {
            _this.txpObject = ConvertTxpBlobToObject_1.default(props.txpBlob);
        }
        return _this;
    }
    TxpPeekWrapper.prototype.componentWillReceiveProps = function (newProps) {
        if (newProps.txpBlob !== this.props.txpBlob) {
            this.txpObject = ConvertTxpBlobToObject_1.default(newProps.txpBlob);
        }
    };
    TxpPeekWrapper.prototype.render = function () {
        var _a = this.props, source = _a.source, txpLocation = _a.txpLocation, onActionButtonClicked = _a.onActionButtonClicked;
        var showEnhancedLocation = txpLocation ? true : false;
        var txpStyle = {
            txpColor: this.props.colorSchema.calPrimary,
            cardSummaryContainer: styles.txpPeekCardSummary,
            cardDetails: styles.peekDetails,
            cardSummaryLines: styles.PeekCardSummaryLines,
            airPlaneIcon: "AirplaneSolid" /* AirplaneSolid */,
            planeStyle: styles.peekPlane,
            summaryLabel: styles.summaryLabelPeek,
            detailsLabel: styles.detailsLabelPeek,
        };
        if (this.txpObject) {
            return (React.createElement("div", null,
                React.createElement(Txp_1.default, { txpObject: this.txpObject, source: source, txpStyle: txpStyle, txpLocation: txpLocation, showEnhancedLocation: showEnhancedLocation, onActionButtonClicked: onActionButtonClicked })));
        }
        else {
            return React.createElement(Spinner_1.Spinner, { className: styles.spinner, size: Spinner_1.SpinnerSize.large });
        }
    };
    TxpPeekWrapper = tslib_1.__decorate([
        mobx_react_1.observer
    ], TxpPeekWrapper);
    return TxpPeekWrapper;
}(React.Component));
exports.default = TxpPeekWrapper;
//# sourceMappingURL=TxpPeekWrapper.js.map

/***/ }),

/***/ 585:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function s4() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
}
function getGuid() {
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}
exports.getGuid = getGuid;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 629:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SpinnerSize;
(function (SpinnerSize) {
    /**
     * 12px Spinner diameter
     */
    SpinnerSize[SpinnerSize["xSmall"] = 0] = "xSmall";
    /**
     * 16px Spinner diameter
     */
    SpinnerSize[SpinnerSize["small"] = 1] = "small";
    /**
     * 20px Spinner diameter
     */
    SpinnerSize[SpinnerSize["medium"] = 2] = "medium";
    /**
     * 28px Spinner diameter
     */
    SpinnerSize[SpinnerSize["large"] = 3] = "large";
})(SpinnerSize = exports.SpinnerSize || (exports.SpinnerSize = {}));
/**
 * Deprecated at v2.0.0, use 'SpinnerSize' instead.
 * @deprecated
 */
var SpinnerType;
(function (SpinnerType) {
    /**
     * Deprecated and will be removed at >= 2.0.0. Use SpinnerSize.medium instead.
     */
    SpinnerType[SpinnerType["normal"] = 0] = "normal";
    /**
     * Deprecated and will be removed at >= 2.0.0. Use SpinnerSize.large instead.
     */
    SpinnerType[SpinnerType["large"] = 1] = "large";
})(SpinnerType = exports.SpinnerType || (exports.SpinnerType = {}));
//# sourceMappingURL=Spinner.types.js.map

/***/ }),

/***/ 670:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(1573), exports);
//# sourceMappingURL=Spinner.js.map

/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ariaRoles_1 = __webpack_require__(1594);
exports.AriaRoles = ariaRoles_1.AriaRoles;
var generateNewId_1 = __webpack_require__(1595);
exports.generateNewId = generateNewId_1.generateNewId;
var generateDomPropertiesForAria_1 = __webpack_require__(1596);
exports.generateDomPropertiesForAria = generateDomPropertiesForAria_1.generateDomPropertiesForAria;
//# sourceMappingURL=index.js.map

/***/ })

});


// WEBPACK FOOTER //
// owa.Txp.js